(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["techrevive-a-la-carte-upgrade-builder-v3"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ROOT_SELECTOR = '[data-tr-upgrade-builder]';
    const BENCH_PROPERTY = 'properties[bench fee agreement]';
    const BENCH_COPY = 'I understand that if my controller cannot be upgraded because of severe physical or liquid damage, TechRevive will retain $25 of my upfront payment as a non-refundable diagnostic bench fee and return my controller to me.';
    const CONTROLLER_CONFIG = {
      ps5: {
        label: 'PS5 DualSense',
        aliases: ['PS5 DUALSENSE', 'DUALSENSE 5', 'DUALSENSE', 'PLAYSTATION 5']
      },
      xbox: {
        label: 'Xbox Series X/S',
        aliases: ['XBOX SERIES X/S', 'XBOX SERIES XS', 'XBOX SERIES']
      },
      switch: {
        label: 'Nintendo Switch Pro',
        aliases: ['NINTENDO SWITCH PRO', 'SWITCH PRO']
      }
    };
    const GROUP_CONFIG = {
      joysticks: {
        sourceValue: 'Joystick Upgrade',
        sourceLabel: 'Joystick Options'
      },
      mouseclick: {
        sourceValue: 'Mouse-Click Triggers/Buttons',
        sourceLabel: 'Mouse-Click Options'
      },
      paddles: {
        sourceValue: 'Back Paddles/Buttons',
        sourceLabel: 'Back Paddles Options'
      }
    };

    function dispatchValueEvents(element) {
      element.dispatchEvent(new Event('input', { bubbles: true }));
      element.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function parseAddedPrice(label) {
      const match = String(label || '').match(/\$\s*([0-9]+(?:\.[0-9]{1,2})?)/);
      return match ? Math.round(Number(match[1]) * 100) : 0;
    }

    function formatMoney(cents, currency) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: currency || 'USD'
        }).format((Number(cents) || 0) / 100);
      } catch (error) {
        return `$${((Number(cents) || 0) / 100).toFixed(2)}`;
      }
    }

    function splitChoice(value) {
      const match = String(value || '').match(/^(.*?)\s+-\s+(\$[0-9,.]+)$/);
      return match ? { name: match[1], price: match[2] } : { name: String(value || ''), price: '' };
    }

    function normalizedMatch(value) {
      return String(value || '').trim().toUpperCase().replace(/[^A-Z0-9]+/g, ' ').trim();
    }

    function controllerKeyForValue(value) {
      const normalized = normalizedMatch(value);
      return Object.keys(CONTROLLER_CONFIG).find((key) => {
        const entry = CONTROLLER_CONFIG[key];
        return [entry.label, ...entry.aliases].some((alias) => normalizedMatch(alias) === normalized);
      }) || '';
    }

    function sourceControllerOption(select, key) {
      const entry = CONTROLLER_CONFIG[key];
      if (!select || !entry) return null;
      return [...select.options].find((option) => {
        const normalized = normalizedMatch(option.value || option.textContent);
        return [entry.label, ...entry.aliases].some((alias) => normalizedMatch(alias) === normalized);
      }) || null;
    }

    function initUpgradeBuilder(root) {
      if (!root || root.dataset.trInitialized === 'true') return;

      const configElement = root.querySelector('[data-tr-upgrade-config]');
      if (!configElement) return;

      let config;
      try {
        config = JSON.parse(configElement.textContent);
      } catch (error) {
        return;
      }

      const submit = root.querySelector('[data-tr-submit]');
      const submitLabel = root.querySelector('[data-tr-submit-label]');
      const status = root.querySelector('[data-tr-status]');
      const total = root.querySelector('[data-tr-total]');
      const details = root.querySelector('[data-tr-details]');
      const agreement = root.querySelector('[data-tr-agreement]');
      const characterCount = root.querySelector('[data-tr-character-count]');
      const kitPrice = root.querySelector('[data-tr-kit-price]');
      const announcer = root.querySelector('[data-tr-announcer]');
      const summaryDetails = root.querySelector('[data-tr-summary-details]');
      const mobileSummaryQuery = window.matchMedia('(max-width: 680px)');

      const state = {
        controller: '',
        controllerKey: '',
        controllerLabel: '',
        sendIn: '',
        sendInLabel: '',
        agreement: false,
        groups: {
          joysticks: { active: false, value: '' },
          mouseclick: { active: false, value: '' },
          paddles: { active: false, value: '' }
        }
      };

      let source = null;
      let priceObserver = null;
      let sourceReady = false;
      let submitting = false;
      const groupBusy = {};

      function setStatus(message) {
        if (status) status.textContent = message || '';
      }

      function announce(message) {
        if (!announcer || !message) return;
        announcer.textContent = '';
        window.setTimeout(() => { announcer.textContent = message; }, 20);
      }

      function canonicalChoiceName(key, rawName) {
        const normalized = normalizedMatch(rawName);

        if (key === 'joysticks') {
          if (normalized.includes('TMR')) return 'TMR Joysticks';
          if (normalized.includes('HALL')) return 'Hall Effect Joysticks';
        }

        if (key === 'mouseclick') {
          if (normalized.includes('EVERYTHING') || normalized.includes('COMPLETE') || normalized.includes('FULL')) {
            return 'Complete Mouse Click Control Set';
          }
          if (normalized.includes('TRIGGER') || normalized.includes('BUMPER')) {
            return 'Mouse Click Triggers and Bumpers';
          }
          if (normalized.includes('BUTTON') || normalized.includes('FACE') || normalized.includes('D PAD')) {
            return 'Mouse Click Face Buttons and D Pad';
          }
        }

        if (key === 'paddles') {
          if (state.controllerKey === 'ps5') return 'Four Rear Paddles';
          if (state.controllerKey === 'xbox' || state.controllerKey === 'switch') return 'Four Rear Buttons';
          return 'Rear Inputs';
        }

        return rawName;
      }

      function displayChoice(key, value) {
        const parts = splitChoice(value);
        const name = canonicalChoiceName(key, parts.name);
        return {
          name,
          price: parts.price,
          full: parts.price ? `${name} - ${parts.price}` : name
        };
      }

      function setSummary(key, value) {
        const target = root.querySelector(`[data-tr-summary="${key}"]`);
        if (target) target.textContent = value;
      }

      function showSummaryRow(key, show) {
        const row = root.querySelector(`[data-tr-summary-row="${key}"]`);
        if (row) row.hidden = !show;
      }

      function syncSummaryDisclosure() {
        if (!summaryDetails) return;
        summaryDetails.open = !mobileSummaryQuery.matches;
      }

      function setActive(group, value) {
        root.querySelectorAll(`[data-tr-choice="${group}"]`).forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.value === value));
        });
      }

      function clearError(group) {
        const wrapper = root.querySelector(`[data-tr-group="${group}"]`);
        const error = root.querySelector(`[data-tr-error="${group}"]`);
        wrapper?.removeAttribute('aria-invalid');
        if (error) error.textContent = '';
      }

      function showError(group, message) {
        const wrapper = root.querySelector(`[data-tr-group="${group}"]`);
        const error = root.querySelector(`[data-tr-error="${group}"]`);
        wrapper?.setAttribute('aria-invalid', 'true');
        if (error) error.textContent = message;
      }

      function sourceRadios(key) {
        return source?.groups[key]?.block
          ? [...source.groups[key].block.querySelectorAll('input[type="radio"]')]
          : [];
      }

      function selectedRadio(key) {
        return sourceRadios(key).find((input) => input.checked && !input.disabled) || null;
      }

      function fallbackTotal() {
        let cents = Number(config.basePrice) || 0;
        Object.keys(state.groups).forEach((key) => {
          if (state.groups[key].active) cents += parseAddedPrice(state.groups[key].value);
        });
        if (/MAIL-IN KIT/i.test(state.sendIn)) cents += parseAddedPrice(state.sendIn);
        return formatMoney(cents, config.currency || root.dataset.currency);
      }

      function activeUpgradeKeys() {
        return Object.keys(state.groups).filter((key) => state.groups[key].active);
      }

      function missingRequirements() {
        const missing = [];
        const activeGroups = activeUpgradeKeys();

        if (!state.controllerKey) missing.push('controller');
        if (!activeGroups.length) {
          missing.push('at least one upgrade');
        } else if (activeGroups.some((key) => !state.groups[key].value)) {
          missing.push('an option in each selected upgrade');
        }
        if (!state.sendIn) missing.push('mail in method');
        if (!state.agreement) missing.push('bench fee agreement');
        return missing;
      }

      function updateSubmitState() {
        if (!submit) return;

        const missing = missingRequirements();
        const ready = sourceReady && !submitting && missing.length === 0;
        submit.disabled = !ready;
        submit.setAttribute('aria-disabled', String(!ready));

        if (submitting) return;
        if (!sourceReady) {
          setStatus('Loading upgrade options...');
        } else if (missing.length) {
          setStatus(`Still needed: ${missing.join(', ')}.`);
        } else {
          setStatus('Configuration complete. Ready to add to cart.');
        }
      }

      function updatePrice() {
        if (!total) return;
        const hasUpgrade = activeUpgradeKeys().some((key) => state.groups[key].value);
        if (!hasUpgrade) {
          total.textContent = 'Select an upgrade';
          total.dataset.empty = 'true';
          return;
        }

        const appPrice = source?.price?.textContent?.trim();
        total.textContent = appPrice || fallbackTotal();
        total.dataset.empty = 'false';
      }

      function updateSummary() {
        setSummary('controller', state.controllerLabel || 'Select a controller');
        Object.keys(state.groups).forEach((key) => {
          const value = state.groups[key].active && state.groups[key].value
            ? displayChoice(key, state.groups[key].value).full
            : 'Not selected';
          setSummary(key, value);
          showSummaryRow(key, state.groups[key].active);
        });
        setSummary('send-in', state.sendInLabel || 'Select a method');
        updatePrice();
        updateSubmitState();
      }

      function renderOptionButtons(key) {
        const list = root.querySelector(`[data-tr-option-list="${key}"]`);
        if (!list) return;

        const values = sourceRadios(key).map((radio) => radio.value).filter(Boolean);
        const existingValues = [...list.querySelectorAll('[data-tr-option-value]')].map((button) => button.dataset.trOptionValue);
        const controllerChanged = key === 'paddles' && list.dataset.trControllerKey !== state.controllerKey;
        const needsRebuild = controllerChanged || values.length !== existingValues.length || values.some((value, index) => value !== existingValues[index]);

        if (needsRebuild) {
          list.replaceChildren();
          values.forEach((value) => {
            const parts = displayChoice(key, value);
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'tr-upgrade-builder__option';
            button.dataset.trOptionValue = value;
            button.setAttribute('aria-pressed', 'false');

            const dot = document.createElement('span');
            dot.className = 'tr-upgrade-builder__radio-dot';
            dot.setAttribute('aria-hidden', 'true');

            const copy = document.createElement('span');
            copy.className = 'tr-upgrade-builder__option-copy';
            const name = document.createElement('span');
            name.className = 'tr-upgrade-builder__option-name';
            name.textContent = parts.name;
            copy.append(name);

            if (parts.price) {
              const price = document.createElement('span');
              price.className = 'tr-upgrade-builder__option-price';
              price.textContent = parts.price;
              copy.append(price);
            }

            button.append(dot, copy);
            button.addEventListener('click', () => selectConditionalOption(key, value));
            list.append(button);
          });
          list.dataset.trControllerKey = state.controllerKey;
        }

        const selected = selectedRadio(key)?.value || '';
        list.querySelectorAll('[data-tr-option-value]').forEach((button) => {
          button.setAttribute('aria-pressed', String(state.groups[key].active && button.dataset.trOptionValue === selected));
        });
      }

      function syncUpgradeGroup(key) {
        const groupSource = source?.groups[key];
        if (!groupSource) return;

        const active = Boolean(groupSource.checkbox.checked);
        const selected = selectedRadio(key);
        state.groups[key].active = active;
        state.groups[key].value = active && selected ? selected.value : '';

        const card = root.querySelector(`[data-tr-upgrade-card="${key}"]`);
        const toggle = root.querySelector(`[data-tr-upgrade-toggle="${key}"]`);
        const panel = root.querySelector(`[data-tr-option-panel="${key}"]`);
        const stateLabel = root.querySelector(`[data-tr-upgrade-state="${key}"]`);

        card?.classList.toggle('is-selected', active);
        toggle?.setAttribute('aria-pressed', String(active));
        toggle?.setAttribute('aria-expanded', String(active));
        if (panel) panel.hidden = !active;
        if (stateLabel) stateLabel.textContent = active ? 'Selected' : 'Add';

        renderOptionButtons(key);
        if (active) clearError('upgrades');
        updateSummary();
      }

      function selectFirstUpgradeOption(key) {
        const groupSource = source?.groups[key];
        if (!groupSource?.checkbox.checked || selectedRadio(key)) return false;
        const firstRadio = sourceRadios(key).find((input) => !input.disabled);
        if (!firstRadio) return false;
        firstRadio.click();
        return true;
      }

      function toggleUpgrade(key) {
        if (!source?.groups[key] || groupBusy[key]) return;
        groupBusy[key] = true;
        source.groups[key].checkbox.click();

        window.setTimeout(() => {
          const selectedAutomatically = selectFirstUpgradeOption(key);
          syncUpgradeGroup(key);
          if (selectedAutomatically && state.groups[key].value) {
            announce(`${displayChoice(key, state.groups[key].value).full} selected.`);
          }
          window.setTimeout(() => {
            const selectedOnDelay = selectFirstUpgradeOption(key);
            syncUpgradeGroup(key);
            if (selectedOnDelay && state.groups[key].value) {
              announce(`${displayChoice(key, state.groups[key].value).full} selected.`);
            }
            updatePrice();
          }, 160);
          groupBusy[key] = false;
        }, 40);
      }

      function selectConditionalOption(key, value) {
        const groupSource = source?.groups[key];
        if (!groupSource?.checkbox.checked) return;
        const radio = sourceRadios(key).find((input) => input.value === value && !input.disabled);
        if (!radio) {
          showError('upgrades', 'This upgrade choice is still loading. Try it again in a moment.');
          return;
        }

        radio.click();
        state.groups[key].value = value;
        clearError('upgrades');
        renderOptionButtons(key);
        updateSummary();
        announce(`${displayChoice(key, value).full} selected.`);
        window.setTimeout(updatePrice, 160);
      }

      function selectController(button) {
        if (!source?.controller) return;
        const key = button.dataset.controllerKey || button.dataset.value;
        const sourceOption = sourceControllerOption(source.controller, key);
        if (!sourceOption) {
          showError('controller', 'This controller option is still loading. Refresh the page and try again.');
          return;
        }

        source.controller.value = sourceOption.value;
        dispatchValueEvents(source.controller);
        state.controller = sourceOption.value;
        state.controllerKey = key;
        state.controllerLabel = CONTROLLER_CONFIG[key]?.label || button.dataset.label || button.textContent.trim();
        setActive('controller', state.controllerKey);
        clearError('controller');
        renderOptionButtons('paddles');
        updateSummary();
        announce(`${state.controllerLabel} selected.`);
      }

      function selectSendIn(button) {
        if (!source?.sendIn) return;
        source.sendIn.value = button.dataset.value;
        dispatchValueEvents(source.sendIn);
        state.sendIn = button.dataset.value;
        state.sendInLabel = button.dataset.label || button.textContent.trim();
        setActive('send-in', state.sendIn);
        clearError('send-in');
        updateSummary();
        announce(`${state.sendInLabel} selected.`);
        window.setTimeout(updatePrice, 160);
      }

      function syncDetails() {
        if (!source?.details || !details) return;
        source.details.value = details.value;
        dispatchValueEvents(source.details);
        if (characterCount) characterCount.textContent = details.value.length;
        updateSummary();
      }

      function syncAgreement() {
        if (!source || !agreement) return;
        const checked = agreement.checked;
        const agreementValue = BENCH_COPY;

        if (source.benchCheckbox && source.benchCheckbox.checked !== checked) {
          source.benchCheckbox.click();
        }

        source.benchHidden.value = checked ? agreementValue : '';
        dispatchValueEvents(source.benchHidden);
        state.agreement = checked;
        if (checked) clearError('agreement');
        updateSummary();
        announce(checked ? 'Bench fee agreement accepted.' : 'Bench fee agreement is required.');
      }

      function validate() {
        let firstInvalid = null;
        if (!state.controllerKey) {
          showError('controller', 'Choose the controller you are sending.');
          firstInvalid ||= 'controller';
        }

        const selectedGroups = activeUpgradeKeys();
        if (!selectedGroups.length) {
          showError('upgrades', 'Choose at least one upgrade category.');
          firstInvalid ||= 'upgrades';
        } else if (selectedGroups.some((key) => !state.groups[key].value)) {
          showError('upgrades', 'Choose an option inside every selected upgrade category.');
          firstInvalid ||= 'upgrades';
        }

        if (!state.sendIn) {
          showError('send-in', 'Choose Self-Ship or the Mail-In Kit.');
          firstInvalid ||= 'send-in';
        }
        if (!state.agreement) {
          showError('agreement', 'Accept the bench fee terms to continue.');
          firstInvalid ||= 'agreement';
        }

        if (firstInvalid) {
          const group = root.querySelector(`[data-tr-group="${firstInvalid}"]`);
          group?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          group?.querySelector('button, input, textarea')?.focus({ preventScroll: true });
          return false;
        }
        return true;
      }

      function submitOriginalForm() {
        if (!source || !validate()) return;
        syncDetails();
        syncAgreement();

        submitting = true;
        submit.disabled = true;
        submit.setAttribute('aria-disabled', 'true');
        submit.setAttribute('aria-busy', 'true');
        if (submitLabel) submitLabel.textContent = 'Adding to cart';
        setStatus('Adding your configured upgrades...');
        source.addButton.click();

        window.setTimeout(() => {
          submitting = false;
          submit.removeAttribute('aria-busy');
          if (submitLabel) submitLabel.textContent = 'Add upgrades to cart';
          updateSubmitState();
        }, 1800);
      }

      function hideSourceControls() {
        source.container.classList.add('tr-upgrade-builder-source-control');
        source.container.setAttribute('aria-hidden', 'true');
        source.container.inert = true;
        source.price?.classList.add('tr-upgrade-builder-source-price');
        source.price?.setAttribute('aria-hidden', 'true');

        const nativeSection = source.form.closest('.shopify-section');
        if (nativeSection && !nativeSection.contains(root)) {
          nativeSection.classList.add('tr-upgrade-builder-native-interface');
          nativeSection.setAttribute('aria-hidden', 'true');
          nativeSection.inert = true;
        }

        document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
          const productId = form.querySelector('input[name="product-id"]')?.value;
          if (String(productId) !== String(config.productId)) return;
          form.querySelectorAll('button[name="add"], button[type="submit"]').forEach((button) => {
            button.classList.add('tr-upgrade-builder-source-submit');
            button.setAttribute('aria-hidden', 'true');
            button.setAttribute('tabindex', '-1');
          });

          const quickAdd = form.closest('quick-add-modal, .quick-add, [data-sticky-add-to-cart], .sticky-add-to-cart, product-sticky-bar');
          if (quickAdd) {
            quickAdd.classList.add('tr-upgrade-builder-quick-add');
            quickAdd.setAttribute('aria-hidden', 'true');
            quickAdd.inert = true;
          }
        });
      }

      function connectToInfiniteOptions() {
        const controller = document.querySelector('select[name="properties[CONTROLLER TYPE]"]');
        const form = controller?.form;
        const container = controller?.closest('#infiniteoptions-container');
        if (!controller || !form || !container) return false;

        const upgradeHidden = [...container.querySelectorAll('input[name="properties[Upgrades]"]')]
          .find((input) => input.form === form);
        const upgradeFieldset = upgradeHidden?.closest('fieldset');
        const upgradeCheckboxes = upgradeFieldset
          ? [...upgradeFieldset.querySelectorAll('input[type="checkbox"]')]
          : [];
        const detailsSource = [...container.querySelectorAll('textarea[name="properties[_Controller Details]"]')]
          .find((element) => element.form === form);
        const sendIn = [...container.querySelectorAll('select[name="properties[Send-in]"]')]
          .find((element) => element.form === form);
        const benchHidden = [...container.querySelectorAll(`input[name="${BENCH_PROPERTY}"]`)]
          .find((element) => element.form === form);
        const benchCheckbox = benchHidden?.closest('fieldset')?.querySelector('input[type="checkbox"]') || null;
        const addButton = form.querySelector('button[name="add"], button[type="submit"]');
        const groupBlocks = [...container.querySelectorAll('[role="group"]')];

        const groups = {};
        Object.entries(GROUP_CONFIG).forEach(([key, groupConfig]) => {
          const checkbox = upgradeCheckboxes.find((input) => input.value === groupConfig.sourceValue);
          const block = groupBlocks.find((candidate) => {
            const label = candidate.querySelector('.spb-label-tooltip label')?.textContent?.trim();
            return label === groupConfig.sourceLabel;
          });
          groups[key] = { checkbox, block };
        });

        if (
          !upgradeHidden ||
          !detailsSource ||
          !sendIn ||
          !benchHidden ||
          !benchCheckbox ||
          !addButton ||
          Object.values(groups).some((group) => !group.checkbox || !group.block)
        ) return false;

        source = {
          form,
          container,
          controller,
          upgradeHidden,
          details: detailsSource,
          sendIn,
          benchHidden,
          benchCheckbox,
          benchCopy: benchCheckbox.value || '',
          addButton,
          price: document.querySelector('.infiniteoptions-price'),
          groups
        };

        root.dataset.trInitialized = 'true';

        if (controller.value) {
          const controllerKey = controllerKeyForValue(controller.value);
          const controllerButton = [...root.querySelectorAll('[data-tr-choice="controller"]')]
            .find((button) => button.dataset.controllerKey === controllerKey);
          if (controllerButton) {
            state.controller = controller.value;
            state.controllerKey = controllerKey;
            state.controllerLabel = CONTROLLER_CONFIG[controllerKey]?.label || controllerButton.dataset.label || controllerButton.textContent.trim();
            setActive('controller', state.controllerKey);
          }
        }

        if (sendIn.value) {
          const sendButton = [...root.querySelectorAll('[data-tr-choice="send-in"]')]
            .find((button) => button.dataset.value === sendIn.value);
          if (sendButton) {
            state.sendIn = sendButton.dataset.value;
            state.sendInLabel = sendButton.dataset.label || sendButton.textContent.trim();
            setActive('send-in', state.sendIn);
          }
        }

        if (detailsSource.value && details) {
          details.value = detailsSource.value;
          if (characterCount) characterCount.textContent = details.value.length;
        }

        state.agreement = Boolean(benchHidden.value);
        if (agreement) agreement.checked = state.agreement;
        if (state.agreement) {
          benchHidden.value = BENCH_COPY;
          dispatchValueEvents(benchHidden);
        }

        const mailInOption = [...sendIn.options].find((option) => /MAIL-IN KIT/i.test(option.value));
        if (mailInOption && kitPrice) {
          const cents = parseAddedPrice(mailInOption.value);
          kitPrice.textContent = cents ? formatMoney(cents, config.currency) : 'Included';
        }

        sourceReady = true;
        Object.keys(GROUP_CONFIG).forEach((key) => {
          selectFirstUpgradeOption(key);
          syncUpgradeGroup(key);
        });

        if (source.price) {
          priceObserver = new MutationObserver(updatePrice);
          priceObserver.observe(source.price, { childList: true, subtree: true, characterData: true });
        }

        hideSourceControls();
        updateSummary();
        return true;
      }

      root.querySelectorAll('[data-tr-choice="controller"]').forEach((button) => {
        button.addEventListener('click', () => selectController(button));
      });
      root.querySelectorAll('[data-tr-choice="send-in"]').forEach((button) => {
        button.addEventListener('click', () => selectSendIn(button));
      });
      root.querySelectorAll('[data-tr-upgrade-toggle]').forEach((button) => {
        button.addEventListener('click', () => toggleUpgrade(button.dataset.trUpgradeToggle));
      });
      details?.addEventListener('input', syncDetails);
      agreement?.addEventListener('change', syncAgreement);
      submit?.addEventListener('click', submitOriginalForm);

      syncSummaryDisclosure();
      if (mobileSummaryQuery.addEventListener) mobileSummaryQuery.addEventListener('change', syncSummaryDisclosure);
      else mobileSummaryQuery.addListener(syncSummaryDisclosure);

      let attempts = 0;
      const connectionTimer = window.setInterval(() => {
        attempts += 1;
        if (connectToInfiniteOptions()) {
          window.clearInterval(connectionTimer);
        } else if (attempts >= 120) {
          window.clearInterval(connectionTimer);
          setStatus('The upgrade options did not load. Refresh this page before ordering.');
        }
      }, 100);

      root._trUpgradeCleanup = () => {
        window.clearInterval(connectionTimer);
        priceObserver?.disconnect();
        if (mobileSummaryQuery.removeEventListener) mobileSummaryQuery.removeEventListener('change', syncSummaryDisclosure);
        else mobileSummaryQuery.removeListener(syncSummaryDisclosure);
      };
    }

    function initAll(scope = document) {
      if (scope.matches?.(ROOT_SELECTOR)) initUpgradeBuilder(scope);
      scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initUpgradeBuilder);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll?.(ROOT_SELECTOR).forEach((root) => root._trUpgradeCleanup?.());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["techrevive-a-la-carte-upgrade-builder-v4"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ROOT_SELECTOR = '[data-tr-upgrade-builder]';
    const BENCH_PROPERTY = 'properties[bench fee agreement]';
    const BENCH_COPY = 'I understand that if my controller cannot be upgraded because of severe physical or liquid damage, TechRevive will retain $25 of my upfront payment as a non-refundable diagnostic bench fee and return my controller to me.';
    const CONTROLLER_CONFIG = {
      ps5: {
        label: 'PS5 DualSense',
        aliases: ['PS5 DUALSENSE', 'DUALSENSE 5', 'DUALSENSE', 'PLAYSTATION 5']
      },
      xbox: {
        label: 'Xbox Series X/S',
        aliases: ['XBOX SERIES X/S', 'XBOX SERIES XS', 'XBOX SERIES']
      },
      switch: {
        label: 'Nintendo Switch Pro',
        aliases: ['NINTENDO SWITCH PRO', 'SWITCH PRO']
      }
    };
    const GROUP_CONFIG = {
      joysticks: {
        sourceValue: 'Joystick Upgrade',
        sourceLabel: 'Joystick Options'
      },
      mouseclick: {
        sourceValue: 'Mouse-Click Triggers/Buttons',
        sourceLabel: 'Mouse-Click Options'
      },
      paddles: {
        sourceValue: 'Back Paddles/Buttons',
        sourceLabel: 'Back Paddles Options'
      }
    };

    function dispatchValueEvents(element) {
      element.dispatchEvent(new Event('input', { bubbles: true }));
      element.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function parseAddedPrice(label) {
      const match = String(label || '').match(/\$\s*([0-9]+(?:\.[0-9]{1,2})?)/);
      return match ? Math.round(Number(match[1]) * 100) : 0;
    }

    function formatMoney(cents, currency) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: currency || 'USD'
        }).format((Number(cents) || 0) / 100);
      } catch (error) {
        return `$${((Number(cents) || 0) / 100).toFixed(2)}`;
      }
    }

    function splitChoice(value) {
      const match = String(value || '').match(/^(.*?)\s+-\s+(\$[0-9,.]+)$/);
      return match ? { name: match[1], price: match[2] } : { name: String(value || ''), price: '' };
    }

    function normalizedMatch(value) {
      return String(value || '').trim().toUpperCase().replace(/[^A-Z0-9]+/g, ' ').trim();
    }

    function controllerKeyForValue(value) {
      const normalized = normalizedMatch(value);
      return Object.keys(CONTROLLER_CONFIG).find((key) => {
        const entry = CONTROLLER_CONFIG[key];
        return [entry.label, ...entry.aliases].some((alias) => normalizedMatch(alias) === normalized);
      }) || '';
    }

    function sourceControllerOption(select, key) {
      const entry = CONTROLLER_CONFIG[key];
      if (!select || !entry) return null;
      return [...select.options].find((option) => {
        const normalized = normalizedMatch(option.value || option.textContent);
        return [entry.label, ...entry.aliases].some((alias) => normalizedMatch(alias) === normalized);
      }) || null;
    }

    function initUpgradeBuilder(root) {
      if (!root || root.dataset.trInitialized === 'true') return;

      const configElement = root.querySelector('[data-tr-upgrade-config]');
      if (!configElement) return;

      let config;
      try {
        config = JSON.parse(configElement.textContent);
      } catch (error) {
        return;
      }

      const submit = root.querySelector('[data-tr-submit]');
      const submitLabel = root.querySelector('[data-tr-submit-label]');
      const status = root.querySelector('[data-tr-status]');
      const total = root.querySelector('[data-tr-total]');
      const details = root.querySelector('[data-tr-details]');
      const agreement = root.querySelector('[data-tr-agreement]');
      const characterCount = root.querySelector('[data-tr-character-count]');
      const kitPrice = root.querySelector('[data-tr-kit-price]');
      const announcer = root.querySelector('[data-tr-announcer]');
      const summaryDetails = root.querySelector('[data-tr-summary-details]');
      const mobileSummaryQuery = window.matchMedia('(max-width: 680px)');

      const state = {
        controller: '',
        controllerKey: '',
        controllerLabel: '',
        sendIn: '',
        sendInLabel: '',
        agreement: false,
        groups: {
          joysticks: { active: false, value: '' },
          mouseclick: { active: false, value: '' },
          paddles: { active: false, value: '' }
        }
      };

      let source = null;
      let priceObserver = null;
      let sourceReady = false;
      let submitting = false;
      const groupBusy = {};

      function setStatus(message) {
        if (status) status.textContent = message || '';
      }

      function announce(message) {
        if (!announcer || !message) return;
        announcer.textContent = '';
        window.setTimeout(() => { announcer.textContent = message; }, 20);
      }

      function canonicalChoiceName(key, rawName) {
        const normalized = normalizedMatch(rawName);

        if (key === 'joysticks') {
          if (normalized.includes('TMR')) return 'TMR Joysticks';
          if (normalized.includes('HALL')) return 'Hall Effect Joysticks';
        }

        if (key === 'mouseclick') {
          if (normalized.includes('EVERYTHING') || normalized.includes('COMPLETE') || normalized.includes('FULL')) {
            return 'Complete Mouse Click Control Set';
          }
          if (normalized.includes('TRIGGER') || normalized.includes('BUMPER')) {
            return 'Mouse Click Triggers and Bumpers';
          }
          if (normalized.includes('BUTTON') || normalized.includes('FACE') || normalized.includes('D PAD')) {
            return 'Mouse Click Face Buttons and D Pad';
          }
        }

        if (key === 'paddles') {
          if (state.controllerKey === 'ps5') return 'Four Rear Paddles';
          if (state.controllerKey === 'xbox' || state.controllerKey === 'switch') return 'Four Rear Buttons';
          return 'Rear Inputs';
        }

        return rawName;
      }

      function displayChoice(key, value) {
        const parts = splitChoice(value);
        const name = canonicalChoiceName(key, parts.name);
        return {
          name,
          price: parts.price,
          full: parts.price ? `${name} - ${parts.price}` : name
        };
      }

      function setSummary(key, value) {
        const target = root.querySelector(`[data-tr-summary="${key}"]`);
        if (target) target.textContent = value;
      }

      function showSummaryRow(key, show) {
        const row = root.querySelector(`[data-tr-summary-row="${key}"]`);
        if (row) row.hidden = !show;
      }

      function syncSummaryDisclosure() {
        if (!summaryDetails) return;
        summaryDetails.open = !mobileSummaryQuery.matches;
      }

      function setActive(group, value) {
        root.querySelectorAll(`[data-tr-choice="${group}"]`).forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.value === value));
        });
      }

      function clearError(group) {
        const wrapper = root.querySelector(`[data-tr-group="${group}"]`);
        const error = root.querySelector(`[data-tr-error="${group}"]`);
        wrapper?.removeAttribute('aria-invalid');
        if (error) error.textContent = '';
      }

      function showError(group, message) {
        const wrapper = root.querySelector(`[data-tr-group="${group}"]`);
        const error = root.querySelector(`[data-tr-error="${group}"]`);
        wrapper?.setAttribute('aria-invalid', 'true');
        if (error) error.textContent = message;
      }

      function sourceRadios(key) {
        return source?.groups[key]?.block
          ? [...source.groups[key].block.querySelectorAll('input[type="radio"]')]
          : [];
      }

      function selectedRadio(key) {
        return sourceRadios(key).find((input) => input.checked && !input.disabled) || null;
      }

      function variantOptionValues() {
        const joystickChoice = state.groups.joysticks.active ? displayChoice('joysticks', state.groups.joysticks.value).name : '';
        const mouseChoice = state.groups.mouseclick.active ? displayChoice('mouseclick', state.groups.mouseclick.value).name : '';
        return [
          joystickChoice === 'Hall Effect Joysticks' ? 'Hall Effect' : joystickChoice === 'TMR Joysticks' ? 'TMR' : 'None',
          mouseChoice === 'Mouse Click Face Buttons and D Pad' ? 'Face Buttons and D-Pad' : mouseChoice === 'Mouse Click Triggers and Bumpers' ? 'Triggers and Bumpers' : mouseChoice === 'Complete Mouse Click Control Set' ? 'Complete Control Set' : 'None',
          state.groups.paddles.active ? 'Four Rear Inputs' : 'None'
        ];
      }

      function selectedVariant() {
        const wanted = variantOptionValues().map(normalizedMatch);
        return (config.variants || []).find((variant) => {
          const options = (variant.options || []).map(normalizedMatch);
          return options.length === wanted.length && options.every((value, index) => value === wanted[index]);
        }) || null;
      }

      function fallbackTotal() {
        const variant = selectedVariant();
        let cents = variant ? Number(variant.price) || 0 : Number(config.basePrice) || 0;
        if (!variant) Object.keys(state.groups).forEach((key) => {
          if (state.groups[key].active) cents += parseAddedPrice(state.groups[key].value);
        });
        if (/MAIL-IN KIT/i.test(state.sendIn)) cents += parseAddedPrice(state.sendIn);
        return formatMoney(cents, config.currency || root.dataset.currency);
      }

      function activeUpgradeKeys() {
        return Object.keys(state.groups).filter((key) => state.groups[key].active);
      }

      function missingRequirements() {
        const missing = [];
        const activeGroups = activeUpgradeKeys();

        if (!state.controllerKey) missing.push('controller');
        if (!activeGroups.length) {
          missing.push('at least one upgrade');
        } else if (activeGroups.some((key) => !state.groups[key].value)) {
          missing.push('an option in each selected upgrade');
        }
        if (!state.sendIn) missing.push('mail in method');
        if (!state.agreement) missing.push('bench fee agreement');
        if (activeGroups.length && activeGroups.every((key) => state.groups[key].value) && !selectedVariant()) missing.push('available service configuration');
        return missing;
      }

      function updateSubmitState() {
        if (!submit) return;

        const missing = missingRequirements();
        const ready = sourceReady && !submitting && missing.length === 0;
        submit.disabled = !ready;
        submit.setAttribute('aria-disabled', String(!ready));

        if (submitting) return;
        if (!sourceReady) {
          setStatus('Loading upgrade options...');
        } else if (missing.length) {
          setStatus(`Still needed: ${missing.join(', ')}.`);
        } else {
          setStatus('Configuration complete. Ready to add to cart.');
        }
      }

      function updatePrice() {
        if (!total) return;
        const hasUpgrade = activeUpgradeKeys().some((key) => state.groups[key].value);
        if (!hasUpgrade) {
          total.textContent = 'Select an upgrade';
          total.dataset.empty = 'true';
          return;
        }

        const appPrice = source?.price?.textContent?.trim();
        total.textContent = appPrice || fallbackTotal();
        total.dataset.empty = 'false';
      }

      function updateSummary() {
        setSummary('controller', state.controllerLabel || 'Select a controller');
        Object.keys(state.groups).forEach((key) => {
          const value = state.groups[key].active && state.groups[key].value
            ? displayChoice(key, state.groups[key].value).full
            : 'Not selected';
          setSummary(key, value);
          showSummaryRow(key, state.groups[key].active);
        });
        setSummary('send-in', state.sendInLabel || 'Select a method');
        updatePrice();
        updateSubmitState();
      }

      function renderOptionButtons(key) {
        const list = root.querySelector(`[data-tr-option-list="${key}"]`);
        if (!list) return;

        const values = sourceRadios(key).map((radio) => radio.value).filter(Boolean);
        const existingValues = [...list.querySelectorAll('[data-tr-option-value]')].map((button) => button.dataset.trOptionValue);
        const controllerChanged = key === 'paddles' && list.dataset.trControllerKey !== state.controllerKey;
        const needsRebuild = controllerChanged || values.length !== existingValues.length || values.some((value, index) => value !== existingValues[index]);

        if (needsRebuild) {
          list.replaceChildren();
          values.forEach((value) => {
            const parts = displayChoice(key, value);
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'tr-upgrade-builder__option';
            button.dataset.trOptionValue = value;
            button.setAttribute('aria-pressed', 'false');

            const dot = document.createElement('span');
            dot.className = 'tr-upgrade-builder__radio-dot';
            dot.setAttribute('aria-hidden', 'true');

            const copy = document.createElement('span');
            copy.className = 'tr-upgrade-builder__option-copy';
            const name = document.createElement('span');
            name.className = 'tr-upgrade-builder__option-name';
            name.textContent = parts.name;
            copy.append(name);

            if (parts.price) {
              const price = document.createElement('span');
              price.className = 'tr-upgrade-builder__option-price';
              price.textContent = parts.price;
              copy.append(price);
            }

            button.append(dot, copy);
            button.addEventListener('click', () => selectConditionalOption(key, value));
            list.append(button);
          });
          list.dataset.trControllerKey = state.controllerKey;
        }

        const selected = selectedRadio(key)?.value || '';
        list.querySelectorAll('[data-tr-option-value]').forEach((button) => {
          button.setAttribute('aria-pressed', String(state.groups[key].active && button.dataset.trOptionValue === selected));
        });
      }

      function syncUpgradeGroup(key) {
        const groupSource = source?.groups[key];
        if (!groupSource) return;

        const active = Boolean(groupSource.checkbox.checked);
        const selected = selectedRadio(key);
        state.groups[key].active = active;
        state.groups[key].value = active && selected ? selected.value : '';

        const card = root.querySelector(`[data-tr-upgrade-card="${key}"]`);
        const toggle = root.querySelector(`[data-tr-upgrade-toggle="${key}"]`);
        const panel = root.querySelector(`[data-tr-option-panel="${key}"]`);
        const stateLabel = root.querySelector(`[data-tr-upgrade-state="${key}"]`);

        card?.classList.toggle('is-selected', active);
        toggle?.setAttribute('aria-pressed', String(active));
        toggle?.setAttribute('aria-expanded', String(active));
        if (panel) panel.hidden = !active;
        if (stateLabel) stateLabel.textContent = active ? 'Selected' : 'Add';

        renderOptionButtons(key);
        if (active) clearError('upgrades');
        updateSummary();
      }

      function selectFirstUpgradeOption(key) {
        const groupSource = source?.groups[key];
        if (!groupSource?.checkbox.checked || selectedRadio(key)) return false;
        const firstRadio = sourceRadios(key).find((input) => !input.disabled);
        if (!firstRadio) return false;
        firstRadio.click();
        return true;
      }

      function toggleUpgrade(key) {
        if (!source?.groups[key] || groupBusy[key]) return;
        groupBusy[key] = true;
        source.groups[key].checkbox.click();

        window.setTimeout(() => {
          const selectedAutomatically = selectFirstUpgradeOption(key);
          syncUpgradeGroup(key);
          if (selectedAutomatically && state.groups[key].value) {
            announce(`${displayChoice(key, state.groups[key].value).full} selected.`);
          }
          window.setTimeout(() => {
            const selectedOnDelay = selectFirstUpgradeOption(key);
            syncUpgradeGroup(key);
            if (selectedOnDelay && state.groups[key].value) {
              announce(`${displayChoice(key, state.groups[key].value).full} selected.`);
            }
            updatePrice();
          }, 160);
          groupBusy[key] = false;
        }, 40);
      }

      function selectConditionalOption(key, value) {
        const groupSource = source?.groups[key];
        if (!groupSource?.checkbox.checked) return;
        const radio = sourceRadios(key).find((input) => input.value === value && !input.disabled);
        if (!radio) {
          showError('upgrades', 'This upgrade choice is still loading. Try it again in a moment.');
          return;
        }

        radio.click();
        state.groups[key].value = value;
        clearError('upgrades');
        renderOptionButtons(key);
        updateSummary();
        announce(`${displayChoice(key, value).full} selected.`);
        window.setTimeout(updatePrice, 160);
      }

      function selectController(button) {
        if (!source?.controller) return;
        const key = button.dataset.controllerKey || button.dataset.value;
        const sourceOption = sourceControllerOption(source.controller, key);
        if (!sourceOption) {
          showError('controller', 'This controller option is still loading. Refresh the page and try again.');
          return;
        }

        source.controller.value = sourceOption.value;
        dispatchValueEvents(source.controller);
        state.controller = sourceOption.value;
        state.controllerKey = key;
        state.controllerLabel = CONTROLLER_CONFIG[key]?.label || button.dataset.label || button.textContent.trim();
        setActive('controller', state.controllerKey);
        clearError('controller');
        renderOptionButtons('paddles');
        updateSummary();
        announce(`${state.controllerLabel} selected.`);
      }

      function selectSendIn(button) {
        if (!source?.sendIn) return;
        source.sendIn.value = button.dataset.value;
        dispatchValueEvents(source.sendIn);
        state.sendIn = button.dataset.value;
        state.sendInLabel = button.dataset.label || button.textContent.trim();
        setActive('send-in', state.sendIn);
        clearError('send-in');
        updateSummary();
        announce(`${state.sendInLabel} selected.`);
        window.setTimeout(updatePrice, 160);
      }

      function syncDetails() {
        if (!source?.details || !details) return;
        source.details.value = details.value;
        dispatchValueEvents(source.details);
        if (characterCount) characterCount.textContent = details.value.length;
        updateSummary();
      }

      function syncAgreement() {
        if (!source || !agreement) return;
        const checked = agreement.checked;
        const agreementValue = BENCH_COPY;

        if (source.benchCheckbox && source.benchCheckbox.checked !== checked) {
          source.benchCheckbox.click();
        }

        source.benchHidden.value = checked ? agreementValue : '';
        dispatchValueEvents(source.benchHidden);
        state.agreement = checked;
        if (checked) clearError('agreement');
        updateSummary();
        announce(checked ? 'Bench fee agreement accepted.' : 'Bench fee agreement is required.');
      }

      function validate() {
        let firstInvalid = null;
        if (!state.controllerKey) {
          showError('controller', 'Choose the controller you are sending.');
          firstInvalid ||= 'controller';
        }

        const selectedGroups = activeUpgradeKeys();
        if (!selectedGroups.length) {
          showError('upgrades', 'Choose at least one upgrade category.');
          firstInvalid ||= 'upgrades';
        } else if (selectedGroups.some((key) => !state.groups[key].value)) {
          showError('upgrades', 'Choose an option inside every selected upgrade category.');
          firstInvalid ||= 'upgrades';
        }

        if (!state.sendIn) {
          showError('send-in', 'Choose Self-Ship or the Mail-In Kit.');
          firstInvalid ||= 'send-in';
        }
        if (!state.agreement) {
          showError('agreement', 'Accept the bench fee terms to continue.');
          firstInvalid ||= 'agreement';
        }

        if (firstInvalid) {
          const group = root.querySelector(`[data-tr-group="${firstInvalid}"]`);
          group?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          group?.querySelector('button, input, textarea')?.focus({ preventScroll: true });
          return false;
        }
        return true;
      }

      async function submitOriginalForm() {
        if (!source || !validate()) return;
        syncDetails();
        syncAgreement();

        submitting = true;
        submit.disabled = true;
        submit.setAttribute('aria-disabled', 'true');
        submit.setAttribute('aria-busy', 'true');
        if (submitLabel) submitLabel.textContent = 'Adding to cart';
        setStatus('Adding your configured upgrades...');

        try {
          if (!window.TechReviveNativeCart?.addConfiguration) {
            throw new Error('The native cart service did not load. Refresh the page and try again.');
          }

          const activeKeys = activeUpgradeKeys();
          const variant = selectedVariant();
          if (!variant) throw new Error('The selected upgrade configuration is unavailable. Refresh the page and try again.');
          const addOns = [];
          if (/MAIL-IN KIT/i.test(state.sendIn)) {
            addOns.push({ variantTitle: 'Mail-In Kit', label: 'Mail-In Kit' });
          }

          await window.TechReviveNativeCart.addConfiguration({
            root,
            productId: config.productId,
            parentVariantId: variant.id,
            addonVariants: config.addonVariants,
            serviceLabel: 'Build Your Own Controller Upgrades',
            parentProperties: {
              'CONTROLLER TYPE': state.controller,
              'Upgrades': activeKeys.map((key) => GROUP_CONFIG[key].sourceValue),
              '_Joysticks': state.groups.joysticks.active ? displayChoice('joysticks', state.groups.joysticks.value).name : '',
              '_Mouse-Click': state.groups.mouseclick.active ? displayChoice('mouseclick', state.groups.mouseclick.value).name : '',
              '_Back Paddles Upgrade': state.groups.paddles.active ? displayChoice('paddles', state.groups.paddles.value).name : '',
              '_Controller Details': details?.value.trim(),
              'Bench Fee Agreement': 'Accepted'
            },
            addOns
          });
          setStatus('Your configured upgrades were added to the cart.');
        } catch (error) {
          console.error(error);
          setStatus(error?.message || 'The upgrades could not be added. Refresh the page and try again.');
        } finally {
          submitting = false;
          submit.removeAttribute('aria-busy');
          if (submitLabel) submitLabel.textContent = 'Add upgrades to cart';
          updateSubmitState();
        }
      }

      function hideSourceControls() {
        source.container.classList.add('tr-upgrade-builder-source-control');
        source.container.setAttribute('aria-hidden', 'true');
        source.container.inert = true;
        source.price?.classList.add('tr-upgrade-builder-source-price');
        source.price?.setAttribute('aria-hidden', 'true');

        const nativeSection = source.form.closest('.shopify-section');
        if (nativeSection && !nativeSection.contains(root)) {
          nativeSection.classList.add('tr-upgrade-builder-native-interface');
          nativeSection.setAttribute('aria-hidden', 'true');
          nativeSection.inert = true;
        }

        document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
          const productId = form.querySelector('input[name="product-id"]')?.value;
          if (String(productId) !== String(config.productId)) return;
          form.querySelectorAll('button[name="add"], button[type="submit"]').forEach((button) => {
            button.classList.add('tr-upgrade-builder-source-submit');
            button.setAttribute('aria-hidden', 'true');
            button.setAttribute('tabindex', '-1');
          });

          const quickAdd = form.closest('quick-add-modal, .quick-add, [data-sticky-add-to-cart], .sticky-add-to-cart, product-sticky-bar');
          if (quickAdd) {
            quickAdd.classList.add('tr-upgrade-builder-quick-add');
            quickAdd.setAttribute('aria-hidden', 'true');
            quickAdd.inert = true;
          }
        });
      }

      function connectToNativeSource() {
        const controller = document.querySelector('select[name="properties[CONTROLLER TYPE]"]');
        const form = controller?.form;
        const container = controller?.closest('[data-tr-native-options-container]');
        if (!controller || !form || !container) return false;

        const upgradeHidden = [...container.querySelectorAll('input[name="properties[Upgrades]"]')]
          .find((input) => input.form === form);
        const upgradeFieldset = upgradeHidden?.closest('fieldset');
        const upgradeCheckboxes = upgradeFieldset
          ? [...upgradeFieldset.querySelectorAll('input[type="checkbox"]')]
          : [];
        const detailsSource = [...container.querySelectorAll('textarea[name="properties[_Controller Details]"]')]
          .find((element) => element.form === form);
        const sendIn = [...container.querySelectorAll('select[name="properties[Send-in]"]')]
          .find((element) => element.form === form);
        const benchHidden = [...container.querySelectorAll(`input[name="${BENCH_PROPERTY}"]`)]
          .find((element) => element.form === form);
        const benchCheckbox = benchHidden?.closest('fieldset')?.querySelector('input[type="checkbox"]') || null;
        const addButton = form.querySelector('button[name="add"], button[type="submit"]');
        const groupBlocks = [...container.querySelectorAll('[role="group"]')];

        const groups = {};
        Object.entries(GROUP_CONFIG).forEach(([key, groupConfig]) => {
          const checkbox = upgradeCheckboxes.find((input) => input.value === groupConfig.sourceValue);
          const block = groupBlocks.find((candidate) => {
            const label = candidate.querySelector('.spb-label-tooltip label')?.textContent?.trim();
            return label === groupConfig.sourceLabel;
          });
          groups[key] = { checkbox, block };
        });

        if (
          !upgradeHidden ||
          !detailsSource ||
          !sendIn ||
          !benchHidden ||
          !benchCheckbox ||
          !addButton ||
          Object.values(groups).some((group) => !group.checkbox || !group.block)
        ) return false;

        source = {
          form,
          container,
          controller,
          upgradeHidden,
          details: detailsSource,
          sendIn,
          benchHidden,
          benchCheckbox,
          benchCopy: benchCheckbox.value || '',
          addButton,
          price: null,
          groups
        };

        root.dataset.trInitialized = 'true';

        if (controller.value) {
          const controllerKey = controllerKeyForValue(controller.value);
          const controllerButton = [...root.querySelectorAll('[data-tr-choice="controller"]')]
            .find((button) => button.dataset.controllerKey === controllerKey);
          if (controllerButton) {
            state.controller = controller.value;
            state.controllerKey = controllerKey;
            state.controllerLabel = CONTROLLER_CONFIG[controllerKey]?.label || controllerButton.dataset.label || controllerButton.textContent.trim();
            setActive('controller', state.controllerKey);
          }
        }

        if (sendIn.value) {
          const sendButton = [...root.querySelectorAll('[data-tr-choice="send-in"]')]
            .find((button) => button.dataset.value === sendIn.value);
          if (sendButton) {
            state.sendIn = sendButton.dataset.value;
            state.sendInLabel = sendButton.dataset.label || sendButton.textContent.trim();
            setActive('send-in', state.sendIn);
          }
        }

        if (detailsSource.value && details) {
          details.value = detailsSource.value;
          if (characterCount) characterCount.textContent = details.value.length;
        }

        state.agreement = Boolean(benchHidden.value);
        if (agreement) agreement.checked = state.agreement;
        if (state.agreement) {
          benchHidden.value = BENCH_COPY;
          dispatchValueEvents(benchHidden);
        }

        const mailInOption = [...sendIn.options].find((option) => /MAIL-IN KIT/i.test(option.value));
        if (mailInOption && kitPrice) {
          const cents = parseAddedPrice(mailInOption.value);
          kitPrice.textContent = cents ? formatMoney(cents, config.currency) : 'Included';
        }

        sourceReady = true;
        Object.keys(GROUP_CONFIG).forEach((key) => {
          selectFirstUpgradeOption(key);
          syncUpgradeGroup(key);
        });

        if (source.price) {
          priceObserver = new MutationObserver(updatePrice);
          priceObserver.observe(source.price, { childList: true, subtree: true, characterData: true });
        }

        hideSourceControls();
        updateSummary();
        return true;
      }

      root.querySelectorAll('[data-tr-choice="controller"]').forEach((button) => {
        button.addEventListener('click', () => selectController(button));
      });
      root.querySelectorAll('[data-tr-choice="send-in"]').forEach((button) => {
        button.addEventListener('click', () => selectSendIn(button));
      });
      root.querySelectorAll('[data-tr-upgrade-toggle]').forEach((button) => {
        button.addEventListener('click', () => toggleUpgrade(button.dataset.trUpgradeToggle));
      });
      details?.addEventListener('input', syncDetails);
      agreement?.addEventListener('change', syncAgreement);
      submit?.addEventListener('click', submitOriginalForm);

      syncSummaryDisclosure();
      if (mobileSummaryQuery.addEventListener) mobileSummaryQuery.addEventListener('change', syncSummaryDisclosure);
      else mobileSummaryQuery.addListener(syncSummaryDisclosure);

      let attempts = 0;
      const connectionTimer = window.setInterval(() => {
        attempts += 1;
        if (connectToNativeSource()) {
          window.clearInterval(connectionTimer);
        } else if (attempts >= 120) {
          window.clearInterval(connectionTimer);
          setStatus('The upgrade builder did not load. Refresh this page before ordering.');
        }
      }, 100);

      root._trUpgradeCleanup = () => {
        window.clearInterval(connectionTimer);
        priceObserver?.disconnect();
        if (mobileSummaryQuery.removeEventListener) mobileSummaryQuery.removeEventListener('change', syncSummaryDisclosure);
        else mobileSummaryQuery.removeListener(syncSummaryDisclosure);
      };
    }

    function initAll(scope = document) {
      if (scope.matches?.(ROOT_SELECTOR)) initUpgradeBuilder(scope);
      scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initUpgradeBuilder);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll?.(ROOT_SELECTOR).forEach((root) => root._trUpgradeCleanup?.());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["techrevive-bundle-builder-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ROOT_SELECTOR = '[data-tr-bundle-builder-v4]';
    const BENCH_PROPERTY = 'properties[bench fee agreement]';

    const normalize = (value) => String(value || '').trim().toUpperCase();

    function dispatchValueEvents(element) {
      element.dispatchEvent(new Event('input', { bubbles: true }));
      element.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function parseAddedPrice(label) {
      const match = String(label || '').match(/\$\s*([0-9]+(?:\.[0-9]{1,2})?)/);
      return match ? Math.round(Number(match[1]) * 100) : 0;
    }

    function formatMoney(cents, currency) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: currency || 'USD'
        }).format((Number(cents) || 0) / 100);
      } catch (error) {
        return `$${((Number(cents) || 0) / 100).toFixed(2)}`;
      }
    }

    function sourceBlockFor(element, form) {
      if (!element) return null;
      let node = element.parentElement;
      let fallback = element.parentElement;

      while (node && node !== form && node !== document.body) {
        const propertyFields = [...node.querySelectorAll('[name^="properties["]')];
        const uniqueNames = [...new Set(propertyFields.map((field) => field.name).filter(Boolean))];
        const hasAppLabel = node.querySelector('.spb-label-tooltip, fieldset, legend');

        if (propertyFields.length && uniqueNames.length === 1) fallback = node;
        if (propertyFields.length && uniqueNames.length === 1 && hasAppLabel) return node;
        node = node.parentElement;
      }

      return fallback;
    }

    function initBundleBuilder(root) {
      if (!root || root.dataset.trInitialized === 'true') return;

      const configElement = root.querySelector('[data-tr-bundle-config]');
      if (!configElement) return;

      let config;
      try {
        config = JSON.parse(configElement.textContent);
      } catch (error) {
        return;
      }

      const submit = root.querySelector('[data-tr-submit]');
      const submitLabel = root.querySelector('[data-tr-submit-label]');
      const status = root.querySelector('[data-tr-status]');
      const total = root.querySelector('[data-tr-total]');
      const details = root.querySelector('[data-tr-details]');
      const agreement = root.querySelector('[data-tr-agreement]');
      const characterCount = root.querySelector('[data-tr-character-count]');
      const kitPrice = root.querySelector('[data-tr-kit-price]');
      const summaryDetails = root.querySelector('[data-tr-summary-details]');
      const mobileSummaryQuery = window.matchMedia('(max-width: 680px)');

      const state = {
        tier: '',
        tierLabel: '',
        tierSlug: '',
        variantTitle: '',
        variantId: '',
        controller: '',
        controllerLabel: '',
        sendIn: '',
        sendInLabel: '',
        agreement: false
      };

      let source = null;

      function setStatus(message) {
        if (status) status.textContent = message || '';
      }

      function setSummary(key, value) {
        const target = root.querySelector(`[data-tr-summary="${key}"]`);
        if (target) target.textContent = value;
      }

      function setSummaryPrice(key, value) {
        const target = root.querySelector(`[data-tr-summary-price="${key}"]`);
        if (target) target.textContent = value;
      }

      function syncSummaryDisclosure() {
        if (!summaryDetails) return;
        summaryDetails.open = !mobileSummaryQuery.matches;
      }

      function setActive(group, value) {
        root.querySelectorAll(`[data-tr-choice="${group}"]`).forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.value === value));
        });
      }

      function clearError(group) {
        const wrapper = root.querySelector(`[data-tr-group="${group}"]`);
        const error = root.querySelector(`[data-tr-error="${group}"]`);
        if (wrapper) wrapper.removeAttribute('aria-invalid');
        if (error) error.textContent = '';
      }

      function showError(group, message) {
        const wrapper = root.querySelector(`[data-tr-group="${group}"]`);
        const error = root.querySelector(`[data-tr-error="${group}"]`);
        if (wrapper) wrapper.setAttribute('aria-invalid', 'true');
        if (error) error.textContent = message;
      }

      function selectedVariant() {
        return (config.variants || []).find((variant) => String(variant.id) === String(state.variantId))
          || (config.variants || []).find((variant) => normalize(variant.title) === normalize(state.variantTitle))
          || (config.variants || [])[0]
          || null;
      }

      function fallbackTotal() {
        const variant = selectedVariant();
        const base = variant ? Number(variant.price) || 0 : 0;
        const mailIn = /MAIL-IN KIT/i.test(state.sendIn) ? parseAddedPrice(state.sendIn) : 0;
        return formatMoney(base + mailIn, config.currency || root.dataset.currency);
      }

      function updatePrice() {
        if (!total) return;
        total.textContent = state.tier ? fallbackTotal() : 'Pending';
      }

      function missingConfiguration() {
        const missing = [];
        if (!state.tier) missing.push('bundle tier');
        if (!state.controller) missing.push('controller');
        if (!state.sendIn) missing.push('mail in method');
        if (!state.agreement) missing.push('bench fee agreement');
        return missing;
      }

      function updateSubmitState() {
        if (!submit) return;
        const missing = missingConfiguration();
        const ready = Boolean(source) && missing.length === 0;
        submit.disabled = !ready;
        submit.setAttribute('aria-disabled', String(!ready));

        if (submit.getAttribute('aria-busy') === 'true') return;
        if (!source) {
          setStatus('Loading bundle options.');
        } else if (ready) {
          setStatus('Your bundle configuration is complete and ready to add to the cart.');
        } else {
          setStatus(`Complete ${missing.join(', ')} to continue.`);
        }
      }

      function updateSummary() {
        const variant = selectedVariant();
        setSummary('tier', state.tierLabel || 'Select a tier');
        setSummary('controller', state.controllerLabel || 'Select a controller');
        setSummary('send-in', state.sendInLabel || 'Select a method');
        setSummaryPrice('tier', state.tier && variant ? formatMoney(variant.price, config.currency) : 'Pending');
        setSummaryPrice('send-in', !state.sendIn ? 'Pending' : /MAIL-IN KIT/i.test(state.sendIn) ? formatMoney(parseAddedPrice(state.sendIn), config.currency) : 'Included');
        updatePrice();
        updateSubmitState();
      }

      function findTierOption(button) {
        const exactValue = button.dataset.value;
        const variantTitle = normalize(button.dataset.variantTitle);
        return source.bundleInputs.find((input) => input.value === exactValue)
          || source.bundleInputs.find((input) => normalize(input.value).startsWith(variantTitle));
      }

      function syncNativeVariant(variant) {
        if (!variant || !source?.variantControls?.length) return;
        const variantId = String(variant.id);

        source.variantControls.forEach((control) => {
          if (control.matches('input[type="radio"], input[type="checkbox"]')) {
            const shouldCheck = String(control.value) === variantId;
            if (control.checked !== shouldCheck) {
              control.checked = shouldCheck;
              if (shouldCheck) dispatchValueEvents(control);
            }
            return;
          }

          if (String(control.value) !== variantId) {
            control.value = variantId;
            dispatchValueEvents(control);
          }
        });
      }

      function updateTierAddress() {
        if (!state.tierSlug || !state.variantId) return;
        const url = new URL(window.location.href);
        url.searchParams.set('tier', state.tierSlug);
        url.searchParams.set('variant', state.variantId);
        window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
      }

      function applyTierSelection(button, { updateUrl = true } = {}) {
        if (!source || !button) return false;
        const option = findTierOption(button);
        if (!option) {
          showError('tier', 'This bundle tier could not be connected. Refresh the page and try again.');
          return false;
        }

        if (!option.checked) option.click();

        const variant = (config.variants || []).find((item) => String(item.id) === String(button.dataset.variantId))
          || (config.variants || []).find((item) => normalize(item.title) === normalize(button.dataset.variantTitle));

        if (!variant) {
          showError('tier', 'The Shopify variant for this bundle tier could not be found.');
          return false;
        }

        state.tier = button.dataset.value;
        state.tierLabel = button.querySelector('.tr-bundle-builder-v4__choice-name')?.textContent.trim() || button.dataset.value;
        state.tierSlug = button.dataset.tierSlug || state.tierLabel.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        state.variantTitle = button.dataset.variantTitle;
        state.variantId = String(variant.id);
        syncNativeVariant(variant);
        setActive('tier', state.tier);
        clearError('tier');
        updateSummary();
        if (updateUrl) updateTierAddress();
        window.requestAnimationFrame(updatePrice);
        window.setTimeout(updatePrice, 120);
        return true;
      }

      function selectTier(button) {
        applyTierSelection(button, { updateUrl: true });
      }

      function selectController(button) {
        if (!source?.controller) return;
        source.controller.value = button.dataset.value;
        dispatchValueEvents(source.controller);

        state.controller = button.dataset.value;
        state.controllerLabel = button.dataset.label || button.textContent.trim();
        setActive('controller', state.controller);
        clearError('controller');
        updateSummary();
      }

      function selectSendIn(button) {
        if (!source?.sendIn) return;
        source.sendIn.value = button.dataset.value;
        dispatchValueEvents(source.sendIn);

        state.sendIn = button.dataset.value;
        state.sendInLabel = button.dataset.label || button.textContent.trim();
        setActive('send-in', state.sendIn);
        clearError('send-in');
        updateSummary();
        window.setTimeout(updatePrice, 180);
      }

      function syncDetails() {
        if (!source?.details || !details) return;
        source.details.value = details.value;
        dispatchValueEvents(source.details);
        if (characterCount) characterCount.textContent = details.value.length;
        updateSummary();
      }

      function syncAgreement() {
        if (!source || !agreement) return;
        const checked = agreement.checked;
        const agreementValue = source.benchCopy || source.benchCheckbox?.value || '';

        if (source.benchCheckbox) {
          source.benchCheckbox.checked = checked;
          dispatchValueEvents(source.benchCheckbox);
        }

        source.benchHidden.value = checked ? agreementValue : '';
        dispatchValueEvents(source.benchHidden);

        state.agreement = checked;
        if (checked) clearError('agreement');
        updateSummary();
      }

      function validate() {
        let firstInvalid = null;

        if (!state.tier) {
          showError('tier', 'Choose a bundle tier.');
          firstInvalid ||= 'tier';
        }
        if (!state.controller) {
          showError('controller', 'Choose the controller you are sending.');
          firstInvalid ||= 'controller';
        }
        if (!state.sendIn) {
          showError('send-in', 'Choose Self-Ship or the Mail-In Kit.');
          firstInvalid ||= 'send-in';
        }
        if (!state.agreement) {
          showError('agreement', 'Accept the bench fee terms to continue.');
          firstInvalid ||= 'agreement';
        }

        if (firstInvalid) {
          root.querySelector(`[data-tr-group="${firstInvalid}"]`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          root.querySelector(`[data-tr-group="${firstInvalid}"] button, [data-tr-group="${firstInvalid}"] input`)?.focus({ preventScroll: true });
          updateSubmitState();
          return false;
        }
        return true;
      }

      function submitOriginalForm() {
        if (!source || !validate()) return;
        syncDetails();
        syncAgreement();

        submit.disabled = true;
        submit.setAttribute('aria-disabled', 'true');
        submit.setAttribute('aria-busy', 'true');
        if (submitLabel) submitLabel.textContent = 'Adding to cart';
        setStatus('Adding your configured bundle...');

        source.addButton.click();

        window.setTimeout(() => {
          submit.removeAttribute('aria-busy');
          if (submitLabel) submitLabel.textContent = 'Add bundle to cart';
          updateSubmitState();
        }, 1800);
      }

      function hideSourceControls() {
        const conceal = (element, className) => {
          if (!element) return;
          element.classList.add(className);
          element.setAttribute('aria-hidden', 'true');
          const selector = 'a[href], button, input, select, textarea, [tabindex]';
          const focusables = [
            ...(element.matches?.(selector) ? [element] : []),
            ...(element.querySelectorAll?.(selector) || [])
          ];
          focusables.forEach((focusable) => focusable.setAttribute('tabindex', '-1'));
        };

        const propertyElements = [
          ...source.bundleInputs,
          source.controller,
          source.details,
          source.sendIn,
          source.benchHidden
        ].filter(Boolean);

        propertyElements.forEach((element) => {
          conceal(sourceBlockFor(element, source.form), 'tr-bundle-builder-v4-source-control');
        });

        const benchFieldset = source.benchHidden?.closest('fieldset');
        const completeBenchBlock = benchFieldset?.parentElement?.parentElement;
        conceal(completeBenchBlock, 'tr-bundle-builder-v4-source-control');

        source.variantControls.forEach((control) => {
          const variantWrapper = control.closest(
            'variant-selects, variant-radios, variant-picker, product-variant-picker, [data-variant-picker], .product-form__input'
          );
          if (variantWrapper && variantWrapper !== source.form) {
            conceal(variantWrapper, 'tr-bundle-builder-v4-source-variant');
          }
        });

        const productScope = source.form.closest(
          'product-info, product-information, [data-product-id], .product__info-container'
        );
        productScope?.querySelectorAll(
          'variant-selects, variant-radios, variant-picker, product-variant-picker, [data-variant-picker], quantity-input, .product-form__quantity, [data-quantity-selector], price-display, [data-product-price]'
        ).forEach((element) => conceal(element, 'tr-bundle-builder-v4-source-variant'));

        conceal(source.price, 'tr-bundle-builder-v4-source-price');

        document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
          const productId = form.querySelector('input[name="product-id"]')?.value;
          if (String(productId) !== String(config.productId)) return;
          form.querySelectorAll('button[name="add"], button[type="submit"]').forEach((button) => {
            conceal(button, 'tr-bundle-builder-v4-source-submit');
          });
        });
      }

      function connectToInfiniteOptions() {
        const controllers = [...document.querySelectorAll('select[name="properties[CONTROLLER TYPE]"]')];
        const controller = controllers.find((element) => {
          const formProductId = element.form?.querySelector('input[name="product-id"]')?.value;
          return String(formProductId) === String(config.productId);
        }) || controllers[0];
        const form = controller?.form;
        if (!controller || !form) return false;

        const bundleInputs = [...document.querySelectorAll('input[name="properties[Bundle Selection]"]')]
          .filter((input) => input.form === form);
        const detailsSource = [...document.querySelectorAll('textarea[name="properties[_Controller Details]"]')]
          .find((element) => element.form === form);
        const sendIn = [...document.querySelectorAll('select[name="properties[Send-in]"]')]
          .find((element) => element.form === form);
        const benchHidden = [...document.querySelectorAll(`input[name="${BENCH_PROPERTY}"]`)]
          .find((element) => element.form === form);
        const addButton = form.querySelector('button[name="add"], button[type="submit"]');
        const variantControls = [...document.querySelectorAll('[name="id"]')]
          .filter((element) => element.form === form);

        if (bundleInputs.length !== 3 || !detailsSource || !sendIn || !benchHidden || !addButton || !variantControls.length) return false;

        const benchFieldset = benchHidden.closest('fieldset');
        const benchCheckbox = benchFieldset?.querySelector('input[type="checkbox"]') || null;
        const price = document.querySelector('.infiniteoptions-price');
        const benchCopyTarget = root.querySelector('[data-tr-bench-copy]');
        const benchCopy = benchCopyTarget?.textContent.replace(/\s+/g, ' ').trim() || '';

        source = {
          form,
          bundleInputs,
          controller,
          details: detailsSource,
          sendIn,
          benchHidden,
          benchCheckbox,
          benchCopy,
          addButton,
          price,
          variantControls
        };

        if (benchCheckbox && benchCopy) benchCheckbox.value = benchCopy;

        if (controller.value) {
          const controllerButton = [...root.querySelectorAll('[data-tr-choice="controller"]')]
            .find((button) => button.dataset.value === controller.value);
          if (controllerButton) {
            state.controller = controllerButton.dataset.value;
            state.controllerLabel = controllerButton.dataset.label || controllerButton.textContent.trim();
            setActive('controller', state.controller);
          }
        }

        if (sendIn.value) {
          const sendButton = [...root.querySelectorAll('[data-tr-choice="send-in"]')]
            .find((button) => button.dataset.value === sendIn.value);
          if (sendButton) {
            state.sendIn = sendButton.dataset.value;
            state.sendInLabel = sendButton.dataset.label || sendButton.textContent.trim();
            setActive('send-in', state.sendIn);
          }
        }

        if (detailsSource.value && details) {
          details.value = detailsSource.value;
          if (characterCount) characterCount.textContent = details.value.length;
        }

        state.agreement = Boolean(benchHidden.value);
        if (agreement) agreement.checked = state.agreement;

        const mailInOption = [...sendIn.options].find((option) => /MAIL-IN KIT/i.test(option.value));
        if (mailInOption && kitPrice) {
          const cents = parseAddedPrice(mailInOption.value);
          kitPrice.textContent = cents ? `+${formatMoney(cents, config.currency)}` : 'Included';
        }

        const tierButtons = [...root.querySelectorAll('[data-tr-choice="tier"]')];
        const params = new URLSearchParams(window.location.search);
        const requestedTier = String(params.get('tier') || '').trim().toLowerCase();
        const requestedVariantId = String(params.get('variant') || '').trim();
        let initialTierButton = tierButtons.find((button) => button.dataset.tierSlug === requestedTier);

        if (!initialTierButton && requestedVariantId) {
          initialTierButton = tierButtons.find((button) => String(button.dataset.variantId) === requestedVariantId);
        }

        if (!initialTierButton) {
          const checkedTier = bundleInputs.find((input) => input.checked);
          initialTierButton = tierButtons.find((button) => button.dataset.value === checkedTier?.value)
            || tierButtons.find((button) => normalize(checkedTier?.value).startsWith(normalize(button.dataset.variantTitle)))
            || null;
        }

        const shouldNormalizeUrl = params.has('tier') || params.has('variant');
        if (initialTierButton && !applyTierSelection(initialTierButton, { updateUrl: shouldNormalizeUrl })) return false;
        if (!initialTierButton) {
          state.tier = '';
          state.tierLabel = '';
          state.tierSlug = '';
          state.variantTitle = '';
          state.variantId = '';
          setActive('tier', '');
        }

        hideSourceControls();
        updateSummary();
        root.dataset.trInitialized = 'true';
        return true;
      }

      root.querySelectorAll('[data-tr-choice="tier"]').forEach((button) => {
        button.addEventListener('click', () => selectTier(button));
      });
      root.querySelectorAll('[data-tr-choice="controller"]').forEach((button) => {
        button.addEventListener('click', () => selectController(button));
      });
      root.querySelectorAll('[data-tr-choice="send-in"]').forEach((button) => {
        button.addEventListener('click', () => selectSendIn(button));
      });
      details?.addEventListener('input', syncDetails);
      agreement?.addEventListener('change', syncAgreement);
      submit?.addEventListener('click', submitOriginalForm);

      syncSummaryDisclosure();
      if (mobileSummaryQuery.addEventListener) mobileSummaryQuery.addEventListener('change', syncSummaryDisclosure);
      else mobileSummaryQuery.addListener(syncSummaryDisclosure);

      let attempts = 0;
      const connectionTimer = window.setInterval(() => {
        attempts += 1;
        if (connectToInfiniteOptions()) {
          window.clearInterval(connectionTimer);
        } else if (attempts >= 120) {
          window.clearInterval(connectionTimer);
          setStatus('The bundle options did not load. Refresh this page before ordering.');
        }
      }, 100);

      root.addEventListener('shopify:block:select', updateSummary);
      root._trBundleCleanup = () => {
        window.clearInterval(connectionTimer);
        if (mobileSummaryQuery.removeEventListener) mobileSummaryQuery.removeEventListener('change', syncSummaryDisclosure);
        else mobileSummaryQuery.removeListener(syncSummaryDisclosure);
      };
    }

    function initAll(scope = document) {
      if (scope.matches?.(ROOT_SELECTOR)) initBundleBuilder(scope);
      scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initBundleBuilder);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll?.(ROOT_SELECTOR).forEach((root) => root._trBundleCleanup?.());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["techrevive-bundle-builder-v5"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ROOT_SELECTOR = '[data-tr-bundle-builder-v4]';
    const BENCH_PROPERTY = 'properties[bench fee agreement]';

    const normalize = (value) => String(value || '').trim().toUpperCase();

    function dispatchValueEvents(element) {
      element.dispatchEvent(new Event('input', { bubbles: true }));
      element.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function parseAddedPrice(label) {
      const match = String(label || '').match(/\$\s*([0-9]+(?:\.[0-9]{1,2})?)/);
      return match ? Math.round(Number(match[1]) * 100) : 0;
    }

    function formatMoney(cents, currency) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: currency || 'USD'
        }).format((Number(cents) || 0) / 100);
      } catch (error) {
        return `$${((Number(cents) || 0) / 100).toFixed(2)}`;
      }
    }

    function sourceBlockFor(element, form) {
      if (!element) return null;
      let node = element.parentElement;
      let fallback = element.parentElement;

      while (node && node !== form && node !== document.body) {
        const propertyFields = [...node.querySelectorAll('[name^="properties["]')];
        const uniqueNames = [...new Set(propertyFields.map((field) => field.name).filter(Boolean))];
        const hasAppLabel = node.querySelector('.spb-label-tooltip, fieldset, legend');

        if (propertyFields.length && uniqueNames.length === 1) fallback = node;
        if (propertyFields.length && uniqueNames.length === 1 && hasAppLabel) return node;
        node = node.parentElement;
      }

      return fallback;
    }

    function initBundleBuilder(root) {
      if (!root || root.dataset.trInitialized === 'true') return;

      const configElement = root.querySelector('[data-tr-bundle-config]');
      if (!configElement) return;

      let config;
      try {
        config = JSON.parse(configElement.textContent);
      } catch (error) {
        return;
      }

      const submit = root.querySelector('[data-tr-submit]');
      const submitLabel = root.querySelector('[data-tr-submit-label]');
      const status = root.querySelector('[data-tr-status]');
      const total = root.querySelector('[data-tr-total]');
      const details = root.querySelector('[data-tr-details]');
      const agreement = root.querySelector('[data-tr-agreement]');
      const characterCount = root.querySelector('[data-tr-character-count]');
      const kitPrice = root.querySelector('[data-tr-kit-price]');
      const summaryDetails = root.querySelector('[data-tr-summary-details]');
      const mobileSummaryQuery = window.matchMedia('(max-width: 680px)');

      const state = {
        tier: '',
        tierLabel: '',
        tierSlug: '',
        variantTitle: '',
        variantId: '',
        controller: '',
        controllerLabel: '',
        sendIn: '',
        sendInLabel: '',
        agreement: false
      };

      let source = null;

      function setStatus(message) {
        if (status) status.textContent = message || '';
      }

      function setSummary(key, value) {
        const target = root.querySelector(`[data-tr-summary="${key}"]`);
        if (target) target.textContent = value;
      }

      function setSummaryPrice(key, value) {
        const target = root.querySelector(`[data-tr-summary-price="${key}"]`);
        if (target) target.textContent = value;
      }

      function syncSummaryDisclosure() {
        if (!summaryDetails) return;
        summaryDetails.open = !mobileSummaryQuery.matches;
      }

      function setActive(group, value) {
        root.querySelectorAll(`[data-tr-choice="${group}"]`).forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.value === value));
        });
      }

      function clearError(group) {
        const wrapper = root.querySelector(`[data-tr-group="${group}"]`);
        const error = root.querySelector(`[data-tr-error="${group}"]`);
        if (wrapper) wrapper.removeAttribute('aria-invalid');
        if (error) error.textContent = '';
      }

      function showError(group, message) {
        const wrapper = root.querySelector(`[data-tr-group="${group}"]`);
        const error = root.querySelector(`[data-tr-error="${group}"]`);
        if (wrapper) wrapper.setAttribute('aria-invalid', 'true');
        if (error) error.textContent = message;
      }

      function selectedVariant() {
        return (config.variants || []).find((variant) => String(variant.id) === String(state.variantId))
          || (config.variants || []).find((variant) => normalize(variant.title) === normalize(state.variantTitle))
          || (config.variants || [])[0]
          || null;
      }

      function fallbackTotal() {
        const variant = selectedVariant();
        const base = variant ? Number(variant.price) || 0 : 0;
        const mailIn = /MAIL-IN KIT/i.test(state.sendIn) ? parseAddedPrice(state.sendIn) : 0;
        return formatMoney(base + mailIn, config.currency || root.dataset.currency);
      }

      function updatePrice() {
        if (!total) return;
        total.textContent = state.tier ? fallbackTotal() : 'Pending';
      }

      function missingConfiguration() {
        const missing = [];
        if (!state.tier) missing.push('bundle tier');
        if (!state.controller) missing.push('controller');
        if (!state.sendIn) missing.push('mail in method');
        if (!state.agreement) missing.push('bench fee agreement');
        return missing;
      }

      function updateSubmitState() {
        if (!submit) return;
        const missing = missingConfiguration();
        const ready = Boolean(source) && missing.length === 0;
        submit.disabled = !ready;
        submit.setAttribute('aria-disabled', String(!ready));

        if (submit.getAttribute('aria-busy') === 'true') return;
        if (!source) {
          setStatus('Loading bundle options.');
        } else if (ready) {
          setStatus('Your bundle configuration is complete and ready to add to the cart.');
        } else {
          setStatus(`Complete ${missing.join(', ')} to continue.`);
        }
      }

      function updateSummary() {
        const variant = selectedVariant();
        setSummary('tier', state.tierLabel || 'Select a tier');
        setSummary('controller', state.controllerLabel || 'Select a controller');
        setSummary('send-in', state.sendInLabel || 'Select a method');
        setSummaryPrice('tier', state.tier && variant ? formatMoney(variant.price, config.currency) : 'Pending');
        setSummaryPrice('send-in', !state.sendIn ? 'Pending' : /MAIL-IN KIT/i.test(state.sendIn) ? formatMoney(parseAddedPrice(state.sendIn), config.currency) : 'Included');
        updatePrice();
        updateSubmitState();
      }

      function findTierOption(button) {
        const exactValue = button.dataset.value;
        const variantTitle = normalize(button.dataset.variantTitle);
        return source.bundleInputs.find((input) => input.value === exactValue)
          || source.bundleInputs.find((input) => normalize(input.value).startsWith(variantTitle));
      }

      function syncNativeVariant(variant) {
        if (!variant || !source?.variantControls?.length) return;
        const variantId = String(variant.id);

        source.variantControls.forEach((control) => {
          if (control.matches('input[type="radio"], input[type="checkbox"]')) {
            const shouldCheck = String(control.value) === variantId;
            if (control.checked !== shouldCheck) {
              control.checked = shouldCheck;
              if (shouldCheck) dispatchValueEvents(control);
            }
            return;
          }

          if (String(control.value) !== variantId) {
            control.value = variantId;
            dispatchValueEvents(control);
          }
        });
      }

      function updateTierAddress() {
        if (!state.tierSlug || !state.variantId) return;
        const url = new URL(window.location.href);
        url.searchParams.set('tier', state.tierSlug);
        url.searchParams.set('variant', state.variantId);
        window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
      }

      function applyTierSelection(button, { updateUrl = true } = {}) {
        if (!source || !button) return false;
        const option = findTierOption(button);
        if (!option) {
          showError('tier', 'This bundle tier could not be connected. Refresh the page and try again.');
          return false;
        }

        if (!option.checked) option.click();

        const variant = (config.variants || []).find((item) => String(item.id) === String(button.dataset.variantId))
          || (config.variants || []).find((item) => normalize(item.title) === normalize(button.dataset.variantTitle));

        if (!variant) {
          showError('tier', 'The Shopify variant for this bundle tier could not be found.');
          return false;
        }

        state.tier = button.dataset.value;
        state.tierLabel = button.querySelector('.tr-bundle-builder-v4__choice-name')?.textContent.trim() || button.dataset.value;
        state.tierSlug = button.dataset.tierSlug || state.tierLabel.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        state.variantTitle = button.dataset.variantTitle;
        state.variantId = String(variant.id);
        syncNativeVariant(variant);
        setActive('tier', state.tier);
        clearError('tier');
        updateSummary();
        if (updateUrl) updateTierAddress();
        window.requestAnimationFrame(updatePrice);
        window.setTimeout(updatePrice, 120);
        return true;
      }

      function selectTier(button) {
        applyTierSelection(button, { updateUrl: true });
      }

      function selectController(button) {
        if (!source?.controller) return;
        source.controller.value = button.dataset.value;
        dispatchValueEvents(source.controller);

        state.controller = button.dataset.value;
        state.controllerLabel = button.dataset.label || button.textContent.trim();
        setActive('controller', state.controller);
        clearError('controller');
        updateSummary();
      }

      function selectSendIn(button) {
        if (!source?.sendIn) return;
        source.sendIn.value = button.dataset.value;
        dispatchValueEvents(source.sendIn);

        state.sendIn = button.dataset.value;
        state.sendInLabel = button.dataset.label || button.textContent.trim();
        setActive('send-in', state.sendIn);
        clearError('send-in');
        updateSummary();
        window.setTimeout(updatePrice, 180);
      }

      function syncDetails() {
        if (!source?.details || !details) return;
        source.details.value = details.value;
        dispatchValueEvents(source.details);
        if (characterCount) characterCount.textContent = details.value.length;
        updateSummary();
      }

      function syncAgreement() {
        if (!source || !agreement) return;
        const checked = agreement.checked;
        const agreementValue = source.benchCopy || source.benchCheckbox?.value || '';

        if (source.benchCheckbox) {
          source.benchCheckbox.checked = checked;
          dispatchValueEvents(source.benchCheckbox);
        }

        source.benchHidden.value = checked ? agreementValue : '';
        dispatchValueEvents(source.benchHidden);

        state.agreement = checked;
        if (checked) clearError('agreement');
        updateSummary();
      }

      function validate() {
        let firstInvalid = null;

        if (!state.tier) {
          showError('tier', 'Choose a bundle tier.');
          firstInvalid ||= 'tier';
        }
        if (!state.controller) {
          showError('controller', 'Choose the controller you are sending.');
          firstInvalid ||= 'controller';
        }
        if (!state.sendIn) {
          showError('send-in', 'Choose Self-Ship or the Mail-In Kit.');
          firstInvalid ||= 'send-in';
        }
        if (!state.agreement) {
          showError('agreement', 'Accept the bench fee terms to continue.');
          firstInvalid ||= 'agreement';
        }

        if (firstInvalid) {
          root.querySelector(`[data-tr-group="${firstInvalid}"]`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          root.querySelector(`[data-tr-group="${firstInvalid}"] button, [data-tr-group="${firstInvalid}"] input`)?.focus({ preventScroll: true });
          updateSubmitState();
          return false;
        }
        return true;
      }

      function submitOriginalForm() {
        if (!source || !validate()) return;
        syncDetails();
        syncAgreement();

        submit.disabled = true;
        submit.setAttribute('aria-disabled', 'true');
        submit.setAttribute('aria-busy', 'true');
        if (submitLabel) submitLabel.textContent = 'Adding to cart';
        setStatus('Adding your configured bundle...');

        source.addButton.click();

        window.setTimeout(() => {
          submit.removeAttribute('aria-busy');
          if (submitLabel) submitLabel.textContent = 'Add bundle to cart';
          updateSubmitState();
        }, 1800);
      }

      function hideSourceControls() {
        const conceal = (element, className) => {
          if (!element) return;
          element.classList.add(className);
          element.setAttribute('aria-hidden', 'true');
          const selector = 'a[href], button, input, select, textarea, [tabindex]';
          const focusables = [
            ...(element.matches?.(selector) ? [element] : []),
            ...(element.querySelectorAll?.(selector) || [])
          ];
          focusables.forEach((focusable) => focusable.setAttribute('tabindex', '-1'));
        };

        const propertyElements = [
          ...source.bundleInputs,
          source.controller,
          source.details,
          source.sendIn,
          source.benchHidden
        ].filter(Boolean);

        propertyElements.forEach((element) => {
          conceal(sourceBlockFor(element, source.form), 'tr-bundle-builder-v4-source-control');
        });

        const benchFieldset = source.benchHidden?.closest('fieldset');
        const completeBenchBlock = benchFieldset?.parentElement?.parentElement;
        conceal(completeBenchBlock, 'tr-bundle-builder-v4-source-control');

        source.variantControls.forEach((control) => {
          const variantWrapper = control.closest(
            'variant-selects, variant-radios, variant-picker, product-variant-picker, [data-variant-picker], .product-form__input'
          );
          if (variantWrapper && variantWrapper !== source.form) {
            conceal(variantWrapper, 'tr-bundle-builder-v4-source-variant');
          }
        });

        const productScope = source.form.closest(
          'product-info, product-information, [data-product-id], .product__info-container'
        );
        productScope?.querySelectorAll(
          'variant-selects, variant-radios, variant-picker, product-variant-picker, [data-variant-picker], quantity-input, .product-form__quantity, [data-quantity-selector], price-display, [data-product-price]'
        ).forEach((element) => conceal(element, 'tr-bundle-builder-v4-source-variant'));

        conceal(source.price, 'tr-bundle-builder-v4-source-price');

        document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
          const productId = form.querySelector('input[name="product-id"]')?.value;
          if (String(productId) !== String(config.productId)) return;
          form.querySelectorAll('button[name="add"], button[type="submit"]').forEach((button) => {
            conceal(button, 'tr-bundle-builder-v4-source-submit');
          });
        });
      }

      function connectToInfiniteOptions() {
        const controllers = [...document.querySelectorAll('select[name="properties[CONTROLLER TYPE]"]')];
        const controller = controllers.find((element) => {
          const formProductId = element.form?.querySelector('input[name="product-id"]')?.value;
          return String(formProductId) === String(config.productId);
        }) || controllers[0];
        const form = controller?.form;
        if (!controller || !form) return false;

        const bundleInputs = [...document.querySelectorAll('input[name="properties[Bundle Selection]"]')]
          .filter((input) => input.form === form);
        const detailsSource = [...document.querySelectorAll('textarea[name="properties[_Controller Details]"]')]
          .find((element) => element.form === form);
        const sendIn = [...document.querySelectorAll('select[name="properties[Send-in]"]')]
          .find((element) => element.form === form);
        const benchHidden = [...document.querySelectorAll(`input[name="${BENCH_PROPERTY}"]`)]
          .find((element) => element.form === form);
        const addButton = form.querySelector('button[name="add"], button[type="submit"]');
        const variantControls = [...document.querySelectorAll('[name="id"]')]
          .filter((element) => element.form === form);

        if (bundleInputs.length !== 3 || !detailsSource || !sendIn || !benchHidden || !addButton || !variantControls.length) return false;

        const benchFieldset = benchHidden.closest('fieldset');
        const benchCheckbox = benchFieldset?.querySelector('input[type="checkbox"]') || null;
        const price = document.querySelector('.infiniteoptions-price');
        const benchCopyTarget = root.querySelector('[data-tr-bench-copy]');
        const benchCopy = benchCopyTarget?.textContent.replace(/\s+/g, ' ').trim() || '';

        source = {
          form,
          bundleInputs,
          controller,
          details: detailsSource,
          sendIn,
          benchHidden,
          benchCheckbox,
          benchCopy,
          addButton,
          price,
          variantControls
        };

        if (benchCheckbox && benchCopy) benchCheckbox.value = benchCopy;

        if (controller.value) {
          const controllerButton = [...root.querySelectorAll('[data-tr-choice="controller"]')]
            .find((button) => button.dataset.value === controller.value);
          if (controllerButton) {
            state.controller = controllerButton.dataset.value;
            state.controllerLabel = controllerButton.dataset.label || controllerButton.textContent.trim();
            setActive('controller', state.controller);
          }
        }

        if (sendIn.value) {
          const sendButton = [...root.querySelectorAll('[data-tr-choice="send-in"]')]
            .find((button) => button.dataset.value === sendIn.value);
          if (sendButton) {
            state.sendIn = sendButton.dataset.value;
            state.sendInLabel = sendButton.dataset.label || sendButton.textContent.trim();
            setActive('send-in', state.sendIn);
          }
        }

        if (detailsSource.value && details) {
          details.value = detailsSource.value;
          if (characterCount) characterCount.textContent = details.value.length;
        }

        state.agreement = Boolean(benchHidden.value);
        if (agreement) agreement.checked = state.agreement;

        const mailInOption = [...sendIn.options].find((option) => /MAIL-IN KIT/i.test(option.value));
        if (mailInOption && kitPrice) {
          const cents = parseAddedPrice(mailInOption.value);
          kitPrice.textContent = cents ? `+${formatMoney(cents, config.currency)}` : 'Included';
        }

        const tierButtons = [...root.querySelectorAll('[data-tr-choice="tier"]')];
        const params = new URLSearchParams(window.location.search);
        const requestedTier = String(params.get('tier') || '').trim().toLowerCase();
        const requestedVariantId = String(params.get('variant') || '').trim();
        let initialTierButton = tierButtons.find((button) => button.dataset.tierSlug === requestedTier);

        if (!initialTierButton && requestedVariantId) {
          initialTierButton = tierButtons.find((button) => String(button.dataset.variantId) === requestedVariantId);
        }

        if (!initialTierButton) {
          const checkedTier = bundleInputs.find((input) => input.checked);
          initialTierButton = tierButtons.find((button) => button.dataset.value === checkedTier?.value)
            || tierButtons.find((button) => normalize(checkedTier?.value).startsWith(normalize(button.dataset.variantTitle)))
            || null;
        }

        const shouldNormalizeUrl = params.has('tier') || params.has('variant');
        if (initialTierButton && !applyTierSelection(initialTierButton, { updateUrl: shouldNormalizeUrl })) return false;
        if (!initialTierButton) {
          state.tier = '';
          state.tierLabel = '';
          state.tierSlug = '';
          state.variantTitle = '';
          state.variantId = '';
          setActive('tier', '');
        }

        hideSourceControls();
        updateSummary();
        root.dataset.trInitialized = 'true';
        return true;
      }

      root.querySelectorAll('[data-tr-choice="tier"]').forEach((button) => {
        button.addEventListener('click', () => selectTier(button));
      });
      root.querySelectorAll('[data-tr-choice="controller"]').forEach((button) => {
        button.addEventListener('click', () => selectController(button));
      });
      root.querySelectorAll('[data-tr-choice="send-in"]').forEach((button) => {
        button.addEventListener('click', () => selectSendIn(button));
      });
      details?.addEventListener('input', syncDetails);
      agreement?.addEventListener('change', syncAgreement);
      submit?.addEventListener('click', submitOriginalForm);

      syncSummaryDisclosure();
      if (mobileSummaryQuery.addEventListener) mobileSummaryQuery.addEventListener('change', syncSummaryDisclosure);
      else mobileSummaryQuery.addListener(syncSummaryDisclosure);

      let attempts = 0;
      const connectionTimer = window.setInterval(() => {
        attempts += 1;
        if (connectToInfiniteOptions()) {
          window.clearInterval(connectionTimer);
        } else if (attempts >= 120) {
          window.clearInterval(connectionTimer);
          setStatus('The bundle options did not load. Refresh this page before ordering.');
        }
      }, 100);

      root.addEventListener('shopify:block:select', updateSummary);
      root._trBundleCleanup = () => {
        window.clearInterval(connectionTimer);
        if (mobileSummaryQuery.removeEventListener) mobileSummaryQuery.removeEventListener('change', syncSummaryDisclosure);
        else mobileSummaryQuery.removeListener(syncSummaryDisclosure);
      };
    }

    function initAll(scope = document) {
      if (scope.matches?.(ROOT_SELECTOR)) initBundleBuilder(scope);
      scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initBundleBuilder);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll?.(ROOT_SELECTOR).forEach((root) => root._trBundleCleanup?.());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["techrevive-bundle-builder-v6"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ROOT_SELECTOR = '[data-tr-bundle-builder-v4]';
    const BENCH_PROPERTY = 'properties[bench fee agreement]';

    const normalize = (value) => String(value || '').trim().toUpperCase();

    function dispatchValueEvents(element) {
      element.dispatchEvent(new Event('input', { bubbles: true }));
      element.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function parseAddedPrice(label) {
      const match = String(label || '').match(/\$\s*([0-9]+(?:\.[0-9]{1,2})?)/);
      return match ? Math.round(Number(match[1]) * 100) : 0;
    }

    function formatMoney(cents, currency) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: currency || 'USD'
        }).format((Number(cents) || 0) / 100);
      } catch (error) {
        return `$${((Number(cents) || 0) / 100).toFixed(2)}`;
      }
    }

    function sourceBlockFor(element, form) {
      if (!element) return null;
      let node = element.parentElement;
      let fallback = element.parentElement;

      while (node && node !== form && node !== document.body) {
        const propertyFields = [...node.querySelectorAll('[name^="properties["]')];
        const uniqueNames = [...new Set(propertyFields.map((field) => field.name).filter(Boolean))];
        const hasAppLabel = node.querySelector('.spb-label-tooltip, fieldset, legend');

        if (propertyFields.length && uniqueNames.length === 1) fallback = node;
        if (propertyFields.length && uniqueNames.length === 1 && hasAppLabel) return node;
        node = node.parentElement;
      }

      return fallback;
    }

    function initBundleBuilder(root) {
      if (!root || root.dataset.trInitialized === 'true') return;

      const configElement = root.querySelector('[data-tr-bundle-config]');
      if (!configElement) return;

      let config;
      try {
        config = JSON.parse(configElement.textContent);
      } catch (error) {
        return;
      }

      const submit = root.querySelector('[data-tr-submit]');
      const submitLabel = root.querySelector('[data-tr-submit-label]');
      const status = root.querySelector('[data-tr-status]');
      const total = root.querySelector('[data-tr-total]');
      const details = root.querySelector('[data-tr-details]');
      const agreement = root.querySelector('[data-tr-agreement]');
      const characterCount = root.querySelector('[data-tr-character-count]');
      const kitPrice = root.querySelector('[data-tr-kit-price]');
      const summaryDetails = root.querySelector('[data-tr-summary-details]');
      const mobileSummaryQuery = window.matchMedia('(max-width: 680px)');

      const state = {
        tier: '',
        tierLabel: '',
        tierSlug: '',
        variantTitle: '',
        variantId: '',
        controller: '',
        controllerLabel: '',
        sendIn: '',
        sendInLabel: '',
        agreement: false
      };

      let source = null;

      function setStatus(message) {
        if (status) status.textContent = message || '';
      }

      function setSummary(key, value) {
        const target = root.querySelector(`[data-tr-summary="${key}"]`);
        if (target) target.textContent = value;
      }

      function setSummaryPrice(key, value) {
        const target = root.querySelector(`[data-tr-summary-price="${key}"]`);
        if (target) target.textContent = value;
      }

      function syncSummaryDisclosure() {
        if (!summaryDetails) return;
        summaryDetails.open = !mobileSummaryQuery.matches;
      }

      function setActive(group, value) {
        root.querySelectorAll(`[data-tr-choice="${group}"]`).forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.value === value));
        });
      }

      function clearError(group) {
        const wrapper = root.querySelector(`[data-tr-group="${group}"]`);
        const error = root.querySelector(`[data-tr-error="${group}"]`);
        if (wrapper) wrapper.removeAttribute('aria-invalid');
        if (error) error.textContent = '';
      }

      function showError(group, message) {
        const wrapper = root.querySelector(`[data-tr-group="${group}"]`);
        const error = root.querySelector(`[data-tr-error="${group}"]`);
        if (wrapper) wrapper.setAttribute('aria-invalid', 'true');
        if (error) error.textContent = message;
      }

      function selectedVariant() {
        return (config.variants || []).find((variant) => String(variant.id) === String(state.variantId))
          || (config.variants || []).find((variant) => normalize(variant.title) === normalize(state.variantTitle))
          || (config.variants || [])[0]
          || null;
      }

      function fallbackTotal() {
        const variant = selectedVariant();
        const base = variant ? Number(variant.price) || 0 : 0;
        const mailIn = /MAIL-IN KIT/i.test(state.sendIn) ? parseAddedPrice(state.sendIn) : 0;
        return formatMoney(base + mailIn, config.currency || root.dataset.currency);
      }

      function updatePrice() {
        if (!total) return;
        total.textContent = state.tier ? fallbackTotal() : 'Pending';
      }

      function missingConfiguration() {
        const missing = [];
        if (!state.tier) missing.push('bundle tier');
        if (!state.controller) missing.push('controller');
        if (!state.sendIn) missing.push('mail in method');
        if (!state.agreement) missing.push('bench fee agreement');
        return missing;
      }

      function updateSubmitState() {
        if (!submit) return;
        const missing = missingConfiguration();
        const ready = Boolean(source) && missing.length === 0;
        submit.disabled = !ready;
        submit.setAttribute('aria-disabled', String(!ready));

        if (submit.getAttribute('aria-busy') === 'true') return;
        if (!source) {
          setStatus('Loading bundle options.');
        } else if (ready) {
          setStatus('Your bundle configuration is complete and ready to add to the cart.');
        } else {
          setStatus(`Complete ${missing.join(', ')} to continue.`);
        }
      }

      function updateSummary() {
        const variant = selectedVariant();
        setSummary('tier', state.tierLabel || 'Select a tier');
        setSummary('controller', state.controllerLabel || 'Select a controller');
        setSummary('send-in', state.sendInLabel || 'Select a method');
        setSummaryPrice('tier', state.tier && variant ? formatMoney(variant.price, config.currency) : 'Pending');
        setSummaryPrice('send-in', !state.sendIn ? 'Pending' : /MAIL-IN KIT/i.test(state.sendIn) ? formatMoney(parseAddedPrice(state.sendIn), config.currency) : 'Included');
        updatePrice();
        updateSubmitState();
      }

      function findTierOption(button) {
        const exactValue = button.dataset.value;
        const variantTitle = normalize(button.dataset.variantTitle);
        return source.bundleInputs.find((input) => input.value === exactValue)
          || source.bundleInputs.find((input) => normalize(input.value).startsWith(variantTitle));
      }

      function syncNativeVariant(variant) {
        if (!variant || !source?.variantControls?.length) return;
        const variantId = String(variant.id);

        source.variantControls.forEach((control) => {
          if (control.matches('input[type="radio"], input[type="checkbox"]')) {
            const shouldCheck = String(control.value) === variantId;
            if (control.checked !== shouldCheck) {
              control.checked = shouldCheck;
              if (shouldCheck) dispatchValueEvents(control);
            }
            return;
          }

          if (String(control.value) !== variantId) {
            control.value = variantId;
            dispatchValueEvents(control);
          }
        });
      }

      function updateTierAddress() {
        if (!state.tierSlug || !state.variantId) return;
        const url = new URL(window.location.href);
        url.searchParams.set('tier', state.tierSlug);
        url.searchParams.set('variant', state.variantId);
        window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
      }

      function applyTierSelection(button, { updateUrl = true } = {}) {
        if (!source || !button) return false;
        const option = findTierOption(button);
        if (!option) {
          showError('tier', 'This bundle tier could not be connected. Refresh the page and try again.');
          return false;
        }

        if (!option.checked) option.click();

        const variant = (config.variants || []).find((item) => String(item.id) === String(button.dataset.variantId))
          || (config.variants || []).find((item) => normalize(item.title) === normalize(button.dataset.variantTitle));

        if (!variant) {
          showError('tier', 'The Shopify variant for this bundle tier could not be found.');
          return false;
        }

        state.tier = button.dataset.value;
        state.tierLabel = button.querySelector('.tr-bundle-builder-v4__choice-name')?.textContent.trim() || button.dataset.value;
        state.tierSlug = button.dataset.tierSlug || state.tierLabel.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        state.variantTitle = button.dataset.variantTitle;
        state.variantId = String(variant.id);
        syncNativeVariant(variant);
        setActive('tier', state.tier);
        clearError('tier');
        updateSummary();
        if (updateUrl) updateTierAddress();
        window.requestAnimationFrame(updatePrice);
        window.setTimeout(updatePrice, 120);
        return true;
      }

      function selectTier(button) {
        applyTierSelection(button, { updateUrl: true });
      }

      function selectController(button) {
        if (!source?.controller) return;
        source.controller.value = button.dataset.value;
        dispatchValueEvents(source.controller);

        state.controller = button.dataset.value;
        state.controllerLabel = button.dataset.label || button.textContent.trim();
        setActive('controller', state.controller);
        clearError('controller');
        updateSummary();
      }

      function selectSendIn(button) {
        if (!source?.sendIn) return;
        source.sendIn.value = button.dataset.value;
        dispatchValueEvents(source.sendIn);

        state.sendIn = button.dataset.value;
        state.sendInLabel = button.dataset.label || button.textContent.trim();
        setActive('send-in', state.sendIn);
        clearError('send-in');
        updateSummary();
        window.setTimeout(updatePrice, 180);
      }

      function syncDetails() {
        if (!source?.details || !details) return;
        source.details.value = details.value;
        dispatchValueEvents(source.details);
        if (characterCount) characterCount.textContent = details.value.length;
        updateSummary();
      }

      function syncAgreement() {
        if (!source || !agreement) return;
        const checked = agreement.checked;
        const agreementValue = source.benchCopy || source.benchCheckbox?.value || '';

        if (source.benchCheckbox) {
          source.benchCheckbox.checked = checked;
          dispatchValueEvents(source.benchCheckbox);
        }

        source.benchHidden.value = checked ? agreementValue : '';
        dispatchValueEvents(source.benchHidden);

        state.agreement = checked;
        if (checked) clearError('agreement');
        updateSummary();
      }

      function validate() {
        let firstInvalid = null;

        if (!state.tier) {
          showError('tier', 'Choose a bundle tier.');
          firstInvalid ||= 'tier';
        }
        if (!state.controller) {
          showError('controller', 'Choose the controller you are sending.');
          firstInvalid ||= 'controller';
        }
        if (!state.sendIn) {
          showError('send-in', 'Choose Self-Ship or the Mail-In Kit.');
          firstInvalid ||= 'send-in';
        }
        if (!state.agreement) {
          showError('agreement', 'Accept the bench fee terms to continue.');
          firstInvalid ||= 'agreement';
        }

        if (firstInvalid) {
          root.querySelector(`[data-tr-group="${firstInvalid}"]`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          root.querySelector(`[data-tr-group="${firstInvalid}"] button, [data-tr-group="${firstInvalid}"] input`)?.focus({ preventScroll: true });
          updateSubmitState();
          return false;
        }
        return true;
      }

      async function submitOriginalForm() {
        if (!source || !validate()) return;
        syncDetails();
        syncAgreement();

        submit.disabled = true;
        submit.setAttribute('aria-disabled', 'true');
        submit.setAttribute('aria-busy', 'true');
        if (submitLabel) submitLabel.textContent = 'Adding to cart';
        setStatus('Adding your configured bundle...');

        try {
          if (!window.TechReviveNativeCart?.addConfiguration) {
            throw new Error('The native cart service did not load. Refresh the page and try again.');
          }

          const addOns = /MAIL-IN KIT/i.test(state.sendIn)
            ? [{ variantTitle: 'Mail-In Kit', label: 'Mail-In Kit' }]
            : [];

          await window.TechReviveNativeCart.addConfiguration({
            root,
            productId: config.productId,
            parentVariantId: state.variantId,
            addonVariants: config.addonVariants,
            serviceLabel: `Performance Upgrade Bundle - ${state.tierLabel}`,
            parentProperties: {
              'Bundle Selection': state.tier,
              'CONTROLLER TYPE': state.controller,
              '_Controller Details': details?.value.trim(),
              'Bench Fee Agreement': 'Accepted'
            },
            addOns
          });
          setStatus('Your configured bundle was added to the cart.');
        } catch (error) {
          console.error(error);
          setStatus(error?.message || 'The bundle could not be added. Refresh the page and try again.');
        } finally {
          submit.removeAttribute('aria-busy');
          if (submitLabel) submitLabel.textContent = 'Add bundle to cart';
          updateSubmitState();
        }
      }

      function hideSourceControls() {
        const conceal = (element, className) => {
          if (!element) return;
          element.classList.add(className);
          element.setAttribute('aria-hidden', 'true');
          const selector = 'a[href], button, input, select, textarea, [tabindex]';
          const focusables = [
            ...(element.matches?.(selector) ? [element] : []),
            ...(element.querySelectorAll?.(selector) || [])
          ];
          focusables.forEach((focusable) => focusable.setAttribute('tabindex', '-1'));
        };

        const propertyElements = [
          ...source.bundleInputs,
          source.controller,
          source.details,
          source.sendIn,
          source.benchHidden
        ].filter(Boolean);

        propertyElements.forEach((element) => {
          conceal(sourceBlockFor(element, source.form), 'tr-bundle-builder-v4-source-control');
        });

        conceal(source.container, 'tr-bundle-builder-v4-source-control');
        source.container.inert = true;

        const benchFieldset = source.benchHidden?.closest('fieldset');
        const completeBenchBlock = benchFieldset?.parentElement?.parentElement;
        conceal(completeBenchBlock, 'tr-bundle-builder-v4-source-control');

        source.variantControls.forEach((control) => {
          const variantWrapper = control.closest(
            'variant-selects, variant-radios, variant-picker, product-variant-picker, [data-variant-picker], .product-form__input'
          );
          if (variantWrapper && variantWrapper !== source.form) {
            conceal(variantWrapper, 'tr-bundle-builder-v4-source-variant');
          }
        });

        const productScope = source.form.closest(
          'product-info, product-information, [data-product-id], .product__info-container'
        );
        productScope?.querySelectorAll(
          'variant-selects, variant-radios, variant-picker, product-variant-picker, [data-variant-picker], quantity-input, .product-form__quantity, [data-quantity-selector], price-display, [data-product-price]'
        ).forEach((element) => conceal(element, 'tr-bundle-builder-v4-source-variant'));

        conceal(source.price, 'tr-bundle-builder-v4-source-price');

        const nativeSection = source.form.closest('.shopify-section');
        if (nativeSection && !nativeSection.contains(root)) {
          nativeSection.classList.add('tr-bundle-builder-v6-native-interface');
          nativeSection.setAttribute('aria-hidden', 'true');
          nativeSection.inert = true;
          nativeSection.querySelectorAll('a[href], button, input, select, textarea, [tabindex]')
            .forEach((element) => element.setAttribute('tabindex', '-1'));
        }

        document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
          const productId = form.querySelector('input[name="product-id"]')?.value;
          if (String(productId) !== String(config.productId)) return;
          form.querySelectorAll('button[name="add"], button[type="submit"]').forEach((button) => {
            conceal(button, 'tr-bundle-builder-v4-source-submit');
          });

          const quickAdd = form.closest(
            'quick-add-modal, .quick-add, [data-sticky-add-to-cart], .sticky-add-to-cart, product-sticky-bar'
          );
          if (quickAdd) {
            quickAdd.classList.add('tr-bundle-builder-v6-quick-add');
            quickAdd.setAttribute('aria-hidden', 'true');
            quickAdd.inert = true;
          }
        });
      }

      function connectToNativeSource() {
        const controllers = [...document.querySelectorAll('select[name="properties[CONTROLLER TYPE]"]')];
        const controller = controllers.find((element) => {
          const formProductId = element.form?.querySelector('input[name="product-id"]')?.value;
          return String(formProductId) === String(config.productId);
        }) || controllers[0];
        const form = controller?.form;
        const container = controller?.closest('[data-tr-native-options-container]');
        if (!controller || !form || !container) return false;

        const bundleInputs = [...container.querySelectorAll('input[name="properties[Bundle Selection]"]')]
          .filter((input) => input.form === form);
        const detailsSource = [...container.querySelectorAll('textarea[name="properties[_Controller Details]"]')]
          .find((element) => element.form === form);
        const sendIn = [...container.querySelectorAll('select[name="properties[Send-in]"]')]
          .find((element) => element.form === form);
        const benchHidden = [...container.querySelectorAll(`input[name="${BENCH_PROPERTY}"]`)]
          .find((element) => element.form === form);
        const addButton = form.querySelector('button[name="add"], button[type="submit"]');
        const variantControls = [...document.querySelectorAll('[name="id"]')]
          .filter((element) => element.form === form);

        if (bundleInputs.length !== 3 || !detailsSource || !sendIn || !benchHidden || !addButton || !variantControls.length) return false;

        const benchFieldset = benchHidden.closest('fieldset');
        const benchCheckbox = benchFieldset?.querySelector('input[type="checkbox"]') || null;
        const price = null;
        const benchCopyTarget = root.querySelector('[data-tr-bench-copy]');
        const benchCopy = benchCopyTarget?.textContent.replace(/\s+/g, ' ').trim() || '';

        source = {
          form,
          container,
          bundleInputs,
          controller,
          details: detailsSource,
          sendIn,
          benchHidden,
          benchCheckbox,
          benchCopy,
          addButton,
          price,
          variantControls
        };

        if (benchCheckbox && benchCopy) benchCheckbox.value = benchCopy;

        if (controller.value) {
          const controllerButton = [...root.querySelectorAll('[data-tr-choice="controller"]')]
            .find((button) => button.dataset.value === controller.value);
          if (controllerButton) {
            state.controller = controllerButton.dataset.value;
            state.controllerLabel = controllerButton.dataset.label || controllerButton.textContent.trim();
            setActive('controller', state.controller);
          }
        }

        if (sendIn.value) {
          const sendButton = [...root.querySelectorAll('[data-tr-choice="send-in"]')]
            .find((button) => button.dataset.value === sendIn.value);
          if (sendButton) {
            state.sendIn = sendButton.dataset.value;
            state.sendInLabel = sendButton.dataset.label || sendButton.textContent.trim();
            setActive('send-in', state.sendIn);
          }
        }

        if (detailsSource.value && details) {
          details.value = detailsSource.value;
          if (characterCount) characterCount.textContent = details.value.length;
        }

        state.agreement = Boolean(benchHidden.value);
        if (agreement) agreement.checked = state.agreement;

        const mailInOption = [...sendIn.options].find((option) => /MAIL-IN KIT/i.test(option.value));
        if (mailInOption && kitPrice) {
          const cents = parseAddedPrice(mailInOption.value);
          kitPrice.textContent = cents ? `+${formatMoney(cents, config.currency)}` : 'Included';
        }

        const tierButtons = [...root.querySelectorAll('[data-tr-choice="tier"]')];
        const params = new URLSearchParams(window.location.search);
        const requestedTier = String(params.get('tier') || '').trim().toLowerCase();
        const requestedVariantId = String(params.get('variant') || '').trim();
        let initialTierButton = tierButtons.find((button) => button.dataset.tierSlug === requestedTier);

        if (!initialTierButton && requestedVariantId) {
          initialTierButton = tierButtons.find((button) => String(button.dataset.variantId) === requestedVariantId);
        }

        if (!initialTierButton) {
          const checkedTier = bundleInputs.find((input) => input.checked);
          initialTierButton = tierButtons.find((button) => button.dataset.value === checkedTier?.value)
            || tierButtons.find((button) => normalize(checkedTier?.value).startsWith(normalize(button.dataset.variantTitle)))
            || null;
        }

        const shouldNormalizeUrl = params.has('tier') || params.has('variant');
        if (initialTierButton && !applyTierSelection(initialTierButton, { updateUrl: shouldNormalizeUrl })) return false;
        if (!initialTierButton) {
          state.tier = '';
          state.tierLabel = '';
          state.tierSlug = '';
          state.variantTitle = '';
          state.variantId = '';
          setActive('tier', '');
        }

        hideSourceControls();
        updateSummary();
        root.dataset.trInitialized = 'true';
        return true;
      }

      root.querySelectorAll('[data-tr-choice="tier"]').forEach((button) => {
        button.addEventListener('click', () => selectTier(button));
      });
      root.querySelectorAll('[data-tr-choice="controller"]').forEach((button) => {
        button.addEventListener('click', () => selectController(button));
      });
      root.querySelectorAll('[data-tr-choice="send-in"]').forEach((button) => {
        button.addEventListener('click', () => selectSendIn(button));
      });
      details?.addEventListener('input', syncDetails);
      agreement?.addEventListener('change', syncAgreement);
      submit?.addEventListener('click', submitOriginalForm);

      syncSummaryDisclosure();
      if (mobileSummaryQuery.addEventListener) mobileSummaryQuery.addEventListener('change', syncSummaryDisclosure);
      else mobileSummaryQuery.addListener(syncSummaryDisclosure);

      let attempts = 0;
      const connectionTimer = window.setInterval(() => {
        attempts += 1;
        if (connectToNativeSource()) {
          window.clearInterval(connectionTimer);
        } else if (attempts >= 120) {
          window.clearInterval(connectionTimer);
          setStatus('The bundle builder did not load. Refresh this page before ordering.');
        }
      }, 100);

      root.addEventListener('shopify:block:select', updateSummary);
      root._trBundleCleanup = () => {
        window.clearInterval(connectionTimer);
        if (mobileSummaryQuery.removeEventListener) mobileSummaryQuery.removeEventListener('change', syncSummaryDisclosure);
        else mobileSummaryQuery.removeListener(syncSummaryDisclosure);
      };
    }

    function initAll(scope = document) {
      if (scope.matches?.(ROOT_SELECTOR)) initBundleBuilder(scope);
      scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initBundleBuilder);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll?.(ROOT_SELECTOR).forEach((root) => root._trBundleCleanup?.());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["techrevive-repair-builder-v10"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ROOT_SELECTOR = '[data-tr-repair-builder]';
    const BENCH_PROPERTY = 'properties[bench fee agreement]';
    const ELIGIBLE_CONTROLLERS = new Set([
      'PS5 DualSense',
      'Xbox Series X|S Controller',
      'Nintendo Switch Pro Controller'
    ]);
    const JOYCON_CONTROLLERS = new Set([
      'Nintendo Switch 2 Joy-Con',
      'Nintendo Switch Joy-Con'
    ]);
    const CONTROLLER_SOURCE_ALIASES = {
      'PS4 DualShock 4': ['PS4 DualShock 4', 'PS4 DualShock'],
      'Xbox Series X|S Controller': ['Xbox Series X|S Controller', 'Xbox Series X/S Controller'],
      'Nintendo Switch Joy-Con': ['Nintendo Switch Joy-Con', 'Nintendo Switch 1 Joy-Con']
    };
    const FALLBACK_FEES = {
      'Hall Effect Upgrade': 3999,
      'TMR Upgrade': 4699,
      mouseclick: 6499,
      paddles: 8999,
      kit: 1999
    };

    function normalizedOption(value) {
      return String(value || '').trim().toLowerCase();
    }

    function dispatchValueEvents(element) {
      element.dispatchEvent(new Event('input', { bubbles: true }));
      element.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function formatMoney(cents, currency) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: currency || 'USD'
        }).format((Number(cents) || 0) / 100);
      } catch (error) {
        return `$${((Number(cents) || 0) / 100).toFixed(2)}`;
      }
    }

    function parseAddedPrice(label) {
      const match = String(label || '').match(/\$\s*([0-9]+(?:\.[0-9]{1,2})?)/);
      return match ? Math.round(Number(match[1]) * 100) : 0;
    }

    function parsePriceSetting(value, fallback) {
      const cleaned = String(value ?? '').replace(/[^0-9.]/g, '');
      if (!cleaned) return fallback;
      const amount = Number(cleaned);
      return Number.isFinite(amount) ? Math.round(amount * 100) : fallback;
    }

    function initRepairBuilder(root) {
      if (!root || root.dataset.trRepairInitialized === 'true') return;

      const configElement = root.querySelector('[data-tr-repair-config]');
      if (!configElement) return;

      let config;
      try {
        config = JSON.parse(configElement.textContent);
      } catch (error) {
        return;
      }

      const controllerSelect = root.querySelector('[data-tr-controller]');
      const problem = root.querySelector('[data-tr-problem]');
      const agreement = root.querySelector('[data-tr-agreement]');
      const submit = root.querySelector('[data-tr-submit]');
      const submitLabel = root.querySelector('[data-tr-submit-label]');
      const status = root.querySelector('[data-tr-status]');
      const total = root.querySelector('[data-tr-total]');
      const characterCount = root.querySelector('[data-tr-character-count]');
      const kitPrice = root.querySelector('[data-tr-kit-price]');
      const joyconPanel = root.querySelector('[data-tr-joycon-panel]');
      const upgradesPanel = root.querySelector('[data-tr-upgrades-panel]');
      const repairOnly = root.querySelector('[data-tr-repair-only]');
      const benchCopyTarget = root.querySelector('[data-tr-bench-copy]');
      const summaryDetails = root.querySelector('[data-tr-summary-details]');
      const mobileSummaryQuery = window.matchMedia('(max-width: 680px)');

      const state = {
        tier: '',
        controller: '',
        joycon: '',
        joystick: '',
        mouseclick: false,
        paddles: false,
        sendIn: '',
        sendInLabel: '',
        kitFee: FALLBACK_FEES.kit,
        agreement: false
      };

      const itemFees = {
        'Hall Effect Upgrade': parsePriceSetting(config.upgradePriceLabels?.['Hall Effect Upgrade'], FALLBACK_FEES['Hall Effect Upgrade']),
        'TMR Upgrade': parsePriceSetting(config.upgradePriceLabels?.['TMR Upgrade'], FALLBACK_FEES['TMR Upgrade']),
        mouseclick: parsePriceSetting(config.upgradePriceLabels?.mouseclick, FALLBACK_FEES.mouseclick),
        paddles: parsePriceSetting(config.upgradePriceLabels?.paddles, FALLBACK_FEES.paddles)
      };

      let source = null;
      let priceObserver = null;
      let connectionTimer = null;
      let restoring = false;

      function setStatus(message) {
        if (status) status.textContent = message || '';
      }

      function setSummary(key, value) {
        const target = root.querySelector(`[data-tr-summary="${key}"]`);
        if (target) target.textContent = value;
      }

      function setSummaryPrice(key, value) {
        const target = root.querySelector(`[data-tr-summary-price="${key}"]`);
        if (target) target.textContent = value;
      }

      function showSummaryRow(key, show) {
        const row = root.querySelector(`[data-tr-summary-row="${key}"]`);
        if (row) row.hidden = !show;
      }

      function setActive(group, value) {
        root.querySelectorAll(`[data-tr-choice="${group}"]`).forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.value === value));
        });
      }

      function setAddonState(key, active) {
        const button = root.querySelector(`[data-tr-addon="${key}"]`);
        const label = root.querySelector(`[data-tr-addon-state="${key}"]`);
        button?.setAttribute('aria-pressed', String(active));
        if (label) label.textContent = active ? 'Added' : 'Add';
      }

      function clearError(group) {
        const wrapper = root.querySelector(`[data-tr-group="${group}"]`);
        const error = root.querySelector(`[data-tr-error="${group}"]`);
        wrapper?.removeAttribute('aria-invalid');
        if (error) error.textContent = '';
      }

      function showError(group, message) {
        const wrapper = root.querySelector(`[data-tr-group="${group}"]`);
        const error = root.querySelector(`[data-tr-error="${group}"]`);
        wrapper?.setAttribute('aria-invalid', 'true');
        if (error) error.textContent = message;
      }

      function selectedSourceRadio(radios) {
        return (radios || []).find((radio) => radio.checked && !radio.disabled) || null;
      }

      function findSelectOption(select, desired) {
        if (!select) return null;
        return [...select.options].find((option) => option.value === desired || option.textContent.trim() === desired) || null;
      }

      function findControllerOption(select, desired) {
        const candidates = CONTROLLER_SOURCE_ALIASES[desired] || [desired];
        return candidates.map((candidate) => findSelectOption(select, candidate)).find(Boolean) || null;
      }

      function canonicalController(value) {
        const match = Object.entries(CONTROLLER_SOURCE_ALIASES).find(([, aliases]) => aliases.includes(value));
        return match?.[0] || value;
      }

      function displaySendInLabel(value) {
        if (/MAIL-IN KIT/i.test(value)) return 'Mail In Kit';
        if (/SELF-SHIP/i.test(value)) return 'Self Ship';
        return value;
      }

      function syncSummaryDisclosure() {
        if (!summaryDetails) return;
        summaryDetails.open = !mobileSummaryQuery.matches;
      }

      function findJoyconRadio(value) {
        if (!source?.container) return null;
        return [...source.container.querySelectorAll('input[type="radio"]')].find((radio) => {
          return radio.value === value && radio.name && /JOY-CON SELECTION/i.test(radio.name) && !radio.disabled;
        }) || null;
      }

      function refreshConditionalSources() {
        if (!source?.container) return;
        source.joystickRadios = [...source.container.querySelectorAll('input[name="properties[Joystick]"][type="radio"]')];
        const upgradesHidden = source.container.querySelector('input[name="properties[Your Upgrades]"]');
        const upgradesFieldset = upgradesHidden?.closest('fieldset');
        const checkboxes = upgradesFieldset ? [...upgradesFieldset.querySelectorAll('input[type="checkbox"]')] : [];
        source.upgradesHidden = upgradesHidden || source.upgradesHidden;
        source.mouseclick = checkboxes.find((input) => input.value === 'Mouse-Click Triggers') || null;
        source.paddles = checkboxes.find((input) => input.value === '4 Back Paddles') || null;
      }

      function fallbackTotal() {
        const variant = selectedVariant();
        let cents = variant ? Number(variant.price) || 0 : Number(config.tierPrices?.[state.tier] ?? config.basePrice) || 0;
        if (!variant && JOYCON_CONTROLLERS.has(state.controller) && state.joycon === 'Pair of Joy-Cons') cents += Math.round(cents * 0.8);
        if (!variant && ELIGIBLE_CONTROLLERS.has(state.controller)) {
          cents += itemFees[state.joystick] || 0;
          if (state.mouseclick) cents += itemFees.mouseclick;
          if (state.paddles) cents += itemFees.paddles;
        }
        if (/MAIL-IN KIT/i.test(state.sendIn)) cents += state.kitFee;
        return formatMoney(cents, config.currency || root.dataset.currency);
      }

      function variantOptionValues() {
        let joystick = 'None';
        if (JOYCON_CONTROLLERS.has(state.controller) && state.joycon === 'Pair of Joy-Cons') joystick = 'Joy-Con Pair';
        if (ELIGIBLE_CONTROLLERS.has(state.controller) && state.joystick === 'Hall Effect Upgrade') joystick = 'Hall Effect';
        if (ELIGIBLE_CONTROLLERS.has(state.controller) && state.joystick === 'TMR Upgrade') joystick = 'TMR';

        let additional = 'None';
        if (ELIGIBLE_CONTROLLERS.has(state.controller) && state.mouseclick && state.paddles) additional = 'Mouse-Click Triggers + Four Back Paddles';
        else if (ELIGIBLE_CONTROLLERS.has(state.controller) && state.mouseclick) additional = 'Mouse-Click Triggers';
        else if (ELIGIBLE_CONTROLLERS.has(state.controller) && state.paddles) additional = 'Four Back Paddles';

        return [state.tier, joystick, additional];
      }

      function selectedVariant() {
        const wanted = variantOptionValues().map(normalizedOption);
        return (config.variants || []).find((variant) => {
          const options = (variant.options || []).map(normalizedOption);
          return options.length === wanted.length && options.every((value, index) => value === wanted[index]);
        }) || null;
      }

      function updatePrice() {
        if (!total) return;
        total.textContent = fallbackTotal();
      }

      function missingConfiguration() {
        const missing = [];
        if (!state.tier) missing.push('repair tier');
        if (!state.controller) missing.push('controller');
        if (JOYCON_CONTROLLERS.has(state.controller) && !state.joycon) missing.push('Joy Con quantity');
        if (ELIGIBLE_CONTROLLERS.has(state.controller) && !state.joystick) missing.push('joystick choice');
        if (!problem?.value.trim()) missing.push('problem description');
        if (!state.sendIn) missing.push('mail in method');
        if (!state.agreement) missing.push('bench fee agreement');
        if (state.tier && state.controller && !selectedVariant()) missing.push('available service configuration');
        return missing;
      }

      function updateSubmitState() {
        if (!submit) return;
        const missing = missingConfiguration();
        const ready = Boolean(source) && missing.length === 0;
        submit.disabled = !ready;
        submit.setAttribute('aria-disabled', String(!ready));
        if (submit.getAttribute('aria-busy') === 'true') return;
        if (!source) {
          setStatus('Loading repair options.');
        } else if (ready) {
          setStatus('Your repair configuration is complete and ready to add to the cart.');
        } else {
          setStatus(`Complete ${missing.join(', ')} to continue.`);
        }
      }

      function updateSummary() {
        const eligible = ELIGIBLE_CONTROLLERS.has(state.controller);
        const joycon = JOYCON_CONTROLLERS.has(state.controller);
        const tierCents = Number(config.tierPrices?.[state.tier] ?? 0) || 0;
        const joystickFee = itemFees[state.joystick] || 0;
        setSummary('tier', state.tier || 'Select a tier');
        setSummary('controller', state.controller || 'Select a controller');
        setSummary('joycon', state.joycon || 'Select one or a pair');
        setSummary('joystick', state.joystick === 'Hall Effect Upgrade' ? 'Hall Effect' : state.joystick === 'TMR Upgrade' ? 'TMR' : 'No upgrade');
        setSummary('mouseclick', state.mouseclick ? 'Added' : 'Not added');
        setSummary('paddles', state.paddles ? 'Added' : 'Not added');
        setSummary('send-in', state.sendInLabel || 'Select a method');
        setSummaryPrice('tier', state.tier ? formatMoney(tierCents, config.currency) : 'Pending');
        setSummaryPrice('joycon', !state.joycon ? 'Pending' : state.joycon === 'Pair of Joy-Cons' ? `Adds ${formatMoney(Math.round(tierCents * 0.8), config.currency)}` : 'Included');
        setSummaryPrice('joystick', formatMoney(joystickFee, config.currency));
        setSummaryPrice('mouseclick', formatMoney(state.mouseclick ? itemFees.mouseclick : 0, config.currency));
        setSummaryPrice('paddles', formatMoney(state.paddles ? itemFees.paddles : 0, config.currency));
        setSummaryPrice('send-in', !state.sendIn ? 'Pending' : /MAIL-IN KIT/i.test(state.sendIn) ? formatMoney(state.kitFee, config.currency) : 'Included');
        showSummaryRow('joycon', joycon && Boolean(state.joycon));
        showSummaryRow('joystick', eligible && (state.joystick === 'Hall Effect Upgrade' || state.joystick === 'TMR Upgrade'));
        showSummaryRow('mouseclick', eligible && state.mouseclick);
        showSummaryRow('paddles', eligible && state.paddles);
        updatePrice();
        updateSubmitState();
      }

      function updateControllerPanels() {
        const eligible = ELIGIBLE_CONTROLLERS.has(state.controller);
        const joycon = JOYCON_CONTROLLERS.has(state.controller);
        if (joyconPanel) joyconPanel.hidden = !joycon;
        if (upgradesPanel) upgradesPanel.hidden = !eligible;
        if (repairOnly) repairOnly.hidden = !state.controller || eligible || joycon;
        setActive('joycon', state.joycon);
        setActive('joystick', state.joystick);
        setAddonState('mouseclick', state.mouseclick);
        setAddonState('paddles', state.paddles);
        updateSummary();
      }

      function chooseSourceRadio(radios, value) {
        const radio = (radios || []).find((input) => input.value === value && !input.disabled);
        if (!radio) return false;
        if (!radio.checked) radio.click();
        return true;
      }

      function restoreConditionalSelections() {
        if (!source || restoring) return;
        restoring = true;
        refreshConditionalSources();

        if (JOYCON_CONTROLLERS.has(state.controller) && state.joycon) {
          const pairRadio = findJoyconRadio(state.joycon);
          if (pairRadio && !pairRadio.checked) pairRadio.click();
        }

        if (ELIGIBLE_CONTROLLERS.has(state.controller)) {
          const desiredJoystick = state.joystick || 'No, Keep My Analogs';
          if (chooseSourceRadio(source.joystickRadios, desiredJoystick)) state.joystick = desiredJoystick;
          if (source.mouseclick && source.mouseclick.checked !== state.mouseclick) source.mouseclick.click();
          if (source.paddles && source.paddles.checked !== state.paddles) source.paddles.click();
        }

        restoring = false;
        updateControllerPanels();
        window.setTimeout(updatePrice, 120);
      }

      function selectTier(button) {
        if (!source) return;
        const value = button.dataset.value;
        if (!chooseSourceRadio(source.tierRadios, value)) {
          showError('tier', 'This repair tier is still loading. Try it again in a moment.');
          return;
        }
        state.tier = value;
        setActive('tier', value);
        clearError('tier');
        updateSummary();
        [80, 260, 650].forEach((delay) => window.setTimeout(restoreConditionalSelections, delay));
      }

      function selectController() {
        if (!source?.controller || !controllerSelect) return;
        const value = controllerSelect.value;
        const option = findControllerOption(source.controller, value);
        if (!option && value) {
          showError('controller', 'This controller choice is not available. Refresh the page and try again.');
          return;
        }

        source.controller.value = option?.value || '';
        dispatchValueEvents(source.controller);
        state.controller = value;
        state.joycon = '';
        state.joystick = '';
        state.mouseclick = false;
        state.paddles = false;
        clearError('controller');
        clearError('joycon');
        clearError('upgrades');
        updateControllerPanels();
        [90, 280, 650].forEach((delay) => window.setTimeout(restoreConditionalSelections, delay));
      }

      function selectJoycon(button) {
        refreshConditionalSources();
        const value = button.dataset.value;
        const radio = findJoyconRadio(value);
        if (!radio) {
          showError('joycon', 'The Joy-Con quantity options are still loading. Try again in a moment.');
          return;
        }
        radio.click();
        state.joycon = value;
        setActive('joycon', value);
        clearError('joycon');
        updateSummary();
        window.setTimeout(updatePrice, 180);
      }

      function selectJoystick(button) {
        refreshConditionalSources();
        const value = button.dataset.value;
        if (!chooseSourceRadio(source.joystickRadios, value)) {
          showError('upgrades', 'The joystick choices are still loading. Try again in a moment.');
          return;
        }
        state.joystick = value;
        setActive('joystick', value);
        clearError('upgrades');
        updateSummary();
        window.setTimeout(updatePrice, 180);
      }

      function toggleAddon(button) {
        refreshConditionalSources();
        const key = button.dataset.trAddon;
        const input = source?.[key];
        if (!input) {
          showError('upgrades', 'This upgrade is still loading. Try again in a moment.');
          return;
        }
        input.click();
        state[key] = input.checked;
        setAddonState(key, state[key]);
        clearError('upgrades');
        updateSummary();
        window.setTimeout(updatePrice, 180);
      }

      function syncProblem() {
        if (!source?.problem || !problem) return;
        source.problem.value = problem.value;
        dispatchValueEvents(source.problem);
        if (characterCount) characterCount.textContent = problem.value.length;
        if (problem.value.trim()) clearError('problem');
        updateSummary();
      }

      function selectSendIn(button) {
        if (!source?.sendIn) return;
        const option = findSelectOption(source.sendIn, button.dataset.value);
        if (!option) {
          showError('send-in', 'This mail-in method is still loading. Try it again in a moment.');
          return;
        }
        source.sendIn.value = option.value;
        dispatchValueEvents(source.sendIn);
        state.sendIn = option.value;
        state.sendInLabel = button.dataset.label || option.textContent.trim();
        setActive('send-in', button.dataset.value);
        clearError('send-in');
        updateSummary();
        window.setTimeout(updatePrice, 180);
      }

      function syncAgreement() {
        if (!source || !agreement) return;
        const checked = agreement.checked;
        const agreementValue = benchCopyTarget?.textContent.trim() || source.benchCheckbox?.value || source.benchCopy || '';
        if (source.benchCheckbox && source.benchCheckbox.checked !== checked) source.benchCheckbox.click();
        source.benchHidden.value = checked ? agreementValue : '';
        dispatchValueEvents(source.benchHidden);
        state.agreement = checked;
        if (checked) clearError('agreement');
        updateSummary();
      }

      function validate() {
        let firstInvalid = null;
        if (!state.tier) {
          showError('tier', 'Choose a repair tier.');
          firstInvalid ||= 'tier';
        }
        if (!state.controller) {
          showError('controller', 'Choose the controller you are sending.');
          firstInvalid ||= 'controller';
        }
        if (JOYCON_CONTROLLERS.has(state.controller) && !state.joycon) {
          showError('joycon', 'Choose a single Joy-Con or the discounted pair.');
          firstInvalid ||= 'controller';
        }
        if (ELIGIBLE_CONTROLLERS.has(state.controller) && !state.joystick) {
          showError('upgrades', 'Choose whether to keep the standard joysticks or install an upgrade.');
          firstInvalid ||= 'controller';
        }
        if (!problem?.value.trim()) {
          showError('problem', 'Describe the controller problem before continuing.');
          firstInvalid ||= 'problem';
        }
        if (!state.sendIn) {
          showError('send-in', 'Choose Self-Ship or the Mail-In Kit.');
          firstInvalid ||= 'send-in';
        }
        if (!state.agreement) {
          showError('agreement', 'Accept the bench fee terms to continue.');
          firstInvalid ||= 'agreement';
        }

        if (firstInvalid) {
          updateSubmitState();
          return false;
        }
        return true;
      }

      async function submitOriginalForm() {
        if (!source || !validate()) return;
        restoreConditionalSelections();
        syncProblem();
        syncAgreement();
        submit.disabled = true;
        submit.setAttribute('aria-disabled', 'true');
        submit.setAttribute('aria-busy', 'true');
        if (submitLabel) submitLabel.textContent = 'Adding to cart';
        setStatus('Adding your configured repair...');

        try {
          if (!window.TechReviveNativeCart?.addConfiguration) {
            throw new Error('The native cart service did not load. Refresh the page and try again.');
          }

          const variant = selectedVariant();
          if (!variant) throw new Error('The selected repair configuration is unavailable. Refresh the page and try again.');
          const addOns = [];
          if (/MAIL-IN KIT/i.test(state.sendIn)) {
            addOns.push({ variantTitle: 'Mail-In Kit', label: 'Mail-In Kit' });
          }

          await window.TechReviveNativeCart.addConfiguration({
            root,
            productId: config.productId,
            parentVariantId: variant.id,
            addonVariants: config.addonVariants,
            serviceLabel: `Repair Service - ${state.tier}`,
            parentProperties: {
              'Repair Tier': state.tier,
              'Controller Type': state.controller,
              'Joy-Con Quantity': JOYCON_CONTROLLERS.has(state.controller) ? state.joycon : '',
              'Problem Described': problem?.value.trim(),
              'Joystick': ELIGIBLE_CONTROLLERS.has(state.controller) ? state.joystick : '',
              'Your Upgrades': [
                state.mouseclick ? 'Mouse-Click Triggers' : '',
                state.paddles ? 'Four Back Paddles' : ''
              ].filter(Boolean),
              'Bench Fee Agreement': 'Accepted'
            },
            addOns
          });
          setStatus('Your configured repair was added to the cart.');
        } catch (error) {
          console.error(error);
          setStatus(error?.message || 'The repair could not be added. Refresh the page and try again.');
        } finally {
          submit.removeAttribute('aria-busy');
          if (submitLabel) submitLabel.textContent = 'Add repair to cart';
          updateSubmitState();
        }
      }

      function hideSourceControls() {
        source.concealedRoots = [];
        source.concealedFocusables = [];

        function conceal(node, className) {
          if (!node) return;
          source.concealedRoots.push({ node, className, ariaHidden: node.getAttribute('aria-hidden') });
          node.classList.add(className);
          node.setAttribute('aria-hidden', 'true');
          const selector = 'a[href], button, input, select, textarea, [tabindex]';
          const focusables = [
            ...(node.matches?.(selector) ? [node] : []),
            ...(node.querySelectorAll?.(selector) || [])
          ];
          focusables.forEach((element) => {
            if (source.concealedFocusables.some((item) => item.element === element)) return;
            source.concealedFocusables.push({ element, tabindex: element.getAttribute('tabindex') });
            element.setAttribute('tabindex', '-1');
          });
        }

        conceal(source.container, 'tr-repair-builder-source-control');
        conceal(source.price, 'tr-repair-builder-source-price');
        document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
          const productId = form.querySelector('input[name="product-id"]')?.value;
          if (String(productId) !== String(config.productId)) return;
          form.querySelectorAll('button[name="add"], button[type="submit"]').forEach((button) => {
            conceal(button, 'tr-repair-builder-source-submit');
          });
        });
      }

      function collapseSourceSection() {
        const nativeSection = source?.container?.closest('.shopify-section');
        if (!nativeSection || nativeSection.contains(root)) return;

        source.nativeSection = {
          node: nativeSection,
          ariaHidden: nativeSection.getAttribute('aria-hidden')
        };

        nativeSection.classList.add('tr-repair-builder-source-section');
        nativeSection.setAttribute('aria-hidden', 'true');
      }

      function restoreSourceSection() {
        const saved = source?.nativeSection;
        if (!saved?.node) return;

        saved.node.classList.remove('tr-repair-builder-source-section');
        if (saved.ariaHidden === null) saved.node.removeAttribute('aria-hidden');
        else saved.node.setAttribute('aria-hidden', saved.ariaHidden);
      }

      function restoreSourceControls() {
        source?.concealedRoots?.forEach(({ node, className, ariaHidden }) => {
          node.classList.remove(className);
          if (ariaHidden === null) node.removeAttribute('aria-hidden');
          else node.setAttribute('aria-hidden', ariaHidden);
        });
        source?.concealedFocusables?.forEach(({ element, tabindex }) => {
          if (tabindex === null) element.removeAttribute('tabindex');
          else element.setAttribute('tabindex', tabindex);
        });
      }

      function connectToNativeSource() {
        const controller = document.querySelector('select[name="properties[Controller Type]"]');
        const form = controller?.form;
        const container = controller?.closest('[data-tr-native-options-container]');
        if (!controller || !form || !container) return false;

        const tierRadios = [...container.querySelectorAll('input[name="properties[Repair Tier]"][type="radio"]')];
        const problemSource = [...container.querySelectorAll('textarea[name="properties[Problem Described]"]')].find((element) => element.form === form);
        const sendIn = [...container.querySelectorAll('select[name="properties[Send-in]"]')].find((element) => element.form === form);
        const benchHidden = [...container.querySelectorAll(`input[name="${BENCH_PROPERTY}"]`)].find((element) => element.form === form);
        const benchCheckbox = benchHidden?.closest('fieldset')?.querySelector('input[type="checkbox"]') || null;
        const upgradesHidden = [...container.querySelectorAll('input[name="properties[Your Upgrades]"]')].find((element) => element.form === form);
        const addButton = form.querySelector('button[name="add"], button[type="submit"]');

        if (tierRadios.length < 3 || !problemSource || !sendIn || !benchHidden || !benchCheckbox || !addButton) return false;

        source = {
          form,
          container,
          controller,
          tierRadios,
          problem: problemSource,
          sendIn,
          benchHidden,
          benchCheckbox,
          benchCopy: benchCheckbox.value || '',
          upgradesHidden,
          addButton,
          price: null
        };
        refreshConditionalSources();

        state.tier = selectedSourceRadio(tierRadios)?.value || '';
        state.controller = canonicalController(controller.value || '');
        state.joycon = selectedSourceRadio([
          findJoyconRadio('Single Joy-Con'),
          findJoyconRadio('Pair of Joy-Cons')
        ].filter(Boolean))?.value || '';
        state.joystick = selectedSourceRadio(source.joystickRadios)?.value || '';
        state.mouseclick = Boolean(source.mouseclick?.checked);
        state.paddles = Boolean(source.paddles?.checked);
        state.sendIn = sendIn.value || '';
        state.sendInLabel = sendIn.value ? displaySendInLabel(sendIn.value) : '';
        state.agreement = Boolean(benchHidden.value);

        setActive('tier', state.tier);
        setActive('send-in', state.sendIn);
        if (controllerSelect) controllerSelect.value = state.controller;
        if (problem) {
          problem.value = problemSource.value || '';
          if (characterCount) characterCount.textContent = problem.value.length;
        }
        if (agreement) agreement.checked = state.agreement;

        const mailInOption = [...sendIn.options].find((option) => /MAIL-IN KIT/i.test(option.value));
        if (mailInOption && kitPrice) {
          const cents = parseAddedPrice(mailInOption.value);
          state.kitFee = cents || FALLBACK_FEES.kit;
          kitPrice.textContent = cents ? formatMoney(cents, config.currency) : 'Included';
        }

        if (source.price) {
          priceObserver = new MutationObserver(updatePrice);
          priceObserver.observe(source.price, { childList: true, subtree: true, characterData: true });
        }

        root.dataset.trRepairInitialized = 'true';
        hideSourceControls();
        collapseSourceSection();
        updateControllerPanels();
        restoreConditionalSelections();
        updateSubmitState();
        return true;
      }

      root.querySelectorAll('[data-tr-choice="tier"]').forEach((button) => button.addEventListener('click', () => selectTier(button)));
      root.querySelectorAll('[data-tr-choice="joycon"]').forEach((button) => button.addEventListener('click', () => selectJoycon(button)));
      root.querySelectorAll('[data-tr-choice="joystick"]').forEach((button) => button.addEventListener('click', () => selectJoystick(button)));
      root.querySelectorAll('[data-tr-choice="send-in"]').forEach((button) => button.addEventListener('click', () => selectSendIn(button)));
      root.querySelectorAll('[data-tr-addon]').forEach((button) => button.addEventListener('click', () => toggleAddon(button)));
      controllerSelect?.addEventListener('change', selectController);
      problem?.addEventListener('input', syncProblem);
      agreement?.addEventListener('change', syncAgreement);
      submit?.addEventListener('click', submitOriginalForm);

      syncSummaryDisclosure();
      if (mobileSummaryQuery.addEventListener) mobileSummaryQuery.addEventListener('change', syncSummaryDisclosure);
      else mobileSummaryQuery.addListener(syncSummaryDisclosure);

      let attempts = 0;
      connectionTimer = window.setInterval(() => {
        attempts += 1;
        if (connectToNativeSource()) {
          window.clearInterval(connectionTimer);
        } else if (attempts >= 120) {
          window.clearInterval(connectionTimer);
          setStatus('The repair builder did not load. Refresh this page before ordering.');
        }
      }, 100);

      root._trRepairCleanup = () => {
        window.clearInterval(connectionTimer);
        priceObserver?.disconnect();
        restoreSourceSection();
        restoreSourceControls();
        if (mobileSummaryQuery.removeEventListener) mobileSummaryQuery.removeEventListener('change', syncSummaryDisclosure);
        else mobileSummaryQuery.removeListener(syncSummaryDisclosure);
      };
    }

    function initAll(scope = document) {
      if (scope.matches?.(ROOT_SELECTOR)) initRepairBuilder(scope);
      scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initRepairBuilder);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll?.(ROOT_SELECTOR).forEach((root) => root._trRepairCleanup?.());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["techrevive-repair-builder-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ROOT_SELECTOR = '[data-tr-repair-builder]';
    const BENCH_PROPERTY = 'properties[bench fee agreement]';
    const ELIGIBLE_CONTROLLERS = new Set([
      'PS5 DualSense',
      'Xbox Series X|S Controller',
      'Nintendo Switch Pro Controller'
    ]);
    const JOYCON_CONTROLLERS = new Set([
      'Nintendo Switch 2 Joy-Con',
      'Nintendo Switch Joy-Con'
    ]);
    const CONTROLLER_SOURCE_ALIASES = {
      'PS4 DualShock 4': ['PS4 DualShock 4', 'PS4 DualShock'],
      'Xbox Series X|S Controller': ['Xbox Series X|S Controller', 'Xbox Series X/S Controller'],
      'Nintendo Switch Joy-Con': ['Nintendo Switch Joy-Con', 'Nintendo Switch 1 Joy-Con']
    };
    const FALLBACK_FEES = {
      'Hall Effect Upgrade': 3999,
      'TMR Upgrade': 4699,
      mouseclick: 6499,
      paddles: 8999,
      kit: 1999
    };

    function dispatchValueEvents(element) {
      element.dispatchEvent(new Event('input', { bubbles: true }));
      element.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function formatMoney(cents, currency) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: currency || 'USD'
        }).format((Number(cents) || 0) / 100);
      } catch (error) {
        return `$${((Number(cents) || 0) / 100).toFixed(2)}`;
      }
    }

    function parseAddedPrice(label) {
      const match = String(label || '').match(/\$\s*([0-9]+(?:\.[0-9]{1,2})?)/);
      return match ? Math.round(Number(match[1]) * 100) : 0;
    }

    function parsePriceSetting(value, fallback) {
      const cleaned = String(value ?? '').replace(/[^0-9.]/g, '');
      if (!cleaned) return fallback;
      const amount = Number(cleaned);
      return Number.isFinite(amount) ? Math.round(amount * 100) : fallback;
    }

    function initRepairBuilder(root) {
      if (!root || root.dataset.trRepairInitialized === 'true') return;

      const configElement = root.querySelector('[data-tr-repair-config]');
      if (!configElement) return;

      let config;
      try {
        config = JSON.parse(configElement.textContent);
      } catch (error) {
        return;
      }

      const controllerSelect = root.querySelector('[data-tr-controller]');
      const problem = root.querySelector('[data-tr-problem]');
      const agreement = root.querySelector('[data-tr-agreement]');
      const submit = root.querySelector('[data-tr-submit]');
      const submitLabel = root.querySelector('[data-tr-submit-label]');
      const status = root.querySelector('[data-tr-status]');
      const total = root.querySelector('[data-tr-total]');
      const characterCount = root.querySelector('[data-tr-character-count]');
      const kitPrice = root.querySelector('[data-tr-kit-price]');
      const joyconPanel = root.querySelector('[data-tr-joycon-panel]');
      const upgradesPanel = root.querySelector('[data-tr-upgrades-panel]');
      const repairOnly = root.querySelector('[data-tr-repair-only]');
      const benchCopyTarget = root.querySelector('[data-tr-bench-copy]');
      const summaryDetails = root.querySelector('[data-tr-summary-details]');
      const mobileSummaryQuery = window.matchMedia('(max-width: 680px)');

      const state = {
        tier: '',
        controller: '',
        joycon: '',
        joystick: '',
        mouseclick: false,
        paddles: false,
        sendIn: '',
        sendInLabel: '',
        kitFee: FALLBACK_FEES.kit,
        agreement: false
      };

      const itemFees = {
        'Hall Effect Upgrade': parsePriceSetting(config.upgradePriceLabels?.['Hall Effect Upgrade'], FALLBACK_FEES['Hall Effect Upgrade']),
        'TMR Upgrade': parsePriceSetting(config.upgradePriceLabels?.['TMR Upgrade'], FALLBACK_FEES['TMR Upgrade']),
        mouseclick: parsePriceSetting(config.upgradePriceLabels?.mouseclick, FALLBACK_FEES.mouseclick),
        paddles: parsePriceSetting(config.upgradePriceLabels?.paddles, FALLBACK_FEES.paddles)
      };

      let source = null;
      let priceObserver = null;
      let connectionTimer = null;
      let restoring = false;

      function setStatus(message) {
        if (status) status.textContent = message || '';
      }

      function setSummary(key, value) {
        const target = root.querySelector(`[data-tr-summary="${key}"]`);
        if (target) target.textContent = value;
      }

      function setSummaryPrice(key, value) {
        const target = root.querySelector(`[data-tr-summary-price="${key}"]`);
        if (target) target.textContent = value;
      }

      function showSummaryRow(key, show) {
        const row = root.querySelector(`[data-tr-summary-row="${key}"]`);
        if (row) row.hidden = !show;
      }

      function setActive(group, value) {
        root.querySelectorAll(`[data-tr-choice="${group}"]`).forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.value === value));
        });
      }

      function setAddonState(key, active) {
        const button = root.querySelector(`[data-tr-addon="${key}"]`);
        const label = root.querySelector(`[data-tr-addon-state="${key}"]`);
        button?.setAttribute('aria-pressed', String(active));
        if (label) label.textContent = active ? 'Added' : 'Add';
      }

      function clearError(group) {
        const wrapper = root.querySelector(`[data-tr-group="${group}"]`);
        const error = root.querySelector(`[data-tr-error="${group}"]`);
        wrapper?.removeAttribute('aria-invalid');
        if (error) error.textContent = '';
      }

      function showError(group, message) {
        const wrapper = root.querySelector(`[data-tr-group="${group}"]`);
        const error = root.querySelector(`[data-tr-error="${group}"]`);
        wrapper?.setAttribute('aria-invalid', 'true');
        if (error) error.textContent = message;
      }

      function selectedSourceRadio(radios) {
        return (radios || []).find((radio) => radio.checked && !radio.disabled) || null;
      }

      function findSelectOption(select, desired) {
        if (!select) return null;
        return [...select.options].find((option) => option.value === desired || option.textContent.trim() === desired) || null;
      }

      function findControllerOption(select, desired) {
        const candidates = CONTROLLER_SOURCE_ALIASES[desired] || [desired];
        return candidates.map((candidate) => findSelectOption(select, candidate)).find(Boolean) || null;
      }

      function canonicalController(value) {
        const match = Object.entries(CONTROLLER_SOURCE_ALIASES).find(([, aliases]) => aliases.includes(value));
        return match?.[0] || value;
      }

      function displaySendInLabel(value) {
        if (/MAIL-IN KIT/i.test(value)) return 'Mail In Kit';
        if (/SELF-SHIP/i.test(value)) return 'Self Ship';
        return value;
      }

      function syncSummaryDisclosure() {
        if (!summaryDetails) return;
        summaryDetails.open = !mobileSummaryQuery.matches;
      }

      function findJoyconRadio(value) {
        if (!source?.container) return null;
        return [...source.container.querySelectorAll('input[type="radio"]')].find((radio) => {
          return radio.value === value && radio.name && /JOY-CON SELECTION/i.test(radio.name) && !radio.disabled;
        }) || null;
      }

      function refreshConditionalSources() {
        if (!source?.container) return;
        source.joystickRadios = [...source.container.querySelectorAll('input[name="properties[Joystick]"][type="radio"]')];
        const upgradesHidden = source.container.querySelector('input[name="properties[Your Upgrades]"]');
        const upgradesFieldset = upgradesHidden?.closest('fieldset');
        const checkboxes = upgradesFieldset ? [...upgradesFieldset.querySelectorAll('input[type="checkbox"]')] : [];
        source.upgradesHidden = upgradesHidden || source.upgradesHidden;
        source.mouseclick = checkboxes.find((input) => input.value === 'Mouse-Click Triggers') || null;
        source.paddles = checkboxes.find((input) => input.value === '4 Back Paddles') || null;
      }

      function fallbackTotal() {
        let cents = Number(config.tierPrices?.[state.tier] ?? config.basePrice) || 0;
        if (JOYCON_CONTROLLERS.has(state.controller) && state.joycon === 'Pair of Joy-Cons') {
          cents += Math.round(cents * 0.8);
        }
        if (ELIGIBLE_CONTROLLERS.has(state.controller)) {
          cents += itemFees[state.joystick] || 0;
          if (state.mouseclick) cents += itemFees.mouseclick;
          if (state.paddles) cents += itemFees.paddles;
        }
        if (/MAIL-IN KIT/i.test(state.sendIn)) cents += state.kitFee;
        return formatMoney(cents, config.currency || root.dataset.currency);
      }

      function updatePrice() {
        if (!total) return;
        const appPrice = source?.price?.textContent?.trim();
        total.textContent = appPrice || fallbackTotal();
      }

      function missingConfiguration() {
        const missing = [];
        if (!state.tier) missing.push('repair tier');
        if (!state.controller) missing.push('controller');
        if (JOYCON_CONTROLLERS.has(state.controller) && !state.joycon) missing.push('Joy Con quantity');
        if (ELIGIBLE_CONTROLLERS.has(state.controller) && !state.joystick) missing.push('joystick choice');
        if (!problem?.value.trim()) missing.push('problem description');
        if (!state.sendIn) missing.push('mail in method');
        if (!state.agreement) missing.push('bench fee agreement');
        return missing;
      }

      function updateSubmitState() {
        if (!submit) return;
        const missing = missingConfiguration();
        const ready = Boolean(source) && missing.length === 0;
        submit.disabled = !ready;
        submit.setAttribute('aria-disabled', String(!ready));
        if (submit.getAttribute('aria-busy') === 'true') return;
        if (!source) {
          setStatus('Loading repair options.');
        } else if (ready) {
          setStatus('Your repair configuration is complete and ready to add to the cart.');
        } else {
          setStatus(`Complete ${missing.join(', ')} to continue.`);
        }
      }

      function updateSummary() {
        const eligible = ELIGIBLE_CONTROLLERS.has(state.controller);
        const joycon = JOYCON_CONTROLLERS.has(state.controller);
        const tierCents = Number(config.tierPrices?.[state.tier] ?? 0) || 0;
        const joystickFee = itemFees[state.joystick] || 0;
        setSummary('tier', state.tier || 'Select a tier');
        setSummary('controller', state.controller || 'Select a controller');
        setSummary('joycon', state.joycon || 'Select one or a pair');
        setSummary('joystick', state.joystick === 'Hall Effect Upgrade' ? 'Hall Effect' : state.joystick === 'TMR Upgrade' ? 'TMR' : 'No upgrade');
        setSummary('mouseclick', state.mouseclick ? 'Added' : 'Not added');
        setSummary('paddles', state.paddles ? 'Added' : 'Not added');
        setSummary('send-in', state.sendInLabel || 'Select a method');
        setSummaryPrice('tier', state.tier ? formatMoney(tierCents, config.currency) : 'Pending');
        setSummaryPrice('joycon', !state.joycon ? 'Pending' : state.joycon === 'Pair of Joy-Cons' ? `Adds ${formatMoney(Math.round(tierCents * 0.8), config.currency)}` : 'Included');
        setSummaryPrice('joystick', formatMoney(joystickFee, config.currency));
        setSummaryPrice('mouseclick', formatMoney(state.mouseclick ? itemFees.mouseclick : 0, config.currency));
        setSummaryPrice('paddles', formatMoney(state.paddles ? itemFees.paddles : 0, config.currency));
        setSummaryPrice('send-in', !state.sendIn ? 'Pending' : /MAIL-IN KIT/i.test(state.sendIn) ? formatMoney(state.kitFee, config.currency) : 'Included');
        showSummaryRow('joycon', joycon && Boolean(state.joycon));
        showSummaryRow('joystick', eligible && (state.joystick === 'Hall Effect Upgrade' || state.joystick === 'TMR Upgrade'));
        showSummaryRow('mouseclick', eligible && state.mouseclick);
        showSummaryRow('paddles', eligible && state.paddles);
        updatePrice();
        updateSubmitState();
      }

      function updateControllerPanels() {
        const eligible = ELIGIBLE_CONTROLLERS.has(state.controller);
        const joycon = JOYCON_CONTROLLERS.has(state.controller);
        if (joyconPanel) joyconPanel.hidden = !joycon;
        if (upgradesPanel) upgradesPanel.hidden = !eligible;
        if (repairOnly) repairOnly.hidden = !state.controller || eligible || joycon;
        setActive('joycon', state.joycon);
        setActive('joystick', state.joystick);
        setAddonState('mouseclick', state.mouseclick);
        setAddonState('paddles', state.paddles);
        updateSummary();
      }

      function chooseSourceRadio(radios, value) {
        const radio = (radios || []).find((input) => input.value === value && !input.disabled);
        if (!radio) return false;
        if (!radio.checked) radio.click();
        return true;
      }

      function restoreConditionalSelections() {
        if (!source || restoring) return;
        restoring = true;
        refreshConditionalSources();

        if (JOYCON_CONTROLLERS.has(state.controller) && state.joycon) {
          const pairRadio = findJoyconRadio(state.joycon);
          if (pairRadio && !pairRadio.checked) pairRadio.click();
        }

        if (ELIGIBLE_CONTROLLERS.has(state.controller)) {
          const desiredJoystick = state.joystick || 'No, Keep My Analogs';
          if (chooseSourceRadio(source.joystickRadios, desiredJoystick)) state.joystick = desiredJoystick;
          if (source.mouseclick && source.mouseclick.checked !== state.mouseclick) source.mouseclick.click();
          if (source.paddles && source.paddles.checked !== state.paddles) source.paddles.click();
        }

        restoring = false;
        updateControllerPanels();
        window.setTimeout(updatePrice, 120);
      }

      function selectTier(button) {
        if (!source) return;
        const value = button.dataset.value;
        if (!chooseSourceRadio(source.tierRadios, value)) {
          showError('tier', 'This repair tier is still loading. Try it again in a moment.');
          return;
        }
        state.tier = value;
        setActive('tier', value);
        clearError('tier');
        updateSummary();
        [80, 260, 650].forEach((delay) => window.setTimeout(restoreConditionalSelections, delay));
      }

      function selectController() {
        if (!source?.controller || !controllerSelect) return;
        const value = controllerSelect.value;
        const option = findControllerOption(source.controller, value);
        if (!option && value) {
          showError('controller', 'This controller choice is not available in Infinite Options.');
          return;
        }

        source.controller.value = option?.value || '';
        dispatchValueEvents(source.controller);
        state.controller = value;
        state.joycon = '';
        state.joystick = '';
        state.mouseclick = false;
        state.paddles = false;
        clearError('controller');
        clearError('joycon');
        clearError('upgrades');
        updateControllerPanels();
        [90, 280, 650].forEach((delay) => window.setTimeout(restoreConditionalSelections, delay));
      }

      function selectJoycon(button) {
        refreshConditionalSources();
        const value = button.dataset.value;
        const radio = findJoyconRadio(value);
        if (!radio) {
          showError('joycon', 'The Joy-Con quantity options are still loading. Try again in a moment.');
          return;
        }
        radio.click();
        state.joycon = value;
        setActive('joycon', value);
        clearError('joycon');
        updateSummary();
        window.setTimeout(updatePrice, 180);
      }

      function selectJoystick(button) {
        refreshConditionalSources();
        const value = button.dataset.value;
        if (!chooseSourceRadio(source.joystickRadios, value)) {
          showError('upgrades', 'The joystick choices are still loading. Try again in a moment.');
          return;
        }
        state.joystick = value;
        setActive('joystick', value);
        clearError('upgrades');
        updateSummary();
        window.setTimeout(updatePrice, 180);
      }

      function toggleAddon(button) {
        refreshConditionalSources();
        const key = button.dataset.trAddon;
        const input = source?.[key];
        if (!input) {
          showError('upgrades', 'This upgrade is still loading. Try again in a moment.');
          return;
        }
        input.click();
        state[key] = input.checked;
        setAddonState(key, state[key]);
        clearError('upgrades');
        updateSummary();
        window.setTimeout(updatePrice, 180);
      }

      function syncProblem() {
        if (!source?.problem || !problem) return;
        source.problem.value = problem.value;
        dispatchValueEvents(source.problem);
        if (characterCount) characterCount.textContent = problem.value.length;
        if (problem.value.trim()) clearError('problem');
        updateSummary();
      }

      function selectSendIn(button) {
        if (!source?.sendIn) return;
        const option = findSelectOption(source.sendIn, button.dataset.value);
        if (!option) {
          showError('send-in', 'This mail-in method is still loading. Try it again in a moment.');
          return;
        }
        source.sendIn.value = option.value;
        dispatchValueEvents(source.sendIn);
        state.sendIn = option.value;
        state.sendInLabel = button.dataset.label || option.textContent.trim();
        setActive('send-in', button.dataset.value);
        clearError('send-in');
        updateSummary();
        window.setTimeout(updatePrice, 180);
      }

      function syncAgreement() {
        if (!source || !agreement) return;
        const checked = agreement.checked;
        const agreementValue = benchCopyTarget?.textContent.trim() || source.benchCheckbox?.value || source.benchCopy || '';
        if (source.benchCheckbox && source.benchCheckbox.checked !== checked) source.benchCheckbox.click();
        source.benchHidden.value = checked ? agreementValue : '';
        dispatchValueEvents(source.benchHidden);
        state.agreement = checked;
        if (checked) clearError('agreement');
        updateSummary();
      }

      function validate() {
        let firstInvalid = null;
        if (!state.tier) {
          showError('tier', 'Choose a repair tier.');
          firstInvalid ||= 'tier';
        }
        if (!state.controller) {
          showError('controller', 'Choose the controller you are sending.');
          firstInvalid ||= 'controller';
        }
        if (JOYCON_CONTROLLERS.has(state.controller) && !state.joycon) {
          showError('joycon', 'Choose a single Joy-Con or the discounted pair.');
          firstInvalid ||= 'controller';
        }
        if (ELIGIBLE_CONTROLLERS.has(state.controller) && !state.joystick) {
          showError('upgrades', 'Choose whether to keep the standard joysticks or install an upgrade.');
          firstInvalid ||= 'controller';
        }
        if (!problem?.value.trim()) {
          showError('problem', 'Describe the controller problem before continuing.');
          firstInvalid ||= 'problem';
        }
        if (!state.sendIn) {
          showError('send-in', 'Choose Self-Ship or the Mail-In Kit.');
          firstInvalid ||= 'send-in';
        }
        if (!state.agreement) {
          showError('agreement', 'Accept the bench fee terms to continue.');
          firstInvalid ||= 'agreement';
        }

        if (firstInvalid) {
          updateSubmitState();
          return false;
        }
        return true;
      }

      function submitOriginalForm() {
        if (!source || !validate()) return;
        restoreConditionalSelections();
        syncProblem();
        syncAgreement();
        submit.disabled = true;
        submit.setAttribute('aria-disabled', 'true');
        submit.setAttribute('aria-busy', 'true');
        if (submitLabel) submitLabel.textContent = 'Adding to cart';
        setStatus('Adding your configured repair...');
        window.setTimeout(() => source.addButton.click(), 80);

        window.setTimeout(() => {
          submit.removeAttribute('aria-busy');
          if (submitLabel) submitLabel.textContent = 'Add repair to cart';
          updateSubmitState();
        }, 1900);
      }

      function hideSourceControls() {
        source.concealedRoots = [];
        source.concealedFocusables = [];

        function conceal(node, className) {
          if (!node) return;
          source.concealedRoots.push({ node, className, ariaHidden: node.getAttribute('aria-hidden') });
          node.classList.add(className);
          node.setAttribute('aria-hidden', 'true');
          const selector = 'a[href], button, input, select, textarea, [tabindex]';
          const focusables = [
            ...(node.matches?.(selector) ? [node] : []),
            ...(node.querySelectorAll?.(selector) || [])
          ];
          focusables.forEach((element) => {
            if (source.concealedFocusables.some((item) => item.element === element)) return;
            source.concealedFocusables.push({ element, tabindex: element.getAttribute('tabindex') });
            element.setAttribute('tabindex', '-1');
          });
        }

        conceal(source.container, 'tr-repair-builder-source-control');
        conceal(source.price, 'tr-repair-builder-source-price');
        document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
          const productId = form.querySelector('input[name="product-id"]')?.value;
          if (String(productId) !== String(config.productId)) return;
          form.querySelectorAll('button[name="add"], button[type="submit"]').forEach((button) => {
            conceal(button, 'tr-repair-builder-source-submit');
          });
        });
      }

      function restoreSourceControls() {
        source?.concealedRoots?.forEach(({ node, className, ariaHidden }) => {
          node.classList.remove(className);
          if (ariaHidden === null) node.removeAttribute('aria-hidden');
          else node.setAttribute('aria-hidden', ariaHidden);
        });
        source?.concealedFocusables?.forEach(({ element, tabindex }) => {
          if (tabindex === null) element.removeAttribute('tabindex');
          else element.setAttribute('tabindex', tabindex);
        });
      }

      function connectToInfiniteOptions() {
        const controller = document.querySelector('select[name="properties[Controller Type]"]');
        const form = controller?.form;
        const container = controller?.closest('#infiniteoptions-container');
        if (!controller || !form || !container) return false;

        const tierRadios = [...container.querySelectorAll('input[name="properties[Repair Tier]"][type="radio"]')];
        const problemSource = [...container.querySelectorAll('textarea[name="properties[Problem Described]"]')].find((element) => element.form === form);
        const sendIn = [...container.querySelectorAll('select[name="properties[Send-in]"]')].find((element) => element.form === form);
        const benchHidden = [...container.querySelectorAll(`input[name="${BENCH_PROPERTY}"]`)].find((element) => element.form === form);
        const benchCheckbox = benchHidden?.closest('fieldset')?.querySelector('input[type="checkbox"]') || null;
        const upgradesHidden = [...container.querySelectorAll('input[name="properties[Your Upgrades]"]')].find((element) => element.form === form);
        const addButton = form.querySelector('button[name="add"], button[type="submit"]');

        if (tierRadios.length < 3 || !problemSource || !sendIn || !benchHidden || !benchCheckbox || !addButton) return false;

        source = {
          form,
          container,
          controller,
          tierRadios,
          problem: problemSource,
          sendIn,
          benchHidden,
          benchCheckbox,
          benchCopy: benchCheckbox.value || '',
          upgradesHidden,
          addButton,
          price: document.querySelector('.infiniteoptions-price')
        };
        refreshConditionalSources();

        state.tier = selectedSourceRadio(tierRadios)?.value || '';
        state.controller = canonicalController(controller.value || '');
        state.joycon = selectedSourceRadio([
          findJoyconRadio('Single Joy-Con'),
          findJoyconRadio('Pair of Joy-Cons')
        ].filter(Boolean))?.value || '';
        state.joystick = selectedSourceRadio(source.joystickRadios)?.value || '';
        state.mouseclick = Boolean(source.mouseclick?.checked);
        state.paddles = Boolean(source.paddles?.checked);
        state.sendIn = sendIn.value || '';
        state.sendInLabel = sendIn.value ? displaySendInLabel(sendIn.value) : '';
        state.agreement = Boolean(benchHidden.value);

        setActive('tier', state.tier);
        setActive('send-in', state.sendIn);
        if (controllerSelect) controllerSelect.value = state.controller;
        if (problem) {
          problem.value = problemSource.value || '';
          if (characterCount) characterCount.textContent = problem.value.length;
        }
        if (agreement) agreement.checked = state.agreement;

        const mailInOption = [...sendIn.options].find((option) => /MAIL-IN KIT/i.test(option.value));
        if (mailInOption && kitPrice) {
          const cents = parseAddedPrice(mailInOption.value);
          state.kitFee = cents || FALLBACK_FEES.kit;
          kitPrice.textContent = cents ? formatMoney(cents, config.currency) : 'Included';
        }

        if (source.price) {
          priceObserver = new MutationObserver(updatePrice);
          priceObserver.observe(source.price, { childList: true, subtree: true, characterData: true });
        }

        root.dataset.trRepairInitialized = 'true';
        hideSourceControls();
        updateControllerPanels();
        restoreConditionalSelections();
        updateSubmitState();
        return true;
      }

      root.querySelectorAll('[data-tr-choice="tier"]').forEach((button) => button.addEventListener('click', () => selectTier(button)));
      root.querySelectorAll('[data-tr-choice="joycon"]').forEach((button) => button.addEventListener('click', () => selectJoycon(button)));
      root.querySelectorAll('[data-tr-choice="joystick"]').forEach((button) => button.addEventListener('click', () => selectJoystick(button)));
      root.querySelectorAll('[data-tr-choice="send-in"]').forEach((button) => button.addEventListener('click', () => selectSendIn(button)));
      root.querySelectorAll('[data-tr-addon]').forEach((button) => button.addEventListener('click', () => toggleAddon(button)));
      controllerSelect?.addEventListener('change', selectController);
      problem?.addEventListener('input', syncProblem);
      agreement?.addEventListener('change', syncAgreement);
      submit?.addEventListener('click', submitOriginalForm);

      syncSummaryDisclosure();
      if (mobileSummaryQuery.addEventListener) mobileSummaryQuery.addEventListener('change', syncSummaryDisclosure);
      else mobileSummaryQuery.addListener(syncSummaryDisclosure);

      let attempts = 0;
      connectionTimer = window.setInterval(() => {
        attempts += 1;
        if (connectToInfiniteOptions()) {
          window.clearInterval(connectionTimer);
        } else if (attempts >= 120) {
          window.clearInterval(connectionTimer);
          setStatus('The repair options did not load. Refresh this page before ordering.');
        }
      }, 100);

      root._trRepairCleanup = () => {
        window.clearInterval(connectionTimer);
        priceObserver?.disconnect();
        restoreSourceControls();
        if (mobileSummaryQuery.removeEventListener) mobileSummaryQuery.removeEventListener('change', syncSummaryDisclosure);
        else mobileSummaryQuery.removeListener(syncSummaryDisclosure);
      };
    }

    function initAll(scope = document) {
      if (scope.matches?.(ROOT_SELECTOR)) initRepairBuilder(scope);
      scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initRepairBuilder);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll?.(ROOT_SELECTOR).forEach((root) => root._trRepairCleanup?.());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["techrevive-repair-builder-v9"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ROOT_SELECTOR = '[data-tr-repair-builder]';
    const BENCH_PROPERTY = 'properties[bench fee agreement]';
    const ELIGIBLE_CONTROLLERS = new Set([
      'PS5 DualSense',
      'Xbox Series X|S Controller',
      'Nintendo Switch Pro Controller'
    ]);
    const JOYCON_CONTROLLERS = new Set([
      'Nintendo Switch 2 Joy-Con',
      'Nintendo Switch Joy-Con'
    ]);
    const CONTROLLER_SOURCE_ALIASES = {
      'PS4 DualShock 4': ['PS4 DualShock 4', 'PS4 DualShock'],
      'Xbox Series X|S Controller': ['Xbox Series X|S Controller', 'Xbox Series X/S Controller'],
      'Nintendo Switch Joy-Con': ['Nintendo Switch Joy-Con', 'Nintendo Switch 1 Joy-Con']
    };
    const FALLBACK_FEES = {
      'Hall Effect Upgrade': 3999,
      'TMR Upgrade': 4699,
      mouseclick: 6499,
      paddles: 8999,
      kit: 1999
    };

    function dispatchValueEvents(element) {
      element.dispatchEvent(new Event('input', { bubbles: true }));
      element.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function formatMoney(cents, currency) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: currency || 'USD'
        }).format((Number(cents) || 0) / 100);
      } catch (error) {
        return `$${((Number(cents) || 0) / 100).toFixed(2)}`;
      }
    }

    function parseAddedPrice(label) {
      const match = String(label || '').match(/\$\s*([0-9]+(?:\.[0-9]{1,2})?)/);
      return match ? Math.round(Number(match[1]) * 100) : 0;
    }

    function parsePriceSetting(value, fallback) {
      const cleaned = String(value ?? '').replace(/[^0-9.]/g, '');
      if (!cleaned) return fallback;
      const amount = Number(cleaned);
      return Number.isFinite(amount) ? Math.round(amount * 100) : fallback;
    }

    function initRepairBuilder(root) {
      if (!root || root.dataset.trRepairInitialized === 'true') return;

      const configElement = root.querySelector('[data-tr-repair-config]');
      if (!configElement) return;

      let config;
      try {
        config = JSON.parse(configElement.textContent);
      } catch (error) {
        return;
      }

      const controllerSelect = root.querySelector('[data-tr-controller]');
      const problem = root.querySelector('[data-tr-problem]');
      const agreement = root.querySelector('[data-tr-agreement]');
      const submit = root.querySelector('[data-tr-submit]');
      const submitLabel = root.querySelector('[data-tr-submit-label]');
      const status = root.querySelector('[data-tr-status]');
      const total = root.querySelector('[data-tr-total]');
      const characterCount = root.querySelector('[data-tr-character-count]');
      const kitPrice = root.querySelector('[data-tr-kit-price]');
      const joyconPanel = root.querySelector('[data-tr-joycon-panel]');
      const upgradesPanel = root.querySelector('[data-tr-upgrades-panel]');
      const repairOnly = root.querySelector('[data-tr-repair-only]');
      const benchCopyTarget = root.querySelector('[data-tr-bench-copy]');
      const summaryDetails = root.querySelector('[data-tr-summary-details]');
      const mobileSummaryQuery = window.matchMedia('(max-width: 680px)');

      const state = {
        tier: '',
        controller: '',
        joycon: '',
        joystick: '',
        mouseclick: false,
        paddles: false,
        sendIn: '',
        sendInLabel: '',
        kitFee: FALLBACK_FEES.kit,
        agreement: false
      };

      const itemFees = {
        'Hall Effect Upgrade': parsePriceSetting(config.upgradePriceLabels?.['Hall Effect Upgrade'], FALLBACK_FEES['Hall Effect Upgrade']),
        'TMR Upgrade': parsePriceSetting(config.upgradePriceLabels?.['TMR Upgrade'], FALLBACK_FEES['TMR Upgrade']),
        mouseclick: parsePriceSetting(config.upgradePriceLabels?.mouseclick, FALLBACK_FEES.mouseclick),
        paddles: parsePriceSetting(config.upgradePriceLabels?.paddles, FALLBACK_FEES.paddles)
      };

      let source = null;
      let priceObserver = null;
      let connectionTimer = null;
      let restoring = false;

      function setStatus(message) {
        if (status) status.textContent = message || '';
      }

      function setSummary(key, value) {
        const target = root.querySelector(`[data-tr-summary="${key}"]`);
        if (target) target.textContent = value;
      }

      function setSummaryPrice(key, value) {
        const target = root.querySelector(`[data-tr-summary-price="${key}"]`);
        if (target) target.textContent = value;
      }

      function showSummaryRow(key, show) {
        const row = root.querySelector(`[data-tr-summary-row="${key}"]`);
        if (row) row.hidden = !show;
      }

      function setActive(group, value) {
        root.querySelectorAll(`[data-tr-choice="${group}"]`).forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.value === value));
        });
      }

      function setAddonState(key, active) {
        const button = root.querySelector(`[data-tr-addon="${key}"]`);
        const label = root.querySelector(`[data-tr-addon-state="${key}"]`);
        button?.setAttribute('aria-pressed', String(active));
        if (label) label.textContent = active ? 'Added' : 'Add';
      }

      function clearError(group) {
        const wrapper = root.querySelector(`[data-tr-group="${group}"]`);
        const error = root.querySelector(`[data-tr-error="${group}"]`);
        wrapper?.removeAttribute('aria-invalid');
        if (error) error.textContent = '';
      }

      function showError(group, message) {
        const wrapper = root.querySelector(`[data-tr-group="${group}"]`);
        const error = root.querySelector(`[data-tr-error="${group}"]`);
        wrapper?.setAttribute('aria-invalid', 'true');
        if (error) error.textContent = message;
      }

      function selectedSourceRadio(radios) {
        return (radios || []).find((radio) => radio.checked && !radio.disabled) || null;
      }

      function findSelectOption(select, desired) {
        if (!select) return null;
        return [...select.options].find((option) => option.value === desired || option.textContent.trim() === desired) || null;
      }

      function findControllerOption(select, desired) {
        const candidates = CONTROLLER_SOURCE_ALIASES[desired] || [desired];
        return candidates.map((candidate) => findSelectOption(select, candidate)).find(Boolean) || null;
      }

      function canonicalController(value) {
        const match = Object.entries(CONTROLLER_SOURCE_ALIASES).find(([, aliases]) => aliases.includes(value));
        return match?.[0] || value;
      }

      function displaySendInLabel(value) {
        if (/MAIL-IN KIT/i.test(value)) return 'Mail In Kit';
        if (/SELF-SHIP/i.test(value)) return 'Self Ship';
        return value;
      }

      function syncSummaryDisclosure() {
        if (!summaryDetails) return;
        summaryDetails.open = !mobileSummaryQuery.matches;
      }

      function findJoyconRadio(value) {
        if (!source?.container) return null;
        return [...source.container.querySelectorAll('input[type="radio"]')].find((radio) => {
          return radio.value === value && radio.name && /JOY-CON SELECTION/i.test(radio.name) && !radio.disabled;
        }) || null;
      }

      function refreshConditionalSources() {
        if (!source?.container) return;
        source.joystickRadios = [...source.container.querySelectorAll('input[name="properties[Joystick]"][type="radio"]')];
        const upgradesHidden = source.container.querySelector('input[name="properties[Your Upgrades]"]');
        const upgradesFieldset = upgradesHidden?.closest('fieldset');
        const checkboxes = upgradesFieldset ? [...upgradesFieldset.querySelectorAll('input[type="checkbox"]')] : [];
        source.upgradesHidden = upgradesHidden || source.upgradesHidden;
        source.mouseclick = checkboxes.find((input) => input.value === 'Mouse-Click Triggers') || null;
        source.paddles = checkboxes.find((input) => input.value === '4 Back Paddles') || null;
      }

      function fallbackTotal() {
        let cents = Number(config.tierPrices?.[state.tier] ?? config.basePrice) || 0;
        if (JOYCON_CONTROLLERS.has(state.controller) && state.joycon === 'Pair of Joy-Cons') {
          cents += Math.round(cents * 0.8);
        }
        if (ELIGIBLE_CONTROLLERS.has(state.controller)) {
          cents += itemFees[state.joystick] || 0;
          if (state.mouseclick) cents += itemFees.mouseclick;
          if (state.paddles) cents += itemFees.paddles;
        }
        if (/MAIL-IN KIT/i.test(state.sendIn)) cents += state.kitFee;
        return formatMoney(cents, config.currency || root.dataset.currency);
      }

      function updatePrice() {
        if (!total) return;
        const appPrice = source?.price?.textContent?.trim();
        total.textContent = appPrice || fallbackTotal();
      }

      function missingConfiguration() {
        const missing = [];
        if (!state.tier) missing.push('repair tier');
        if (!state.controller) missing.push('controller');
        if (JOYCON_CONTROLLERS.has(state.controller) && !state.joycon) missing.push('Joy Con quantity');
        if (ELIGIBLE_CONTROLLERS.has(state.controller) && !state.joystick) missing.push('joystick choice');
        if (!problem?.value.trim()) missing.push('problem description');
        if (!state.sendIn) missing.push('mail in method');
        if (!state.agreement) missing.push('bench fee agreement');
        return missing;
      }

      function updateSubmitState() {
        if (!submit) return;
        const missing = missingConfiguration();
        const ready = Boolean(source) && missing.length === 0;
        submit.disabled = !ready;
        submit.setAttribute('aria-disabled', String(!ready));
        if (submit.getAttribute('aria-busy') === 'true') return;
        if (!source) {
          setStatus('Loading repair options.');
        } else if (ready) {
          setStatus('Your repair configuration is complete and ready to add to the cart.');
        } else {
          setStatus(`Complete ${missing.join(', ')} to continue.`);
        }
      }

      function updateSummary() {
        const eligible = ELIGIBLE_CONTROLLERS.has(state.controller);
        const joycon = JOYCON_CONTROLLERS.has(state.controller);
        const tierCents = Number(config.tierPrices?.[state.tier] ?? 0) || 0;
        const joystickFee = itemFees[state.joystick] || 0;
        setSummary('tier', state.tier || 'Select a tier');
        setSummary('controller', state.controller || 'Select a controller');
        setSummary('joycon', state.joycon || 'Select one or a pair');
        setSummary('joystick', state.joystick === 'Hall Effect Upgrade' ? 'Hall Effect' : state.joystick === 'TMR Upgrade' ? 'TMR' : 'No upgrade');
        setSummary('mouseclick', state.mouseclick ? 'Added' : 'Not added');
        setSummary('paddles', state.paddles ? 'Added' : 'Not added');
        setSummary('send-in', state.sendInLabel || 'Select a method');
        setSummaryPrice('tier', state.tier ? formatMoney(tierCents, config.currency) : 'Pending');
        setSummaryPrice('joycon', !state.joycon ? 'Pending' : state.joycon === 'Pair of Joy-Cons' ? `Adds ${formatMoney(Math.round(tierCents * 0.8), config.currency)}` : 'Included');
        setSummaryPrice('joystick', formatMoney(joystickFee, config.currency));
        setSummaryPrice('mouseclick', formatMoney(state.mouseclick ? itemFees.mouseclick : 0, config.currency));
        setSummaryPrice('paddles', formatMoney(state.paddles ? itemFees.paddles : 0, config.currency));
        setSummaryPrice('send-in', !state.sendIn ? 'Pending' : /MAIL-IN KIT/i.test(state.sendIn) ? formatMoney(state.kitFee, config.currency) : 'Included');
        showSummaryRow('joycon', joycon && Boolean(state.joycon));
        showSummaryRow('joystick', eligible && (state.joystick === 'Hall Effect Upgrade' || state.joystick === 'TMR Upgrade'));
        showSummaryRow('mouseclick', eligible && state.mouseclick);
        showSummaryRow('paddles', eligible && state.paddles);
        updatePrice();
        updateSubmitState();
      }

      function updateControllerPanels() {
        const eligible = ELIGIBLE_CONTROLLERS.has(state.controller);
        const joycon = JOYCON_CONTROLLERS.has(state.controller);
        if (joyconPanel) joyconPanel.hidden = !joycon;
        if (upgradesPanel) upgradesPanel.hidden = !eligible;
        if (repairOnly) repairOnly.hidden = !state.controller || eligible || joycon;
        setActive('joycon', state.joycon);
        setActive('joystick', state.joystick);
        setAddonState('mouseclick', state.mouseclick);
        setAddonState('paddles', state.paddles);
        updateSummary();
      }

      function chooseSourceRadio(radios, value) {
        const radio = (radios || []).find((input) => input.value === value && !input.disabled);
        if (!radio) return false;
        if (!radio.checked) radio.click();
        return true;
      }

      function restoreConditionalSelections() {
        if (!source || restoring) return;
        restoring = true;
        refreshConditionalSources();

        if (JOYCON_CONTROLLERS.has(state.controller) && state.joycon) {
          const pairRadio = findJoyconRadio(state.joycon);
          if (pairRadio && !pairRadio.checked) pairRadio.click();
        }

        if (ELIGIBLE_CONTROLLERS.has(state.controller)) {
          const desiredJoystick = state.joystick || 'No, Keep My Analogs';
          if (chooseSourceRadio(source.joystickRadios, desiredJoystick)) state.joystick = desiredJoystick;
          if (source.mouseclick && source.mouseclick.checked !== state.mouseclick) source.mouseclick.click();
          if (source.paddles && source.paddles.checked !== state.paddles) source.paddles.click();
        }

        restoring = false;
        updateControllerPanels();
        window.setTimeout(updatePrice, 120);
      }

      function selectTier(button) {
        if (!source) return;
        const value = button.dataset.value;
        if (!chooseSourceRadio(source.tierRadios, value)) {
          showError('tier', 'This repair tier is still loading. Try it again in a moment.');
          return;
        }
        state.tier = value;
        setActive('tier', value);
        clearError('tier');
        updateSummary();
        [80, 260, 650].forEach((delay) => window.setTimeout(restoreConditionalSelections, delay));
      }

      function selectController() {
        if (!source?.controller || !controllerSelect) return;
        const value = controllerSelect.value;
        const option = findControllerOption(source.controller, value);
        if (!option && value) {
          showError('controller', 'This controller choice is not available in Infinite Options.');
          return;
        }

        source.controller.value = option?.value || '';
        dispatchValueEvents(source.controller);
        state.controller = value;
        state.joycon = '';
        state.joystick = '';
        state.mouseclick = false;
        state.paddles = false;
        clearError('controller');
        clearError('joycon');
        clearError('upgrades');
        updateControllerPanels();
        [90, 280, 650].forEach((delay) => window.setTimeout(restoreConditionalSelections, delay));
      }

      function selectJoycon(button) {
        refreshConditionalSources();
        const value = button.dataset.value;
        const radio = findJoyconRadio(value);
        if (!radio) {
          showError('joycon', 'The Joy-Con quantity options are still loading. Try again in a moment.');
          return;
        }
        radio.click();
        state.joycon = value;
        setActive('joycon', value);
        clearError('joycon');
        updateSummary();
        window.setTimeout(updatePrice, 180);
      }

      function selectJoystick(button) {
        refreshConditionalSources();
        const value = button.dataset.value;
        if (!chooseSourceRadio(source.joystickRadios, value)) {
          showError('upgrades', 'The joystick choices are still loading. Try again in a moment.');
          return;
        }
        state.joystick = value;
        setActive('joystick', value);
        clearError('upgrades');
        updateSummary();
        window.setTimeout(updatePrice, 180);
      }

      function toggleAddon(button) {
        refreshConditionalSources();
        const key = button.dataset.trAddon;
        const input = source?.[key];
        if (!input) {
          showError('upgrades', 'This upgrade is still loading. Try again in a moment.');
          return;
        }
        input.click();
        state[key] = input.checked;
        setAddonState(key, state[key]);
        clearError('upgrades');
        updateSummary();
        window.setTimeout(updatePrice, 180);
      }

      function syncProblem() {
        if (!source?.problem || !problem) return;
        source.problem.value = problem.value;
        dispatchValueEvents(source.problem);
        if (characterCount) characterCount.textContent = problem.value.length;
        if (problem.value.trim()) clearError('problem');
        updateSummary();
      }

      function selectSendIn(button) {
        if (!source?.sendIn) return;
        const option = findSelectOption(source.sendIn, button.dataset.value);
        if (!option) {
          showError('send-in', 'This mail-in method is still loading. Try it again in a moment.');
          return;
        }
        source.sendIn.value = option.value;
        dispatchValueEvents(source.sendIn);
        state.sendIn = option.value;
        state.sendInLabel = button.dataset.label || option.textContent.trim();
        setActive('send-in', button.dataset.value);
        clearError('send-in');
        updateSummary();
        window.setTimeout(updatePrice, 180);
      }

      function syncAgreement() {
        if (!source || !agreement) return;
        const checked = agreement.checked;
        const agreementValue = benchCopyTarget?.textContent.trim() || source.benchCheckbox?.value || source.benchCopy || '';
        if (source.benchCheckbox && source.benchCheckbox.checked !== checked) source.benchCheckbox.click();
        source.benchHidden.value = checked ? agreementValue : '';
        dispatchValueEvents(source.benchHidden);
        state.agreement = checked;
        if (checked) clearError('agreement');
        updateSummary();
      }

      function validate() {
        let firstInvalid = null;
        if (!state.tier) {
          showError('tier', 'Choose a repair tier.');
          firstInvalid ||= 'tier';
        }
        if (!state.controller) {
          showError('controller', 'Choose the controller you are sending.');
          firstInvalid ||= 'controller';
        }
        if (JOYCON_CONTROLLERS.has(state.controller) && !state.joycon) {
          showError('joycon', 'Choose a single Joy-Con or the discounted pair.');
          firstInvalid ||= 'controller';
        }
        if (ELIGIBLE_CONTROLLERS.has(state.controller) && !state.joystick) {
          showError('upgrades', 'Choose whether to keep the standard joysticks or install an upgrade.');
          firstInvalid ||= 'controller';
        }
        if (!problem?.value.trim()) {
          showError('problem', 'Describe the controller problem before continuing.');
          firstInvalid ||= 'problem';
        }
        if (!state.sendIn) {
          showError('send-in', 'Choose Self-Ship or the Mail-In Kit.');
          firstInvalid ||= 'send-in';
        }
        if (!state.agreement) {
          showError('agreement', 'Accept the bench fee terms to continue.');
          firstInvalid ||= 'agreement';
        }

        if (firstInvalid) {
          updateSubmitState();
          return false;
        }
        return true;
      }

      function submitOriginalForm() {
        if (!source || !validate()) return;
        restoreConditionalSelections();
        syncProblem();
        syncAgreement();
        submit.disabled = true;
        submit.setAttribute('aria-disabled', 'true');
        submit.setAttribute('aria-busy', 'true');
        if (submitLabel) submitLabel.textContent = 'Adding to cart';
        setStatus('Adding your configured repair...');
        window.setTimeout(() => source.addButton.click(), 80);

        window.setTimeout(() => {
          submit.removeAttribute('aria-busy');
          if (submitLabel) submitLabel.textContent = 'Add repair to cart';
          updateSubmitState();
        }, 1900);
      }

      function hideSourceControls() {
        source.concealedRoots = [];
        source.concealedFocusables = [];

        function conceal(node, className) {
          if (!node) return;
          source.concealedRoots.push({ node, className, ariaHidden: node.getAttribute('aria-hidden') });
          node.classList.add(className);
          node.setAttribute('aria-hidden', 'true');
          const selector = 'a[href], button, input, select, textarea, [tabindex]';
          const focusables = [
            ...(node.matches?.(selector) ? [node] : []),
            ...(node.querySelectorAll?.(selector) || [])
          ];
          focusables.forEach((element) => {
            if (source.concealedFocusables.some((item) => item.element === element)) return;
            source.concealedFocusables.push({ element, tabindex: element.getAttribute('tabindex') });
            element.setAttribute('tabindex', '-1');
          });
        }

        conceal(source.container, 'tr-repair-builder-source-control');
        conceal(source.price, 'tr-repair-builder-source-price');
        document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
          const productId = form.querySelector('input[name="product-id"]')?.value;
          if (String(productId) !== String(config.productId)) return;
          form.querySelectorAll('button[name="add"], button[type="submit"]').forEach((button) => {
            conceal(button, 'tr-repair-builder-source-submit');
          });
        });
      }

      function collapseSourceSection() {
        const nativeSection = source?.container?.closest('.shopify-section');
        if (!nativeSection || nativeSection.contains(root)) return;

        source.nativeSection = {
          node: nativeSection,
          ariaHidden: nativeSection.getAttribute('aria-hidden')
        };

        nativeSection.classList.add('tr-repair-builder-source-section');
        nativeSection.setAttribute('aria-hidden', 'true');
      }

      function restoreSourceSection() {
        const saved = source?.nativeSection;
        if (!saved?.node) return;

        saved.node.classList.remove('tr-repair-builder-source-section');
        if (saved.ariaHidden === null) saved.node.removeAttribute('aria-hidden');
        else saved.node.setAttribute('aria-hidden', saved.ariaHidden);
      }

      function restoreSourceControls() {
        source?.concealedRoots?.forEach(({ node, className, ariaHidden }) => {
          node.classList.remove(className);
          if (ariaHidden === null) node.removeAttribute('aria-hidden');
          else node.setAttribute('aria-hidden', ariaHidden);
        });
        source?.concealedFocusables?.forEach(({ element, tabindex }) => {
          if (tabindex === null) element.removeAttribute('tabindex');
          else element.setAttribute('tabindex', tabindex);
        });
      }

      function connectToInfiniteOptions() {
        const controller = document.querySelector('select[name="properties[Controller Type]"]');
        const form = controller?.form;
        const container = controller?.closest('#infiniteoptions-container');
        if (!controller || !form || !container) return false;

        const tierRadios = [...container.querySelectorAll('input[name="properties[Repair Tier]"][type="radio"]')];
        const problemSource = [...container.querySelectorAll('textarea[name="properties[Problem Described]"]')].find((element) => element.form === form);
        const sendIn = [...container.querySelectorAll('select[name="properties[Send-in]"]')].find((element) => element.form === form);
        const benchHidden = [...container.querySelectorAll(`input[name="${BENCH_PROPERTY}"]`)].find((element) => element.form === form);
        const benchCheckbox = benchHidden?.closest('fieldset')?.querySelector('input[type="checkbox"]') || null;
        const upgradesHidden = [...container.querySelectorAll('input[name="properties[Your Upgrades]"]')].find((element) => element.form === form);
        const addButton = form.querySelector('button[name="add"], button[type="submit"]');

        if (tierRadios.length < 3 || !problemSource || !sendIn || !benchHidden || !benchCheckbox || !addButton) return false;

        source = {
          form,
          container,
          controller,
          tierRadios,
          problem: problemSource,
          sendIn,
          benchHidden,
          benchCheckbox,
          benchCopy: benchCheckbox.value || '',
          upgradesHidden,
          addButton,
          price: document.querySelector('.infiniteoptions-price')
        };
        refreshConditionalSources();

        state.tier = selectedSourceRadio(tierRadios)?.value || '';
        state.controller = canonicalController(controller.value || '');
        state.joycon = selectedSourceRadio([
          findJoyconRadio('Single Joy-Con'),
          findJoyconRadio('Pair of Joy-Cons')
        ].filter(Boolean))?.value || '';
        state.joystick = selectedSourceRadio(source.joystickRadios)?.value || '';
        state.mouseclick = Boolean(source.mouseclick?.checked);
        state.paddles = Boolean(source.paddles?.checked);
        state.sendIn = sendIn.value || '';
        state.sendInLabel = sendIn.value ? displaySendInLabel(sendIn.value) : '';
        state.agreement = Boolean(benchHidden.value);

        setActive('tier', state.tier);
        setActive('send-in', state.sendIn);
        if (controllerSelect) controllerSelect.value = state.controller;
        if (problem) {
          problem.value = problemSource.value || '';
          if (characterCount) characterCount.textContent = problem.value.length;
        }
        if (agreement) agreement.checked = state.agreement;

        const mailInOption = [...sendIn.options].find((option) => /MAIL-IN KIT/i.test(option.value));
        if (mailInOption && kitPrice) {
          const cents = parseAddedPrice(mailInOption.value);
          state.kitFee = cents || FALLBACK_FEES.kit;
          kitPrice.textContent = cents ? formatMoney(cents, config.currency) : 'Included';
        }

        if (source.price) {
          priceObserver = new MutationObserver(updatePrice);
          priceObserver.observe(source.price, { childList: true, subtree: true, characterData: true });
        }

        root.dataset.trRepairInitialized = 'true';
        hideSourceControls();
        collapseSourceSection();
        updateControllerPanels();
        restoreConditionalSelections();
        updateSubmitState();
        return true;
      }

      root.querySelectorAll('[data-tr-choice="tier"]').forEach((button) => button.addEventListener('click', () => selectTier(button)));
      root.querySelectorAll('[data-tr-choice="joycon"]').forEach((button) => button.addEventListener('click', () => selectJoycon(button)));
      root.querySelectorAll('[data-tr-choice="joystick"]').forEach((button) => button.addEventListener('click', () => selectJoystick(button)));
      root.querySelectorAll('[data-tr-choice="send-in"]').forEach((button) => button.addEventListener('click', () => selectSendIn(button)));
      root.querySelectorAll('[data-tr-addon]').forEach((button) => button.addEventListener('click', () => toggleAddon(button)));
      controllerSelect?.addEventListener('change', selectController);
      problem?.addEventListener('input', syncProblem);
      agreement?.addEventListener('change', syncAgreement);
      submit?.addEventListener('click', submitOriginalForm);

      syncSummaryDisclosure();
      if (mobileSummaryQuery.addEventListener) mobileSummaryQuery.addEventListener('change', syncSummaryDisclosure);
      else mobileSummaryQuery.addListener(syncSummaryDisclosure);

      let attempts = 0;
      connectionTimer = window.setInterval(() => {
        attempts += 1;
        if (connectToInfiniteOptions()) {
          window.clearInterval(connectionTimer);
        } else if (attempts >= 120) {
          window.clearInterval(connectionTimer);
          setStatus('The repair options did not load. Refresh this page before ordering.');
        }
      }, 100);

      root._trRepairCleanup = () => {
        window.clearInterval(connectionTimer);
        priceObserver?.disconnect();
        restoreSourceSection();
        restoreSourceControls();
        if (mobileSummaryQuery.removeEventListener) mobileSummaryQuery.removeEventListener('change', syncSummaryDisclosure);
        else mobileSummaryQuery.removeListener(syncSummaryDisclosure);
      };
    }

    function initAll(scope = document) {
      if (scope.matches?.(ROOT_SELECTOR)) initRepairBuilder(scope);
      scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initRepairBuilder);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll?.(ROOT_SELECTOR).forEach((root) => root._trRepairCleanup?.());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["techrevive-visual-repair-v1"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.TechReviveNativeCart) return;

  const normalize = (value) => String(value || '')
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, ' ')
    .trim();

  const compactProperties = (properties) => Object.fromEntries(
    Object.entries(properties || {}).filter(([, value]) => {
      if (Array.isArray(value)) return value.length > 0;
      return value !== null && value !== undefined && String(value).trim() !== '';
    }).map(([key, value]) => [key, Array.isArray(value) ? value.join(', ') : String(value).trim()])
  );

  const configuredVariant = (variants, title) => {
    const wanted = normalize(title);
    return (variants || []).find((variant) => normalize(variant.title) === wanted) || null;
  };

  const configurationId = () => {
    const randomPart = window.crypto?.randomUUID?.().slice(0, 8) || Math.random().toString(36).slice(2, 10);
    return `TR-${Date.now().toString(36)}-${randomPart}`.toUpperCase();
  };

  const cartUrl = (path) => {
    const root = window.Shopify?.routes?.root || '/';
    return `${root}${path}`.replace(/\/\/{2,}/g, '/');
  };

  async function responseJson(response) {
    const data = await response.json().catch(() => ({}));
    if (!response.ok || data.status) {
      const message = data.description || data.message || 'The configured service could not be added to the cart.';
      throw new Error(message);
    }
    return data;
  }

  async function addConfiguration({
    root,
    productId,
    parentVariantId,
    parentProperties,
    addOns = [],
    addonVariants = [],
    serviceLabel = 'Configured service'
  }) {
    const parentId = Number(parentVariantId);
    if (!Number.isFinite(parentId) || parentId <= 0) {
      throw new Error('The selected service tier is unavailable. Refresh the page and try again.');
    }

    const id = configurationId();
    const parent = {
      id: parentId,
      quantity: 1,
      properties: compactProperties({
        ...parentProperties,
        '_TechRevive configuration ID': id
      })
    };

    const children = addOns.map((addOn) => {
      const variant = configuredVariant(addonVariants, addOn.variantTitle);
      if (!variant) {
        throw new Error(`The ${addOn.label || addOn.variantTitle} price item is not connected yet.`);
      }
      if (variant.available === false) {
        throw new Error(`${addOn.label || addOn.variantTitle} is temporarily unavailable.`);
      }

      return {
        id: Number(variant.id),
        quantity: Number(addOn.quantity) || 1,
        parent_id: parentId,
        properties: compactProperties({
          '_TechRevive configuration ID': id,
          '_Configured for': serviceLabel,
          ...(addOn.properties || {})
        })
      };
    });

    const sectionIds = [...document.querySelectorAll('cart-items-component[data-section-id]')]
      .map((element) => element.dataset.sectionId)
      .filter(Boolean);

    const response = await fetch(cartUrl('cart/add.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [parent, ...children],
        sections: [...new Set(sectionIds)].join(',')
      })
    });
    const added = await responseJson(response);

    const cartResponse = await fetch(cartUrl('cart.js'), {
      headers: { Accept: 'application/json' }
    });
    const cart = await responseJson(cartResponse);

    (root || document).dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: root?.id || String(parentId),
        data: {
          source: 'product-form-component',
          itemCount: 1 + children.length,
          productId: String(productId || ''),
          variantId: String(parentId),
          sections: added.sections || {}
        }
      }
    }));

    return { added, cart };
  }

  window.TechReviveNativeCart = { addConfiguration };
})();

(()=>{
const ARTWORK={"dualsense":{"file":"ps5-dualsense-outline.svg","anchors":{"lshoulder":[225,790],"rshoulder":[863,790],"lstick":[344,1118],"rstick":[744,1118],"dpad":[190,956],"face":[975,966],"touch":[751,854],"system":[544,1114],"usb":[544,782]},"viewBox":[-26,740,1140,830],"body":"\n\n\n<g fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n <path data-part=\"outer-shell\" d=\"M319 799Q311 782 276 782C205 778 155 810 117 859C60 944 25 1051 16 1179C7 1300 10 1396 28 1454Q40 1495 72 1507L154 1513C178 1482 193 1446 208 1407L255 1290Q268 1243 311 1248Q544 1261 777 1248Q820 1243 833 1290L880 1407C895 1446 910 1482 934 1513L1016 1507Q1048 1495 1060 1454C1078 1396 1081 1300 1072 1179C1063 1051 1028 944 971 859C933 810 883 778 812 782Q777 782 769 799Q544 771 319 799Z\"/>\n <path data-part=\"left-grip-seam\" d=\"M331 801 339 951Q343 1007 310 1039C214 1144 145 1308 77 1507\"/>\n <path data-part=\"right-grip-seam\" d=\"M757 801 749 951Q745 1007 778 1039C874 1144 943 1308 1011 1507\"/>\n <g data-part=\"touchpad\" data-art=\"touch\">\n<path d=\"M338 794Q544 777 750 794Q769 796 767 817L743 958Q736 1009 686 1012H402Q352 1009 345 958L321 817Q319 796 338 794Z\"/>\n<path d=\"M340 791Q544 777 748 791Q765 792 763 812L739 952Q733 997 687 998H401Q355 997 349 952L325 812Q323 792 340 791Z\"/>\n</g>\n <g data-part=\"system-buttons\" data-art=\"system\">\n  <rect data-part=\"create-button\" x=\"277\" y=\"821\" width=\"26\" height=\"44\" rx=\"12\" transform=\"rotate(-6 290 843)\"/>\n  <rect data-part=\"options-button\" x=\"785\" y=\"821\" width=\"26\" height=\"44\" rx=\"12\" transform=\"rotate(6 798 843)\"/>\n </g>\n     <g data-part=\"d-pad\" data-art=\"dpad\" transform=\"translate(190 956) scale(1.75)\">\n      <path d=\"M-13-47H13Q18-47 18-42V-19L0-5-18-19V-42Q-18-47-13-47Z\"/>\n      <path d=\"M-13-47H13Q18-47 18-42V-19L0-5-18-19V-42Q-18-47-13-47Z\" transform=\"rotate(90)\"/>\n      <path d=\"M-13-47H13Q18-47 18-42V-19L0-5-18-19V-42Q-18-47-13-47Z\" transform=\"rotate(180)\"/>\n      <path d=\"M-13-47H13Q18-47 18-42V-19L0-5-18-19V-42Q-18-47-13-47Z\" transform=\"rotate(270)\"/>\n      <g><path d=\"m0-35-5 6H5Z\"/><path d=\"m35 0-6-5V5Z\"/><path d=\"m0 35 5-6H-5Z\"/><path d=\"m-35 0 6 5V-5Z\"/></g>\n    </g>\n\n <g transform=\"translate(-399.1 556.3) scale(1.7)\">    <g data-part=\"face-buttons\" data-art=\"face\">\n      <g data-part=\"triangle-button\"><circle cx=\"763\" cy=\"195\" r=\"24\"/><path d=\"m763 183 12 21h-24Z\"/></g>\n      <g data-part=\"circle-button\"><circle cx=\"809\" cy=\"241\" r=\"24\"/><circle cx=\"809\" cy=\"241\" r=\"11\"/></g>\n      <g data-part=\"cross-button\"><circle cx=\"763\" cy=\"287\" r=\"24\"/><path d=\"m754 278 18 18m0-18-18 18\"/></g>\n      <g data-part=\"square-button\"><circle cx=\"717\" cy=\"241\" r=\"24\"/><path d=\"M707 231h20v20h-20Z\"/></g>\n    </g>\n</g>\n <g data-part=\"left-joystick\" data-art=\"lstick\" transform=\"translate(344 1118)\">\n <circle r=\"79\"/>\n <circle r=\"69\"/>\n \n <circle r=\"49\"/>\n \n</g>\n <g data-part=\"right-joystick\" data-art=\"rstick\" transform=\"translate(744 1118)\">\n <circle r=\"79\"/>\n <circle r=\"69\"/>\n \n <circle r=\"49\"/>\n \n</g>\n <g data-part=\"speaker\" data-art=\"audio\">\n  <circle cx=\"502\" cy=\"1035\" r=\"5.7\"/><circle cx=\"523\" cy=\"1035\" r=\"5.7\"/><circle cx=\"544\" cy=\"1035\" r=\"5.7\"/><circle cx=\"565\" cy=\"1035\" r=\"5.7\"/><circle cx=\"586\" cy=\"1035\" r=\"5.7\"/>\n  <circle cx=\"512.5\" cy=\"1055\" r=\"5.2\"/><circle cx=\"533.5\" cy=\"1055\" r=\"5.2\"/><circle cx=\"554.5\" cy=\"1055\" r=\"5.2\"/><circle cx=\"575.5\" cy=\"1055\" r=\"5.2\"/>\n </g>\n <g transform=\"translate(-275.2 557.2) scale(1.6)\">    <g data-part=\"ps-button\" data-art=\"system\">\n      <path d=\"M507 330V354L513 356V336Q520 338 520 343Q520 347 516 346V351Q526 353 526 343Q526 334 507 330Z\"/>\n      <path d=\"M504 346 494 350Q486 354 497 357L505 359V354L501 353Q498 352 503 351L505 350V346ZM517 352V357L527 354Q530 353 533 354Q535 355 531 356L518 361V365L537 358Q545 354 536 351Q528 349 517 352Z\"/>\n    </g>\n</g>\n <g data-part=\"mute-button\" data-art=\"system\"><rect x=\"515\" y=\"1182\" width=\"58\" height=\"15\" rx=\"7.5\"/><path d=\"M538 1239h12\"/></g>\n</g>\n","sourceHash":"bc217c47bdd94ec6fbc9025dd0ec98f8f43e09ec90ad778444dcfba7e1d6fa5e","mappedParts":[{"part":"touchpad","areas":["touch"]},{"part":"system-buttons","areas":["system"]},{"part":"d-pad","areas":["dpad"]},{"part":"face-buttons","areas":["face"]},{"part":"left-joystick","areas":["lstick"]},{"part":"right-joystick","areas":["rstick"]},{"part":"speaker","areas":["audio"]},{"part":"ps-button","areas":["system"]},{"part":"mute-button","areas":["system"]}]},"dualshock":{"file":"ps4-dualshock-4-outline.svg","anchors":{"lshoulder":[242,67],"rshoulder":[766,67],"lstick":[364,337],"rstick":[644,337],"dpad":[234,217],"face":[838,217],"touch":[652,133],"system":[504,339],"usb":[504,97]},"viewBox":[0,0,1010,670],"body":"\n  \n  \r\n  <g transform=\"translate(-180 -159) scale(2)\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n    <g data-part=\"shoulder-buttons\">\n      <path data-part=\"left-bumper\" data-art=\"lb lt\" d=\"M180 121 182 116Q183 112 190 112H231Q239 112 241 116L243 122\"/>\n      <path data-part=\"right-bumper\" data-art=\"rb rt\" d=\"m504 121-2-5q-1-4-8-4h-41q-8 0-10 4l-2 6\"/>\n    </g>\n    <path data-part=\"outer-shell\" d=\"M182 120Q211 116 239 120Q250 128 269 128H415Q434 128 445 120Q473 116 502 120C520 143 532 176 542 211C553 249 562 283 565 313C568 341 560 367 540 378C517 391 490 381 476 363C463 347 458 326 451 297Q447 279 443 275M385.17 279H298.83M241 275Q237 279 233 297C226 326 221 347 208 363C194 381 167 391 144 378C124 367 116 341 119 313C122 283 131 249 142 211C152 176 164 143 182 120\"/>\n    <g data-part=\"grip-seams\">\n      <path data-part=\"left-grip-seam\" d=\"M119 307C118 324 124 331 142 336C161 342 181 347 196 347Q215 347 223 323L237 282\"/>\n      <path data-part=\"right-grip-seam\" d=\"M565 307C566 324 560 331 542 336C523 342 503 347 488 347Q469 347 461 323L447 282\"/>\n    </g>\n    <g data-part=\"control-panels\">\n      <path data-part=\"d-pad-panel\" d=\"M251.86 212.27A51 51 0 1 0 234.84 230.73\"/>\n      <path data-part=\"face-button-panel\" d=\"M432.14 212.27A51 51 0 1 1 449.16 230.73\"/>\n    </g>\n    <g data-part=\"touchpad\" data-art=\"touch\">\n      <path d=\"M272 128H412Q416 128 416 132V194Q416 199 411 199H273Q268 199 268 194V132Q268 128 272 128Z\"/>\n    </g>\n    <g data-part=\"system-buttons\" data-art=\"system\">\n      <rect data-part=\"share-button\" data-art=\"system\" x=\"247\" y=\"133\" width=\"13\" height=\"23\" rx=\"6.5\"/>\n      <rect data-part=\"options-button\" x=\"424\" y=\"133\" width=\"13\" height=\"23\" rx=\"6.5\"/>\n    </g>\n    <g data-part=\"d-pad\" data-art=\"dpad\" transform=\"translate(207 188)\">\n      <path data-part=\"d-pad-up\" d=\"M-8-32H8Q10-32 10-30V-14L0-3-10-14V-30Q-10-32-8-32Z\"/>\n      <path data-part=\"d-pad-right\" d=\"M-8-32H8Q10-32 10-30V-14L0-3-10-14V-30Q-10-32-8-32Z\" transform=\"rotate(90)\"/>\n      <path data-part=\"d-pad-down\" d=\"M-8-32H8Q10-32 10-30V-14L0-3-10-14V-30Q-10-32-8-32Z\" transform=\"rotate(180)\"/>\n      <path data-part=\"d-pad-left\" d=\"M-8-32H8Q10-32 10-30V-14L0-3-10-14V-30Q-10-32-8-32Z\" transform=\"rotate(270)\"/>\n    </g>\n    <g data-part=\"face-buttons\" data-art=\"face\">\n      <g data-part=\"triangle-button\"><circle cx=\"477\" cy=\"156\" r=\"12.5\"/><path d=\"m477 149 7 12h-14Z\" stroke-width=\"1\"/></g>\n      <g data-part=\"circle-button\"><circle cx=\"509\" cy=\"188\" r=\"12.5\"/><circle cx=\"509\" cy=\"188\" r=\"6.5\" stroke-width=\"1\"/></g>\n      <g data-part=\"cross-button\"><circle cx=\"477\" cy=\"220\" r=\"12.5\"/><path d=\"m472 215 10 10m0-10-10 10\" stroke-width=\"1\"/></g>\n      <g data-part=\"square-button\"><circle cx=\"445\" cy=\"188\" r=\"12.5\"/><path d=\"M439.5 182.5h11v11h-11Z\" stroke-width=\"1\"/></g>\n    </g>\n    <g data-part=\"left-joystick\" data-art=\"lstick\" transform=\"translate(272 248)\">\n      <circle data-part=\"left-stick-housing\" r=\"41\"/>\n      <circle r=\"28\"/>\n      <circle r=\"18\"/>\n    </g>\n    <g data-part=\"right-joystick\" data-art=\"rstick\" transform=\"translate(412 248)\">\n      <circle data-part=\"right-stick-housing\" r=\"41\"/>\n      <circle r=\"28\"/>\n      <circle r=\"18\"/>\n    </g>\n    <g data-part=\"speaker\" data-art=\"audio\" stroke-width=\".9\">\n      <circle cx=\"325\" cy=\"217\" r=\"1.7\"/><circle cx=\"333.5\" cy=\"217\" r=\"1.7\"/><circle cx=\"342\" cy=\"217\" r=\"1.7\"/><circle cx=\"350.5\" cy=\"217\" r=\"1.7\"/><circle cx=\"359\" cy=\"217\" r=\"1.7\"/>\n      <circle cx=\"329.25\" cy=\"223\" r=\"1.7\"/><circle cx=\"337.75\" cy=\"223\" r=\"1.7\"/><circle cx=\"346.25\" cy=\"223\" r=\"1.7\"/><circle cx=\"354.75\" cy=\"223\" r=\"1.7\"/>\n      <circle cx=\"333.5\" cy=\"229\" r=\"1.7\"/><circle cx=\"342\" cy=\"229\" r=\"1.7\"/><circle cx=\"350.5\" cy=\"229\" r=\"1.7\"/>\n    </g>\n    <g data-part=\"ps-button\" data-art=\"system\">\n      <circle cx=\"342\" cy=\"249\" r=\"11\"/>\n      <g transform=\"translate(337.5 242.5) scale(.32)\" stroke-width=\"1.8\">\n        <path d=\"M10 0V24L16 26V6Q23 8 23 13Q23 17 19 16V21Q29 23 29 13Q29 4 10 0Z\"/>\n        <path d=\"M7 16-3 20Q-11 24 0 27L8 29V24L4 23Q1 22 6 21L8 20V16ZM20 22V27L30 24Q33 23 36 24Q38 25 34 26L21 31V35L40 28Q48 24 39 21Q31 19 20 22Z\"/>\n      </g>\n    </g>\n  </g>\n","sourceHash":"494edc0958a9cdf9d812dca89dde2e660b188d4694853f525690e96bccba7351","mappedParts":[{"part":"left-bumper","areas":["lb","lt"]},{"part":"right-bumper","areas":["rb","rt"]},{"part":"touchpad","areas":["touch"]},{"part":"system-buttons","areas":["system"]},{"part":"share-button","areas":["system"]},{"part":"d-pad","areas":["dpad"]},{"part":"face-buttons","areas":["face"]},{"part":"left-joystick","areas":["lstick"]},{"part":"right-joystick","areas":["rstick"]},{"part":"speaker","areas":["audio"]},{"part":"ps-button","areas":["system"]}]},"xboxseries":{"file":"xbox-series-controller-outline.svg","anchors":{"lshoulder":[340,13],"rshoulder":[860,13],"lstick":[310,219],"rstick":[765,423],"dpad":[427,446],"face":[988,247],"system":[514,239],"usb":[600,38]},"viewBox":[-30,-30,1260,910],"body":"\n  \n  \n  <g fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n    <g data-part=\"shoulder-buttons\">\n      <path data-part=\"left-bumper\" data-art=\"lb lt\" d=\"M195 112C208 82 220 62 242 49C281 24 342 9 379 4Q394 0 402 9L434 40\"/>\n      <path data-part=\"right-bumper\" data-art=\"rb rt\" d=\"M1005 112C992 82 980 62 958 49C919 24 858 9 821 4Q806 0 798 9L766 40\"/>\n    </g>\n    <path data-part=\"outer-shell\" d=\"M600 38C413 35 263 44 195 112C157 152 118 252 80 362C45 463 19 554 12 620C3 689 17 750 48 791C65 814 98 837 124 842Q145 848 163 832C239 766 299 691 357 626Q378 601 405 595C447 585 528 588 600 588C672 588 753 585 795 595Q822 601 843 626C901 691 961 766 1037 832Q1055 848 1076 842C1102 837 1135 814 1152 791C1183 750 1197 689 1188 620C1181 554 1155 463 1120 362C1082 252 1043 152 1005 112C937 44 787 35 600 38Z\"/>\n    <g data-part=\"xbox-button\" data-art=\"system\">\n      <circle cx=\"600\" cy=\"123\" r=\"53\"/>\n      <path d=\"M565 87Q582 83 600 94Q618 83 635 87Q620 96 612 104Q637 131 643 153Q621 130 600 113Q579 130 557 153Q563 131 588 104Q578 96 565 87Z\" stroke-width=\"2.3\"/>\n    </g>\n    <g data-part=\"left-joystick\" data-art=\"lstick\" transform=\"translate(310 219)\">\n      <circle r=\"72\"/>\n      <circle r=\"62\" stroke-width=\"2\"/>\n      <circle r=\"45\"/>\n    </g>\n    <g data-part=\"right-joystick\" data-art=\"rstick\" transform=\"translate(765 423)\">\n      <circle r=\"72\"/>\n      <circle r=\"62\" stroke-width=\"2\"/>\n      <circle r=\"45\"/>\n    </g>\n    <g data-part=\"d-pad\" data-art=\"dpad\">\n      <circle cx=\"427\" cy=\"446\" r=\"99\"/>\n      <path d=\"M389 354.58V537.42M465 354.58V537.42M335.18 409H518.82M336.01 485H517.99\" stroke-width=\"2.4\"/>\n    </g>\n    <g data-part=\"face-buttons\" data-art=\"face\">\n      <g data-part=\"y-button\">\n        <circle cx=\"906\" cy=\"164\" r=\"44\"/>\n        <path d=\"m889 143 17 27 17-27m-17 27v21\" stroke-width=\"3.5\"/>\n      </g>\n      <g data-part=\"x-button\">\n        <circle cx=\"824\" cy=\"247\" r=\"44\"/>\n        <path d=\"m808 224 32 46m0-46-32 46\" stroke-width=\"3.5\"/>\n      </g>\n      <g data-part=\"b-button\">\n        <circle cx=\"988\" cy=\"247\" r=\"44\"/>\n        <path d=\"M976 225V269M976 225H989Q1003 225 1003 236Q1003 247 989 247H976M989 247Q1006 247 1006 258Q1006 269 989 269H976\" stroke-width=\"3.5\"/>\n      </g>\n      <g data-part=\"a-button\">\n        <circle cx=\"906\" cy=\"330\" r=\"44\"/>\n        <path d=\"m888 353 18-47 18 47m-29-16h22\" stroke-width=\"3.5\"/>\n      </g>\n    </g>\n    <g data-part=\"view-button\" data-art=\"system\">\n      <circle cx=\"514\" cy=\"239\" r=\"36\"/>\n      <path d=\"M526 222V219H493V244H499M504 230H536V256H504Z\" stroke-width=\"2.7\"/>\n    </g>\n    <g data-part=\"menu-button\" data-art=\"system\">\n      <circle cx=\"684\" cy=\"239\" r=\"36\"/>\n      <path d=\"M663 225H705M663 239H705M663 253H705\" stroke-width=\"3\"/>\n    </g>\n    <g data-part=\"share-button\" data-art=\"system\">\n      <ellipse cx=\"600\" cy=\"320\" rx=\"41\" ry=\"22\"/>\n      <path d=\"M577 315V329H623V315M600 321V303M594 309L600 303L606 309\" stroke-width=\"2.7\"/>\n    </g>\n  </g>\n","sourceHash":"048c85af304c71355e092720f4f0e0aeecb53de6107141b78169e06a0119ba97","mappedParts":[{"part":"left-bumper","areas":["lb","lt"]},{"part":"right-bumper","areas":["rb","rt"]},{"part":"xbox-button","areas":["system"]},{"part":"left-joystick","areas":["lstick"]},{"part":"right-joystick","areas":["rstick"]},{"part":"d-pad","areas":["dpad"]},{"part":"face-buttons","areas":["face"]},{"part":"view-button","areas":["system"]},{"part":"menu-button","areas":["system"]},{"part":"share-button","areas":["system"]}]},"xboxone":{"file":"xbox-one-controller-outline.svg","anchors":{"lshoulder":[277,73],"rshoulder":[733,73],"lstick":[279,241],"rstick":[621,381],"dpad":[389,389],"face":[811,241],"system":[439,241],"usb":[505,81]},"viewBox":[0,0,1010,700],"body":"\n  \n  \n  <g transform=\"translate(-159 -135) scale(2)\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n    <path data-part=\"outer-shell\" d=\"M270 108H394Q407 108 416 99Q420 96 428 99C451 103 476 111 486 121Q493 129 499 142C513 163 522 199 531 235C542 277 551 315 553 338C556 369 548 383 525 388C507 393 491 390 474 379C452 365 433 343 414 330Q401 320 382 318Q332 314 282 318Q263 320 250 330C231 343 212 365 190 379C173 390 157 393 139 388C116 383 108 369 111 338C113 315 122 277 133 235C142 199 151 163 165 142Q171 129 178 121C188 111 213 103 236 99Q244 96 248 99Q257 108 270 108Z\" stroke-width=\"1.4\"/>\n    <g data-part=\"upper-housing\">\n      <path data-part=\"shoulder-seam\" d=\"M168 137C187 123 216 114 237 111Q246 110 254 115H410Q418 110 427 111C448 114 477 123 496 137\"/>\n      <path data-part=\"front-panel-seam\" d=\"M165 143C185 130 214 121 237 117Q247 116 256 125L281 151Q291 162 308 162H356Q373 162 383 151L408 125Q417 116 427 117C450 121 479 130 499 143\"/>\n      <path data-part=\"left-bumper-joint\" data-art=\"lb lt\" d=\"M270 108V115\"/>\n      <path data-part=\"right-bumper-joint\" data-art=\"rb rt\" d=\"M394 108V115\"/>\n    </g>\n    <path data-part=\"lower-housing-seam\" d=\"M149 389C176 383 204 354 237 327Q255 312 275 311Q332 306 389 311Q409 312 427 327C460 354 488 383 515 389\"/>\n    <g data-part=\"xbox-button\" data-art=\"system\" transform=\"translate(332 140)\">\n      <circle r=\"18\"/>\n      <path d=\"M-12-12Q-6-14 0-10Q6-14 12-12Q7-8 4-6Q13 3 15 11Q7 3 0-3Q-7 3-15 11Q-13 3-4-6Q-7-8-12-12Z\" stroke-width=\".9\"/>\n    </g>\n    <g data-part=\"left-joystick\" data-art=\"lstick\" transform=\"translate(219 188)\">\n      <circle r=\"36\"/>\n      <circle r=\"29\"/>\n      <circle r=\"22\"/>\n    </g>\n    <g data-part=\"right-joystick\" data-art=\"rstick\" transform=\"translate(390 258)\">\n      <circle r=\"36\"/>\n      <circle r=\"29\"/>\n      <circle r=\"22\"/>\n    </g>\n    <g data-part=\"d-pad\" data-art=\"dpad\">\n      <circle cx=\"274\" cy=\"262\" r=\"36\"/>\n      <path d=\"M264 227.42V248Q264 251 261 251H239.72M284 227.42V248Q284 251 287 251H308.28M308.28 273H287Q284 273 284 276V296.58M264 296.58V276Q264 273 261 273H239.72\"/>\n    </g>\n    <g data-part=\"face-buttons\" data-art=\"face\">\n      <g data-part=\"y-button\"><circle cx=\"453\" cy=\"156\" r=\"16\"/><path d=\"m447 148 6 9 6-9m-6 9v8\" stroke-width=\"1.1\"/></g>\n      <g data-part=\"x-button\"><circle cx=\"421\" cy=\"188\" r=\"16\"/><path d=\"m415 180 12 16m0-16-12 16\" stroke-width=\"1.1\"/></g>\n      <g data-part=\"b-button\"><circle cx=\"485\" cy=\"188\" r=\"16\"/><path d=\"M480 180V196M480 180H485Q491 180 491 184Q491 188 485 188H480M485 188Q492 188 492 192Q492 196 485 196H480\" stroke-width=\"1.1\"/></g>\n      <g data-part=\"a-button\"><circle cx=\"453\" cy=\"220\" r=\"16\"/><path d=\"m446.5 228 6.5-16 6.5 16m-11-5.5h9\" stroke-width=\"1.1\"/></g>\n    </g>\n    <g data-part=\"view-button\" data-art=\"system\">\n      <circle cx=\"299\" cy=\"188\" r=\"11\"/>\n      <path d=\"M302 183V181H293V189H295M296 184H305V192H296Z\" stroke-width=\".9\"/>\n    </g>\n    <g data-part=\"menu-button\" data-art=\"system\">\n      <circle cx=\"365\" cy=\"188\" r=\"11\"/>\n      <path d=\"M359 183H371M359 188H371M359 193H371\" stroke-width=\".9\"/>\n    </g>\n  </g>\n","sourceHash":"b4fb63b8155257e6b549beda57a9ad2f8fdccd0566e783df8305bb0780094118","mappedParts":[{"part":"left-bumper-joint","areas":["lb","lt"]},{"part":"right-bumper-joint","areas":["rb","rt"]},{"part":"xbox-button","areas":["system"]},{"part":"left-joystick","areas":["lstick"]},{"part":"right-joystick","areas":["rstick"]},{"part":"d-pad","areas":["dpad"]},{"part":"face-buttons","areas":["face"]},{"part":"view-button","areas":["system"]},{"part":"menu-button","areas":["system"]}]},"switchpro":{"file":"switch-pro-controller-outline.svg","anchors":{"lshoulder":[535,421],"rshoulder":[1035,421],"lstick":[493,636],"rstick":[923,782],"dpad":[622,782],"face":[1146,638],"system":[710,639],"usb":[785,430]},"viewBox":[215,380,1140,805],"body":"\n  \n  \n  <g fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n    <g data-part=\"shoulder-buttons\">\n      <path data-part=\"left-bumper\" data-art=\"lb lt\" d=\"M374 503Q393 457 437 441C477 424 530 416 575 416L625 438V441\"/>\n      <path data-part=\"right-bumper\" data-art=\"rb rt\" d=\"M1196 503Q1177 457 1133 441C1093 424 1040 416 995 416L945 438V441\"/>\n      <path data-part=\"top-bridge\" d=\"M625 432Q785 425 945 432\"/>\n    </g>\n    <path data-part=\"upper-shell-edge\" d=\"M350 530L365 508L374 503C419 460 522 447 625 441Q785 435 945 441C1048 447 1151 460 1196 503L1205 508L1220 530\"/>\n    <path data-part=\"outer-shell\" d=\"M785 457C642 457 527 463 461 482Q426 489 402 503L350 530C337 552 330 579 321 625C297 737 272 852 258 944C242 1008 239 1053 251 1089C264 1129 297 1145 330 1150C365 1158 388 1143 410 1121C449 1083 471 1024 491 980Q507 932 547 931H1023Q1063 932 1079 980C1099 1024 1121 1083 1160 1121C1182 1143 1205 1158 1240 1150C1273 1145 1306 1129 1319 1089C1331 1053 1328 1008 1312 944C1298 852 1273 737 1249 625C1240 579 1233 552 1220 530L1168 503Q1144 489 1109 482C1043 463 928 457 785 457Z\" stroke-width=\"2.8\"/>\n    <g data-part=\"grip-seams\">\n      <path data-part=\"left-grip-seam\" d=\"M316 649C367 740 435 828 530 934\"/>\n      <path data-part=\"right-grip-seam\" d=\"M1254 649C1203 740 1135 828 1040 934\"/>\n    </g>\n    <g data-part=\"left-joystick\" data-art=\"lstick\" transform=\"translate(493 636)\">\n      <circle r=\"97\"/>\n      <circle r=\"83\" stroke-width=\"2\"/>\n      <circle r=\"61\"/>\n    </g>\n    <g data-part=\"right-joystick\" data-art=\"rstick\" transform=\"translate(923 782)\">\n      <circle r=\"97\"/>\n      <circle r=\"83\" stroke-width=\"2\"/>\n      <circle r=\"61\"/>\n    </g>\n    <g data-part=\"d-pad\" data-art=\"dpad\">\n      <circle cx=\"622\" cy=\"782\" r=\"97\" stroke-width=\"1.8\"/>\n      <path d=\"M607 708H636Q645 708 645 718V754Q645 762 653 762H689Q698 762 698 771V797Q698 806 689 806H653Q645 806 645 814V850Q645 860 636 860H608Q599 860 599 850V814Q599 806 591 806H555Q546 806 546 797V771Q546 762 555 762H591Q599 762 599 754V718Q599 708 607 708Z\"/>\n      <g stroke-width=\"1.7\"><path d=\"m622 726-5 8h10Z\"/><path d=\"m681 782-8-5v10Z\"/><path d=\"m622 842 5-8h-10Z\"/><path d=\"m563 782 8 5v-10Z\"/></g>\n    </g>\n    <g data-part=\"face-buttons\" data-art=\"face\">\n      <g data-part=\"x-button\"><circle cx=\"1065\" cy=\"566\" r=\"41\"/><path d=\"m1052 548 26 36m0-36-26 36\" stroke-width=\"3\"/></g>\n      <g data-part=\"y-button\"><circle cx=\"983\" cy=\"638\" r=\"41\"/><path d=\"m969 620 14 22 14-22m-14 22v17\" stroke-width=\"3\"/></g>\n      <g data-part=\"a-button\"><circle cx=\"1146\" cy=\"638\" r=\"41\"/><path d=\"m1130 658 16-41 16 41m-26-14h20\" stroke-width=\"3\"/></g>\n      <g data-part=\"b-button\"><circle cx=\"1065\" cy=\"712\" r=\"41\"/><path d=\"M1054 693V731M1054 693H1065Q1078 693 1078 702Q1078 712 1065 712H1054M1065 712Q1081 712 1081 722Q1081 731 1065 731H1054\" stroke-width=\"3\"/></g>\n    </g>\n    <g data-part=\"minus-button\" data-art=\"system\">\n      <circle cx=\"655\" cy=\"557\" r=\"35\"/>\n      <circle cx=\"655\" cy=\"557\" r=\"24\" stroke-width=\"2\"/>\n      <path d=\"M644 557H666\" stroke-width=\"3\"/>\n    </g>\n    <g data-part=\"plus-button\" data-art=\"system\">\n      <circle cx=\"915\" cy=\"557\" r=\"35\"/>\n      <circle cx=\"915\" cy=\"557\" r=\"24\" stroke-width=\"2\"/>\n      <path d=\"M904 557H926M915 546V568\" stroke-width=\"3\"/>\n    </g>\n    <g data-part=\"capture-button\" data-art=\"system\">\n      <rect x=\"689\" y=\"618\" width=\"42\" height=\"42\" rx=\"6\"/>\n      <rect x=\"694\" y=\"623\" width=\"32\" height=\"32\" rx=\"4\" stroke-width=\"1.8\"/>\n      <circle cx=\"710\" cy=\"639\" r=\"10\" stroke-width=\"1.8\"/>\n    </g>\n    <g data-part=\"home-button\" data-art=\"system\">\n      <circle cx=\"860\" cy=\"640\" r=\"30\"/>\n      <circle cx=\"860\" cy=\"640\" r=\"22\" stroke-width=\"1.8\"/>\n      <path d=\"m848 638 12-10 12 10m-22-2v17h20v-17m-13 17v-9h6v9\" stroke-width=\"1.8\"/>\n    </g>\n    <g data-part=\"switch-emblem\" stroke-width=\"2\">\n      <path d=\"M780 474H765Q748 474 748 494V530Q748 550 765 550H780Z\"/>\n      <path d=\"M772 481H765Q755 481 755 494V530Q755 543 765 543H772Z\"/>\n      <path d=\"M792 474H805Q823 474 823 494V530Q823 550 805 550H792Z\"/>\n      <circle cx=\"764\" cy=\"496\" r=\"7\"/>\n      <circle cx=\"807\" cy=\"518\" r=\"7\"/>\n    </g>\n  </g>\n","sourceHash":"a3469a8cb3e68122795a2ccda2e9dea416c6119189a9bafd9133b155bc026338","mappedParts":[{"part":"left-bumper","areas":["lb","lt"]},{"part":"right-bumper","areas":["rb","rt"]},{"part":"left-joystick","areas":["lstick"]},{"part":"right-joystick","areas":["rstick"]},{"part":"d-pad","areas":["dpad"]},{"part":"face-buttons","areas":["face"]},{"part":"minus-button","areas":["system"]},{"part":"plus-button","areas":["system"]},{"part":"capture-button","areas":["system"]},{"part":"home-button","areas":["system"]}]},"joycon":{"file":"switch-joycon-pair-outline.svg","joy":true,"anchors":{"lshoulder":[159,75],"rshoulder":[399,75],"lstick":[162,195],"rstick":[402,345],"lbuttons":[124,330],"rbuttons":[440,204],"lsystem":[109,403],"rsystem":[449,407],"lrail":[243,448],"rrail":[315,448]},"viewBox":[39,45,480,470],"body":"\n  \n  \n  <g fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n    <g data-part=\"left-joycon\" data-unit=\"l\">\n      <path data-part=\"left-shell\" d=\"M233 75H159C114 75 77 112 77 157V403C77 448 114 485 159 485H233Z\"/>\n      <path data-part=\"left-rail\" data-art=\"l.sidebuttons l.sync l.attachment l.charging\" d=\"M233 97H253V457H233\"/>\n      <g data-part=\"left-joystick\" data-art=\"l.stick\" transform=\"translate(162 195)\">\n        <circle r=\"42\"/>\n        <circle r=\"32\" stroke-width=\"1.1\"/>\n        <circle r=\"24\"/>\n      </g>\n      <g data-part=\"left-direction-buttons\" data-art=\"l.buttons\">\n        <g data-part=\"direction-up\"><circle cx=\"162\" cy=\"292\" r=\"19\"/><path d=\"m162 285-5 8h10Z\" stroke-width=\"1.1\"/></g>\n        <g data-part=\"direction-left\"><circle cx=\"124\" cy=\"330\" r=\"19\"/><path d=\"m117 330 8 5v-10Z\" stroke-width=\"1.1\"/></g>\n        <g data-part=\"direction-right\"><circle cx=\"200\" cy=\"330\" r=\"19\"/><path d=\"m207 330-8-5v10Z\" stroke-width=\"1.1\"/></g>\n        <g data-part=\"direction-down\"><circle cx=\"162\" cy=\"368\" r=\"19\"/><path d=\"m162 375 5-8h-10Z\" stroke-width=\"1.1\"/></g>\n      </g>\n      <path data-part=\"minus-button\" data-art=\"l.system\" d=\"M177 110H219V127H177Z\"/>\n      <g data-part=\"capture-button\" data-art=\"l.system\"><rect x=\"95\" y=\"389\" width=\"28\" height=\"28\" rx=\"2\"/><circle cx=\"109\" cy=\"403\" r=\"10\" stroke-width=\"1.1\"/></g>\n    </g>\n    <g data-part=\"right-joycon\" data-unit=\"r\">\n      <path data-part=\"right-shell\" d=\"M325 75H399C444 75 481 112 481 157V403C481 448 444 485 399 485H325Z\"/>\n      <path data-part=\"right-rail\" data-art=\"r.sidebuttons r.sync r.attachment r.charging\" d=\"M325 97H305V457H325\"/>\n      <g data-part=\"right-joystick\" data-art=\"r.stick\" transform=\"translate(402 345)\">\n        <circle r=\"42\"/>\n        <circle r=\"32\" stroke-width=\"1.1\"/>\n        <circle r=\"24\"/>\n      </g>\n      <g data-part=\"right-face-buttons\" data-art=\"r.buttons\">\n        <g data-part=\"x-button\"><circle cx=\"402\" cy=\"166\" r=\"19\"/><path d=\"m396 158 12 16m0-16-12 16\" stroke-width=\"1.3\"/></g>\n        <g data-part=\"y-button\"><circle cx=\"364\" cy=\"204\" r=\"19\"/><path d=\"m358 196 6 9 6-9m-6 9v8\" stroke-width=\"1.3\"/></g>\n        <g data-part=\"a-button\"><circle cx=\"440\" cy=\"204\" r=\"19\"/><path d=\"m433.5 213 6.5-18 6.5 18m-11-6h9\" stroke-width=\"1.3\"/></g>\n        <g data-part=\"b-button\"><circle cx=\"402\" cy=\"242\" r=\"19\"/><path d=\"M397 234V250M397 234H402Q408 234 408 238Q408 242 402 242H397M402 242Q409 242 409 246Q409 250 402 250H397\" stroke-width=\"1.3\"/></g>\n      </g>\n      <path data-part=\"plus-button\" data-art=\"r.system\" d=\"M351 97H368V110H381V127H368V140H351V127H338V110H351Z\"/>\n      <g data-part=\"home-button\" data-art=\"r.system\"><circle cx=\"449\" cy=\"407\" r=\"14\"/><path d=\"m442 406 7-6 7 6m-12-2v10h10v-10m-7 10v-5h4v5\" stroke-width=\"1.1\"/></g>\n    </g>\n  </g>\n","sourceHash":"1b22099304c83516c2f100d023461b19a6870eee059c24c1a70400c3bf4862ce","mappedParts":[{"part":"left-rail","areas":["l.sidebuttons","l.sync","l.attachment","l.charging"]},{"part":"left-joystick","areas":["l.stick"]},{"part":"left-direction-buttons","areas":["l.buttons"]},{"part":"minus-button","areas":["l.system"]},{"part":"capture-button","areas":["l.system"]},{"part":"right-rail","areas":["r.sidebuttons","r.sync","r.attachment","r.charging"]},{"part":"right-joystick","areas":["r.stick"]},{"part":"right-face-buttons","areas":["r.buttons"]},{"part":"plus-button","areas":["r.system"]},{"part":"home-button","areas":["r.system"]}]},"joycon2":{"file":"switch-2-joycon-pair-outline.svg","joy":true,"anchors":{"lshoulder":[190,59],"rshoulder":[510,59],"lstick":[184,225],"rstick":[514,406],"lbuttons":[133,406],"rbuttons":[565,227],"lsystem":[228,531],"rsystem":[469,605],"lrail":[311,680],"rrail":[389,680]},"viewBox":[40,20,620,770],"body":"\n  \n  \n  <g fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.65\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n    <g data-part=\"left-joycon-2\" data-unit=\"l\">\n      <path data-part=\"left-shell\" d=\"M288 56H246C155 56 80 101 80 211V589C80 699 155 744 246 744H288Z\"/>\n      <path data-part=\"left-shoulder\" data-art=\"l.bumper l.trigger\" d=\"M77 204C77 98 155 51 256 52\"/>\n      <path data-part=\"left-attachment-edge\" data-art=\"l.sidebuttons l.sync l.attachment l.charging\" d=\"M288 102H334V153L326 172V176H332V287L326 303L334 315V500L326 518H332V626L326 640L334 653V700H288\"/>\n      <g data-part=\"left-player-lights\" data-art=\"l.lights\" stroke-width=\"1.15\">\n        <rect x=\"314\" y=\"368\" width=\"5\" height=\"5\" rx=\".7\"/>\n        <rect x=\"314\" y=\"389\" width=\"5\" height=\"5\" rx=\".7\"/>\n        <rect x=\"314\" y=\"410\" width=\"5\" height=\"5\" rx=\".7\"/>\n        <rect x=\"314\" y=\"431\" width=\"5\" height=\"5\" rx=\".7\"/>\n      </g>\n      <g data-part=\"left-joystick\" data-art=\"l.stick\" transform=\"translate(184 225)\">\n        <circle r=\"60\"/>\n        <circle r=\"49\" stroke-width=\"1.3\"/>\n        <circle r=\"41\"/>\n      </g>\n      <g data-part=\"left-direction-buttons\" data-art=\"l.buttons\">\n        <g data-part=\"direction-up\"><circle cx=\"184\" cy=\"356\" r=\"25\"/><path d=\"m184 347-7 11h14Z\" stroke-width=\"1.3\"/></g>\n        <g data-part=\"direction-left\"><circle cx=\"133\" cy=\"406\" r=\"25\"/><path d=\"m124 406 11 7v-14Z\" stroke-width=\"1.3\"/></g>\n        <g data-part=\"direction-right\"><circle cx=\"235\" cy=\"406\" r=\"25\"/><path d=\"m244 406-11-7v14Z\" stroke-width=\"1.3\"/></g>\n        <g data-part=\"direction-down\"><circle cx=\"184\" cy=\"456\" r=\"25\"/><path d=\"m184 465 7-11h-14Z\" stroke-width=\"1.3\"/></g>\n      </g>\n      <rect data-part=\"minus-button\" data-art=\"l.system\" x=\"233\" y=\"122\" width=\"33\" height=\"11\" rx=\"1\"/>\n      <g data-part=\"capture-button\" data-art=\"l.system\"><rect x=\"211\" y=\"514\" width=\"34\" height=\"34\" rx=\"3\"/><circle cx=\"228\" cy=\"531\" r=\"10.5\" stroke-width=\"1.3\"/></g>\n    </g>\n    <g data-part=\"right-joycon-2\" data-unit=\"r\">\n      <path data-part=\"right-shell\" d=\"M412 56H454C545 56 620 101 620 211V589C620 699 545 744 454 744H412Z\"/>\n      <path data-part=\"right-shoulder\" data-art=\"r.bumper r.trigger\" d=\"M623 204C623 98 545 51 444 52\"/>\n      <path data-part=\"right-attachment-edge\" data-art=\"r.sidebuttons r.sync r.attachment r.charging\" d=\"M412 102H366V153L374 172V176H368V287L374 303L366 315V500L374 518H368V626L374 640L366 653V700H412\"/>\n      <g data-part=\"right-player-lights\" data-art=\"r.lights\" stroke-width=\"1.15\">\n        <rect x=\"381\" y=\"368\" width=\"5\" height=\"5\" rx=\".7\"/>\n        <rect x=\"381\" y=\"389\" width=\"5\" height=\"5\" rx=\".7\"/>\n        <rect x=\"381\" y=\"410\" width=\"5\" height=\"5\" rx=\".7\"/>\n        <rect x=\"381\" y=\"431\" width=\"5\" height=\"5\" rx=\".7\"/>\n      </g>\n      <g data-part=\"right-joystick\" data-art=\"r.stick\" transform=\"translate(514 406)\">\n        <circle r=\"60\"/>\n        <circle r=\"49\" stroke-width=\"1.3\"/>\n        <circle r=\"41\"/>\n      </g>\n      <g data-part=\"right-face-buttons\" data-art=\"r.buttons\">\n        <g data-part=\"x-button\"><circle cx=\"514\" cy=\"176\" r=\"25\"/><path d=\"m506 165 16 22m0-22-16 22\" stroke-width=\"1.65\"/></g>\n        <g data-part=\"y-button\"><circle cx=\"463\" cy=\"227\" r=\"25\"/><path d=\"m455 216 8 13 8-13m-8 13v10\" stroke-width=\"1.65\"/></g>\n        <g data-part=\"a-button\"><circle cx=\"565\" cy=\"227\" r=\"25\"/><path d=\"m556 239 9-24 9 24m-15-8h12\" stroke-width=\"1.65\"/></g>\n        <g data-part=\"b-button\"><circle cx=\"514\" cy=\"278\" r=\"25\"/><path d=\"M507 267V289M507 267H514Q522 267 522 272.5Q522 278 514 278H507M514 278Q524 278 524 283.5Q524 289 514 289H507\" stroke-width=\"1.65\"/></g>\n      </g>\n      <path data-part=\"plus-button\" data-art=\"r.system\" d=\"M443 111H454V122H465V133H454V144H443V133H432V122H443Z\"/>\n      <g data-part=\"home-button\" data-art=\"r.system\"><circle cx=\"469\" cy=\"532\" r=\"21\"/><path d=\"m459 531 10-8 10 8m-17-6v16h14v-16m-9 16v-7h4v7\" stroke-width=\"1.3\"/></g>\n      <g data-part=\"c-button\" data-art=\"r.system\"><rect x=\"452\" y=\"588\" width=\"34\" height=\"34\" rx=\"2\"/><path d=\"M476 598Q473 594 468 594Q460 594 460 605Q460 616 468 616Q473 616 476 612\" stroke-width=\"1.65\"/></g>\n    </g>\n  </g>\n","sourceHash":"95f4e1b723414cbfff1a53d5639d7fc7b15f7cb003187b221d8c31684ea7d842","mappedParts":[{"part":"left-shoulder","areas":["l.bumper","l.trigger"]},{"part":"left-attachment-edge","areas":["l.sidebuttons","l.sync","l.attachment","l.charging"]},{"part":"left-player-lights","areas":["l.lights"]},{"part":"left-joystick","areas":["l.stick"]},{"part":"left-direction-buttons","areas":["l.buttons"]},{"part":"minus-button","areas":["l.system"]},{"part":"capture-button","areas":["l.system"]},{"part":"right-shoulder","areas":["r.bumper","r.trigger"]},{"part":"right-attachment-edge","areas":["r.sidebuttons","r.sync","r.attachment","r.charging"]},{"part":"right-player-lights","areas":["r.lights"]},{"part":"right-joystick","areas":["r.stick"]},{"part":"right-face-buttons","areas":["r.buttons"]},{"part":"plus-button","areas":["r.system"]},{"part":"home-button","areas":["r.system"]},{"part":"c-button","areas":["r.system"]}]}};
const MODELS={"dualsense":{"name":"PS5 DualSense","platform":"playstation","upgrades":true,"groups":[{"id":"lshoulder","label":"L1 / L2","icon":"shoulder","areas":[{"id":"lb","label":"Left bumper · L1","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":[],"side":null},{"id":"lt","label":"Left trigger · L2","symptoms":["Does not register correctly","Only responds sometimes","Sticks or does not return","Feels loose or physically damaged","Adaptive resistance feels wrong or is missing","Other"],"targets":[],"side":null}],"position":["left",13],"help":"L1 and L2 are separate repair areas. Select the symptoms for each affected control.","row":1},{"id":"dpad","label":"D-pad","icon":"dpad","areas":[{"id":"dpad","label":"D-pad","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":["Up","Down","Left","Right"],"side":null}],"position":["left",27],"help":"","row":2},{"id":"lstick","label":"Left joystick","icon":"stick","areas":[{"id":"lstick","label":"Left joystick","symptoms":["Drifts or moves on its own","Does not return to the center when released","Movement does not register or cuts out","Movement feels inaccurate or does not reach full range","Feels loose or wobbly","Sticks, catches, or is difficult to move","Pressing the stick does not register or cuts out","Other"],"targets":[],"side":null}],"position":["left",48],"help":"","row":3},{"id":"system","label":"System buttons","icon":"system","areas":[{"id":"system","label":"System buttons","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":["PS","Options","Create","Mute"],"side":null}],"position":["left",70],"help":"","row":4},{"id":"usb","label":"Charging / USB","icon":"usb","areas":[{"id":"usb","label":"Charging / USB connection","symptoms":["Does not charge through USB","Cable connection is loose or damaged","Charging cuts out when the cable moves","Wired connection is not detected or disconnects","Other"],"targets":[],"side":null}],"position":["top",1],"help":""},{"id":"rshoulder","label":"R1 / R2","icon":"shoulder","areas":[{"id":"rb","label":"Right bumper · R1","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":[],"side":null},{"id":"rt","label":"Right trigger · R2","symptoms":["Does not register correctly","Only responds sometimes","Sticks or does not return","Feels loose or physically damaged","Adaptive resistance feels wrong or is missing","Other"],"targets":[],"side":null}],"position":["right",13],"help":"R1 and R2 are separate repair areas. Select the symptoms for each affected control.","row":1},{"id":"face","label":"Face buttons","icon":"face","areas":[{"id":"face","label":"Face buttons","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":["Cross ×","Circle ○","Square □","Triangle △"],"side":null}],"position":["right",43],"help":"","row":2},{"id":"rstick","label":"Right joystick","icon":"stick","areas":[{"id":"rstick","label":"Right joystick","symptoms":["Drifts or moves on its own","Does not return to the center when released","Movement does not register or cuts out","Movement feels inaccurate or does not reach full range","Feels loose or wobbly","Sticks, catches, or is difficult to move","Pressing the stick does not register or cuts out","Other"],"targets":[],"side":null}],"position":["right",62],"help":"","row":3},{"id":"touch","label":"Touchpad","icon":"touch","areas":[{"id":"touch","label":"Touchpad","symptoms":["Touch or swipe is not detected","Touch response is inaccurate or intermittent","Pressing the touchpad does not register","Sticks, feels loose, or is damaged","Other"],"targets":[],"side":null}],"position":["right",27],"help":"","row":4},{"id":"battery","label":"Battery / power","icon":"battery","areas":[{"id":"battery","label":"Battery / power","symptoms":["Will not turn on","Shuts off unexpectedly","Battery runs down unusually quickly","Only works while connected to power","Other"],"targets":[],"side":null}],"position":null,"help":""},{"id":"wireless","label":"Wireless connection","icon":"wifi","areas":[{"id":"wireless","label":"Wireless connection","symptoms":["Will not pair","Disconnects during use","Works attached or wired, but not wirelessly","Other"],"targets":[],"side":null}],"position":null,"help":""},{"id":"feedback","label":"Vibration & audio","icon":"sound","areas":[{"id":"rumble","label":"Vibration / haptics","symptoms":["No vibration","Weak or intermittent vibration","Unusual buzzing or rattling","Other"],"targets":["Left side","Right side","Both sides","Not sure"],"side":null},{"id":"audio","label":"Audio / microphone","symptoms":["No sound or voice input","Sound or voice cuts out","Sound or voice is unusually quiet","Distortion, crackling, or a damaged connection","Other"],"targets":["Controller speaker","Controller microphone","Headset sound","Headset microphone"],"side":null}],"position":null,"help":"Vibration and audio are separate repair areas. Speaker, microphone, and headset problems share one audio area."},{"id":"motion","label":"Motion controls","icon":"motion","areas":[{"id":"motion","label":"Motion controls","symptoms":["Tilt or movement is not detected","Motion drifts while held still","Motion response is inaccurate or intermittent","Other"],"targets":[],"side":null}],"position":null,"help":"This means moving or tilting the whole controller, rather than moving a joystick."},{"id":"lights","label":"Lights / indicators","icon":"light","areas":[{"id":"lights","label":"Lights / indicators","symptoms":["One or more indicators do not light up while other functions work","An individual indicator flickers or appears damaged","Other"],"targets":["Light bar","Player indicators","Mute indicator"],"side":null}],"position":null,"help":""},{"id":"other","label":"Other / not sure","icon":"search","areas":[{"id":"other","label":"Other / not sure","symptoms":["Other"],"targets":[],"side":null}],"position":null,"help":"Describe a problem you haven’t already selected in another area."}],"id":"dualsense"},"dualshock":{"name":"PS4 DualShock 4","platform":"playstation","upgrades":false,"groups":[{"id":"lshoulder","label":"L1 / L2","icon":"shoulder","areas":[{"id":"lb","label":"Left bumper · L1","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":[],"side":null},{"id":"lt","label":"Left trigger · L2","symptoms":["Does not register correctly","Only responds sometimes","Sticks or does not return","Feels loose or physically damaged","Other"],"targets":[],"side":null}],"position":["left",13],"help":"L1 and L2 are separate repair areas. Select the symptoms for each affected control.","row":1},{"id":"dpad","label":"D-pad","icon":"dpad","areas":[{"id":"dpad","label":"D-pad","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":["Up","Down","Left","Right"],"side":null}],"position":["left",27],"help":"","row":2},{"id":"lstick","label":"Left joystick","icon":"stick","areas":[{"id":"lstick","label":"Left joystick","symptoms":["Drifts or moves on its own","Does not return to the center when released","Movement does not register or cuts out","Movement feels inaccurate or does not reach full range","Feels loose or wobbly","Sticks, catches, or is difficult to move","Pressing the stick does not register or cuts out","Other"],"targets":[],"side":null}],"position":["left",48],"help":"","row":3},{"id":"system","label":"System buttons","icon":"system","areas":[{"id":"system","label":"System buttons","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":["PS","Options","Share"],"side":null}],"position":["left",70],"help":"","row":4},{"id":"usb","label":"Charging / USB","icon":"usb","areas":[{"id":"usb","label":"Charging / USB connection","symptoms":["Does not charge through USB","Cable connection is loose or damaged","Charging cuts out when the cable moves","Wired connection is not detected or disconnects","Other"],"targets":[],"side":null}],"position":["top",1],"help":""},{"id":"rshoulder","label":"R1 / R2","icon":"shoulder","areas":[{"id":"rb","label":"Right bumper · R1","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":[],"side":null},{"id":"rt","label":"Right trigger · R2","symptoms":["Does not register correctly","Only responds sometimes","Sticks or does not return","Feels loose or physically damaged","Other"],"targets":[],"side":null}],"position":["right",13],"help":"R1 and R2 are separate repair areas. Select the symptoms for each affected control.","row":1},{"id":"face","label":"Face buttons","icon":"face","areas":[{"id":"face","label":"Face buttons","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":["Cross ×","Circle ○","Square □","Triangle △"],"side":null}],"position":["right",43],"help":"","row":2},{"id":"rstick","label":"Right joystick","icon":"stick","areas":[{"id":"rstick","label":"Right joystick","symptoms":["Drifts or moves on its own","Does not return to the center when released","Movement does not register or cuts out","Movement feels inaccurate or does not reach full range","Feels loose or wobbly","Sticks, catches, or is difficult to move","Pressing the stick does not register or cuts out","Other"],"targets":[],"side":null}],"position":["right",62],"help":"","row":3},{"id":"touch","label":"Touchpad","icon":"touch","areas":[{"id":"touch","label":"Touchpad","symptoms":["Touch or swipe is not detected","Touch response is inaccurate or intermittent","Pressing the touchpad does not register","Sticks, feels loose, or is damaged","Other"],"targets":[],"side":null}],"position":["right",27],"help":"","row":4},{"id":"battery","label":"Battery / power","icon":"battery","areas":[{"id":"battery","label":"Battery / power","symptoms":["Will not turn on","Shuts off unexpectedly","Battery runs down unusually quickly","Only works while connected to power","Other"],"targets":[],"side":null}],"position":null,"help":""},{"id":"wireless","label":"Wireless connection","icon":"wifi","areas":[{"id":"wireless","label":"Wireless connection","symptoms":["Will not pair","Disconnects during use","Works attached or wired, but not wirelessly","Other"],"targets":[],"side":null}],"position":null,"help":""},{"id":"feedback","label":"Vibration & audio","icon":"sound","areas":[{"id":"rumble","label":"Vibration / haptics","symptoms":["No vibration","Weak or intermittent vibration","Unusual buzzing or rattling","Other"],"targets":["Left side","Right side","Both sides","Not sure"],"side":null},{"id":"audio","label":"Audio / microphone","symptoms":["No sound or voice input","Sound or voice cuts out","Sound or voice is unusually quiet","Distortion, crackling, or a damaged connection","Other"],"targets":["Controller speaker","Headset sound","Headset microphone"],"side":null}],"position":null,"help":"Vibration and audio are separate repair areas. Speaker, microphone, and headset problems share one audio area."},{"id":"motion","label":"Motion controls","icon":"motion","areas":[{"id":"motion","label":"Motion controls","symptoms":["Tilt or movement is not detected","Motion drifts while held still","Motion response is inaccurate or intermittent","Other"],"targets":[],"side":null}],"position":null,"help":"This means moving or tilting the whole controller, rather than moving a joystick."},{"id":"lights","label":"Light bar","icon":"light","areas":[{"id":"lights","label":"Lights / indicators","symptoms":["One or more indicators do not light up while other functions work","An individual indicator flickers or appears damaged","Other"],"targets":[],"side":null}],"position":null,"help":""},{"id":"other","label":"Other / not sure","icon":"search","areas":[{"id":"other","label":"Other / not sure","symptoms":["Other"],"targets":[],"side":null}],"position":null,"help":"Describe a problem you haven’t already selected in another area."},{"id":"extension","label":"Extension port","icon":"usb","areas":[{"id":"extension","label":"Extension port","symptoms":["Accessory is not detected","Accessory connection cuts out","Port is loose or damaged","Charging through this port does not work","Other"],"targets":[],"side":null}],"help":"","position":null}],"id":"dualshock"},"xboxseries":{"name":"Xbox Series X|S Controller","platform":"xbox","upgrades":true,"groups":[{"id":"lshoulder","label":"LB / LT","icon":"shoulder","areas":[{"id":"lb","label":"Left bumper · LB","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":[],"side":null},{"id":"lt","label":"Left trigger · LT","symptoms":["Does not register correctly","Only responds sometimes","Sticks or does not return","Feels loose or physically damaged","Trigger vibration does not work correctly","Other"],"targets":[],"side":null}],"position":["left",13],"help":"The bumper and trigger count as separate repair areas.","row":1},{"id":"dpad","label":"D-pad","icon":"dpad","areas":[{"id":"dpad","label":"D-pad","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":["Up","Down","Left","Right"],"side":null}],"position":["left",70],"help":"","row":2},{"id":"lstick","label":"Left joystick","icon":"stick","areas":[{"id":"lstick","label":"Left joystick","symptoms":["Drifts or moves on its own","Does not return to the center when released","Movement does not register or cuts out","Movement feels inaccurate or does not reach full range","Feels loose or wobbly","Sticks, catches, or is difficult to move","Pressing the stick does not register or cuts out","Other"],"targets":[],"side":null}],"position":["left",27],"help":"","row":3},{"id":"system","label":"System buttons","icon":"system","areas":[{"id":"system","label":"System buttons","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":["Xbox","Menu","View","Share"],"side":null}],"position":["left",48],"help":"","row":4},{"id":"usb","label":"USB-C connection","icon":"usb","areas":[{"id":"usb","label":"USB-C connection","symptoms":["Wired connection is not detected or disconnects","Cable connection is loose or damaged","Compatible rechargeable pack will not charge through the controller","Other"],"targets":[],"side":null}],"position":["top",1],"help":"USB charging applies only to a compatible rechargeable pack designed to charge through the controller. AA batteries do not charge through USB."},{"id":"rshoulder","label":"RB / RT","icon":"shoulder","areas":[{"id":"rb","label":"Right bumper · RB","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":[],"side":null},{"id":"rt","label":"Right trigger · RT","symptoms":["Does not register correctly","Only responds sometimes","Sticks or does not return","Feels loose or physically damaged","Trigger vibration does not work correctly","Other"],"targets":[],"side":null}],"position":["right",13],"help":"The bumper and trigger count as separate repair areas.","row":1},{"id":"face","label":"Face buttons","icon":"face","areas":[{"id":"face","label":"Face buttons","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":["A","B","X","Y"],"side":null}],"position":["right",32],"help":"","row":2},{"id":"rstick","label":"Right joystick","icon":"stick","areas":[{"id":"rstick","label":"Right joystick","symptoms":["Drifts or moves on its own","Does not return to the center when released","Movement does not register or cuts out","Movement feels inaccurate or does not reach full range","Feels loose or wobbly","Sticks, catches, or is difficult to move","Pressing the stick does not register or cuts out","Other"],"targets":[],"side":null}],"position":["right",51],"help":"","row":3},{"id":"battery","label":"Battery / power","icon":"battery","areas":[{"id":"battery","label":"Battery / power","symptoms":["Will not turn on","Shuts off unexpectedly","Battery runs down unusually quickly","Only works while connected to power","Loses power when moved","Battery contacts appear damaged or corroded","Other"],"targets":[],"side":null}],"position":null,"help":""},{"id":"wireless","label":"Wireless connection","icon":"wifi","areas":[{"id":"wireless","label":"Wireless connection","symptoms":["Will not connect to Xbox","Bluetooth will not pair","Disconnects during use","Other"],"targets":[],"side":null}],"position":null,"help":""},{"id":"feedback","label":"Vibration & audio","icon":"sound","areas":[{"id":"rumble","label":"Grip vibration","symptoms":["No vibration","Weak or intermittent vibration","Unusual buzzing or rattling","Other"],"targets":["Left side","Right side","Both sides","Not sure"],"side":null},{"id":"audio","label":"Headset audio","symptoms":["No sound or voice input","Sound or voice cuts out","Sound or voice is unusually quiet","Distortion, crackling, or a damaged connection","Other"],"targets":["Headset sound","Headset microphone"],"side":null}],"position":null,"help":"Grip vibration and headset audio count separately. Trigger vibration belongs under LT or RT."},{"id":"lights","label":"Power indicator","icon":"light","areas":[{"id":"lights","label":"Lights / indicators","symptoms":["One or more indicators do not light up while other functions work","An individual indicator flickers or appears damaged","Other"],"targets":[],"side":null}],"position":null,"help":"For a faulty light while the controller otherwise works. Pairing-related flashing belongs under Wireless connection."},{"id":"other","label":"Other / not sure","icon":"search","areas":[{"id":"other","label":"Other / not sure","symptoms":["Other"],"targets":[],"side":null}],"position":null,"help":"Describe a problem you haven’t already selected in another area."},{"id":"sync","label":"Pairing button","icon":"system","areas":[{"id":"sync","label":"Pairing button","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":[],"side":null}],"help":"For a physically faulty pairing button. Pairing failure without a button fault belongs under Wireless connection.","position":null},{"id":"accessory","label":"Accessory connection","icon":"usb","areas":[{"id":"accessory","label":"Accessory connection","symptoms":["Accessory or headset adapter is not detected","Connection cuts out","Port is loose or damaged","Other"],"targets":[],"side":null}],"help":"Use this only if your controller has the accessory expansion port.","position":null}],"id":"xboxseries"},"xboxone":{"name":"Xbox One Controller","platform":"xbox","upgrades":false,"groups":[{"id":"lshoulder","label":"LB / LT","icon":"shoulder","areas":[{"id":"lb","label":"Left bumper · LB","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":[],"side":null},{"id":"lt","label":"Left trigger · LT","symptoms":["Does not register correctly","Only responds sometimes","Sticks or does not return","Feels loose or physically damaged","Trigger vibration does not work correctly","Other"],"targets":[],"side":null}],"position":["left",13],"help":"The bumper and trigger count as separate repair areas.","row":1},{"id":"dpad","label":"D-pad","icon":"dpad","areas":[{"id":"dpad","label":"D-pad","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":["Up","Down","Left","Right"],"side":null}],"position":["left",70],"help":"","row":2},{"id":"lstick","label":"Left joystick","icon":"stick","areas":[{"id":"lstick","label":"Left joystick","symptoms":["Drifts or moves on its own","Does not return to the center when released","Movement does not register or cuts out","Movement feels inaccurate or does not reach full range","Feels loose or wobbly","Sticks, catches, or is difficult to move","Pressing the stick does not register or cuts out","Other"],"targets":[],"side":null}],"position":["left",27],"help":"","row":3},{"id":"system","label":"System buttons","icon":"system","areas":[{"id":"system","label":"System buttons","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":["Xbox","Menu","View"],"side":null}],"position":["left",48],"help":"","row":4},{"id":"usb","label":"Micro-USB connection","icon":"usb","areas":[{"id":"usb","label":"Micro-USB connection","symptoms":["Wired connection is not detected or disconnects","Cable connection is loose or damaged","Compatible rechargeable pack will not charge through the controller","Other"],"targets":[],"side":null}],"position":["top",1],"help":"USB charging applies only to a compatible rechargeable pack designed to charge through the controller. AA batteries do not charge through USB."},{"id":"rshoulder","label":"RB / RT","icon":"shoulder","areas":[{"id":"rb","label":"Right bumper · RB","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":[],"side":null},{"id":"rt","label":"Right trigger · RT","symptoms":["Does not register correctly","Only responds sometimes","Sticks or does not return","Feels loose or physically damaged","Trigger vibration does not work correctly","Other"],"targets":[],"side":null}],"position":["right",13],"help":"The bumper and trigger count as separate repair areas.","row":1},{"id":"face","label":"Face buttons","icon":"face","areas":[{"id":"face","label":"Face buttons","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":["A","B","X","Y"],"side":null}],"position":["right",32],"help":"","row":2},{"id":"rstick","label":"Right joystick","icon":"stick","areas":[{"id":"rstick","label":"Right joystick","symptoms":["Drifts or moves on its own","Does not return to the center when released","Movement does not register or cuts out","Movement feels inaccurate or does not reach full range","Feels loose or wobbly","Sticks, catches, or is difficult to move","Pressing the stick does not register or cuts out","Other"],"targets":[],"side":null}],"position":["right",51],"help":"","row":3},{"id":"battery","label":"Battery / power","icon":"battery","areas":[{"id":"battery","label":"Battery / power","symptoms":["Will not turn on","Shuts off unexpectedly","Battery runs down unusually quickly","Only works while connected to power","Loses power when moved","Battery contacts appear damaged or corroded","Other"],"targets":[],"side":null}],"position":null,"help":""},{"id":"wireless","label":"Wireless connection","icon":"wifi","areas":[{"id":"wireless","label":"Wireless connection","symptoms":["Will not connect to Xbox","Bluetooth will not pair (if equipped)","Disconnects during use","Other"],"targets":[],"side":null}],"position":null,"help":""},{"id":"feedback","label":"Vibration & audio","icon":"sound","areas":[{"id":"rumble","label":"Grip vibration","symptoms":["No vibration","Weak or intermittent vibration","Unusual buzzing or rattling","Other"],"targets":["Left side","Right side","Both sides","Not sure"],"side":null},{"id":"audio","label":"Headset audio (if equipped)","symptoms":["No sound or voice input","Sound or voice cuts out","Sound or voice is unusually quiet","Distortion, crackling, or a damaged connection","Other"],"targets":["Headset sound","Headset microphone"],"side":null}],"position":null,"help":"Grip vibration and headset audio count separately. Trigger vibration belongs under LT or RT. If your controller has no headset jack, report adapter problems under Accessory connection."},{"id":"lights","label":"Power indicator","icon":"light","areas":[{"id":"lights","label":"Lights / indicators","symptoms":["One or more indicators do not light up while other functions work","An individual indicator flickers or appears damaged","Other"],"targets":[],"side":null}],"position":null,"help":"For a faulty light while the controller otherwise works. Pairing-related flashing belongs under Wireless connection."},{"id":"other","label":"Other / not sure","icon":"search","areas":[{"id":"other","label":"Other / not sure","symptoms":["Other"],"targets":[],"side":null}],"position":null,"help":"Describe a problem you haven’t already selected in another area."},{"id":"sync","label":"Pairing button","icon":"system","areas":[{"id":"sync","label":"Pairing button","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":[],"side":null}],"help":"For a physically faulty pairing button. Pairing failure without a button fault belongs under Wireless connection.","position":null},{"id":"accessory","label":"Accessory connection","icon":"usb","areas":[{"id":"accessory","label":"Accessory connection","symptoms":["Accessory or headset adapter is not detected","Connection cuts out","Port is loose or damaged","Other"],"targets":[],"side":null}],"help":"Use this only if your controller has the accessory expansion port.","position":null}],"id":"xboxone"},"joycon2":{"name":"Nintendo Switch 2 Joy-Con","platform":"nintendo","joy":true,"upgrades":false,"groups":[{"id":"lshoulder","label":"Left · L / ZL","icon":"shoulder","areas":[{"id":"l.bumper","label":"Left Joy-Con · L bumper","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":[],"side":"l"},{"id":"l.trigger","label":"Left Joy-Con · ZL trigger","symptoms":["Does not register correctly","Only responds sometimes","Sticks or does not return","Feels loose or physically damaged","Other"],"targets":[],"side":"l"}],"position":["left",12],"help":"The bumper and trigger count separately. Select only the controls that have problems.","row":1},{"id":"lstick","label":"Left joystick","icon":"stick","areas":[{"id":"l.stick","label":"Left Joy-Con · Joystick","symptoms":["Drifts or moves on its own","Does not return to the center when released","Movement does not register or cuts out","Movement feels inaccurate or does not reach full range","Feels loose or wobbly","Sticks, catches, or is difficult to move","Pressing the stick does not register or cuts out","Other"],"targets":[],"side":"l"}],"position":["left",30],"help":"","row":2},{"id":"lbuttons","label":"Directional buttons","icon":"face","areas":[{"id":"l.buttons","label":"Left Joy-Con · Directional buttons","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":["Up","Down","Left","Right"],"side":"l"}],"position":["left",48],"help":"","row":3},{"id":"lsystem","label":"Minus / Capture","icon":"system","areas":[{"id":"l.system","label":"Left Joy-Con · System buttons","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":["Minus","Capture"],"side":"l"}],"position":["left",66],"help":"","row":4},{"id":"lrail","label":"Left side / attachment","icon":"rail","areas":[{"id":"l.sidebuttons","label":"Left Joy-Con · SL / SR buttons","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":["SL","SR"],"side":"l"},{"id":"l.sync","label":"Left Joy-Con · SYNC button","symptoms":["Does not respond when pressed","Sticks or feels physically damaged","Other"],"targets":[],"side":"l"},{"id":"l.attachment","label":"Left Joy-Con · Magnetic attachment","symptoms":["Does not attach securely","Detaches unexpectedly","Feels unusually loose while attached","Release button is stuck or damaged","Other"],"targets":[],"side":"l"},{"id":"l.charging","label":"Left Joy-Con · Charging / console connection","symptoms":["Does not charge on a powered console or charging grip","Charging cuts in and out","Not detected while attached to the console","Attached connection drops","Charging contacts appear damaged","Other"],"targets":[],"side":"l"}],"position":["left",84],"help":"Side buttons, SYNC, magnetic attachment, and charging count as separate areas.","row":5},{"id":"rshoulder","label":"Right · R / ZR","icon":"shoulder","areas":[{"id":"r.bumper","label":"Right Joy-Con · R bumper","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":[],"side":"r"},{"id":"r.trigger","label":"Right Joy-Con · ZR trigger","symptoms":["Does not register correctly","Only responds sometimes","Sticks or does not return","Feels loose or physically damaged","Other"],"targets":[],"side":"r"}],"position":["right",12],"help":"The bumper and trigger count separately. Select only the controls that have problems.","row":1},{"id":"rstick","label":"Right joystick","icon":"stick","areas":[{"id":"r.stick","label":"Right Joy-Con · Joystick","symptoms":["Drifts or moves on its own","Does not return to the center when released","Movement does not register or cuts out","Movement feels inaccurate or does not reach full range","Feels loose or wobbly","Sticks, catches, or is difficult to move","Pressing the stick does not register or cuts out","Other"],"targets":[],"side":"r"}],"position":["right",48],"help":"","row":2},{"id":"rbuttons","label":"A / B / X / Y","icon":"face","areas":[{"id":"r.buttons","label":"Right Joy-Con · Face buttons","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":["A","B","X","Y"],"side":"r"}],"position":["right",30],"help":"","row":3},{"id":"rsystem","label":"Plus / HOME / C","icon":"system","areas":[{"id":"r.system","label":"Right Joy-Con · System buttons","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":["Plus","HOME","C"],"side":"r"}],"position":["right",66],"help":"","row":4},{"id":"rrail","label":"Right side / attachment","icon":"rail","areas":[{"id":"r.sidebuttons","label":"Right Joy-Con · SL / SR buttons","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":["SL","SR"],"side":"r"},{"id":"r.sync","label":"Right Joy-Con · SYNC button","symptoms":["Does not respond when pressed","Sticks or feels physically damaged","Other"],"targets":[],"side":"r"},{"id":"r.attachment","label":"Right Joy-Con · Magnetic attachment","symptoms":["Does not attach securely","Detaches unexpectedly","Feels unusually loose while attached","Release button is stuck or damaged","Other"],"targets":[],"side":"r"},{"id":"r.charging","label":"Right Joy-Con · Charging / console connection","symptoms":["Does not charge on a powered console or charging grip","Charging cuts in and out","Not detected while attached to the console","Attached connection drops","Charging contacts appear damaged","Other"],"targets":[],"side":"r"}],"position":["right",84],"help":"Side buttons, SYNC, magnetic attachment, and charging count as separate areas.","row":5},{"id":"battery","label":"Battery / power","icon":"battery","areas":[{"id":"l.battery","label":"Left Joy-Con · Battery / power","symptoms":["Will not turn on","Shuts off unexpectedly","Battery runs down unusually quickly","Only works while connected to power","Other"],"targets":[],"side":"l"},{"id":"r.battery","label":"Right Joy-Con · Battery / power","symptoms":["Will not turn on","Shuts off unexpectedly","Battery runs down unusually quickly","Only works while connected to power","Other"],"targets":[],"side":"r"}],"position":null,"help":"Select symptoms on the affected side only. Each side is recorded separately."},{"id":"wireless","label":"Wireless connection","icon":"wifi","areas":[{"id":"l.wireless","label":"Left Joy-Con · Wireless connection","symptoms":["Will not pair","Disconnects during use","Works attached or wired, but not wirelessly","Other"],"targets":[],"side":"l"},{"id":"r.wireless","label":"Right Joy-Con · Wireless connection","symptoms":["Will not pair","Disconnects during use","Works attached or wired, but not wirelessly","Other"],"targets":[],"side":"r"}],"position":null,"help":"Select symptoms on the affected side only. Each side is recorded separately."},{"id":"rumble","label":"HD rumble 2","icon":"sound","areas":[{"id":"l.rumble","label":"Left Joy-Con · HD rumble","symptoms":["No vibration","Weak or intermittent vibration","Unusual buzzing or rattling","Other"],"targets":[],"side":"l"},{"id":"r.rumble","label":"Right Joy-Con · HD rumble","symptoms":["No vibration","Weak or intermittent vibration","Unusual buzzing or rattling","Other"],"targets":[],"side":"r"}],"position":null,"help":"Select symptoms on the affected side only. Each side is recorded separately."},{"id":"motion","label":"Motion controls","icon":"motion","areas":[{"id":"l.motion","label":"Left Joy-Con · Motion controls","symptoms":["Tilt or movement is not detected","Motion drifts while held still","Motion response is inaccurate or intermittent","Other"],"targets":[],"side":"l"},{"id":"r.motion","label":"Right Joy-Con · Motion controls","symptoms":["Tilt or movement is not detected","Motion drifts while held still","Motion response is inaccurate or intermittent","Other"],"targets":[],"side":"r"}],"position":null,"help":"Select symptoms on the affected side only. Each side is recorded separately."},{"id":"lights","label":"Player lights","icon":"light","areas":[{"id":"l.lights","label":"Left Joy-Con · Player lights","symptoms":["One or more indicators do not light up while other functions work","An individual indicator flickers or appears damaged","Other"],"targets":["First light","Second light","Third light","Fourth light","Not sure"],"side":"l"},{"id":"r.lights","label":"Right Joy-Con · Player lights","symptoms":["One or more indicators do not light up while other functions work","An individual indicator flickers or appears damaged","Other"],"targets":["First light","Second light","Third light","Fourth light","Not sure"],"side":"r"}],"position":null,"help":"Select symptoms on the affected side only. Each side is recorded separately."},{"id":"amiibo","label":"Amiibo · right only","icon":"nfc","areas":[{"id":"r.amiibo","label":"Right Joy-Con · Amiibo reader","symptoms":["Compatible amiibo is not detected","Amiibo reading works intermittently","Other"],"targets":[],"side":"r"}],"position":null,"help":"The amiibo reader is on the right Joy-Con. Check with compatible amiibo and software."},{"id":"mouse","label":"Mouse controls","icon":"mouse","areas":[{"id":"l.mouse","label":"Left Joy-Con · Mouse controls","symptoms":["Surface movement is not detected","Pointer jumps or drifts","Tracking is inaccurate or intermittent","Mouse feet are damaged or movement catches","Other"],"targets":[],"side":"l"},{"id":"r.mouse","label":"Right Joy-Con · Mouse controls","symptoms":["Surface movement is not detected","Pointer jumps or drifts","Tracking is inaccurate or intermittent","Mouse feet are damaged or movement catches","Other"],"targets":[],"side":"r"}],"help":"For moving a Joy-Con 2 across a suitable surface in software that supports mouse controls.","position":null},{"id":"other","label":"Other / not sure","icon":"search","areas":[{"id":"l.other","label":"Left Joy-Con · Other / not sure","symptoms":["Other"],"targets":[],"side":"l"},{"id":"r.other","label":"Right Joy-Con · Other / not sure","symptoms":["Other"],"targets":[],"side":"r"}],"position":null,"help":"Describe the problem under the Joy-Con that needs repair. Details on one side won’t select the other."}],"id":"joycon2"},"joycon":{"name":"Nintendo Switch Joy-Con","platform":"nintendo","joy":true,"upgrades":false,"groups":[{"id":"lshoulder","label":"Left · L / ZL","icon":"shoulder","areas":[{"id":"l.bumper","label":"Left Joy-Con · L bumper","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":[],"side":"l"},{"id":"l.trigger","label":"Left Joy-Con · ZL trigger","symptoms":["Does not register correctly","Only responds sometimes","Sticks or does not return","Feels loose or physically damaged","Other"],"targets":[],"side":"l"}],"position":["left",12],"help":"The bumper and trigger count separately. Select only the controls that have problems.","row":1},{"id":"lstick","label":"Left joystick","icon":"stick","areas":[{"id":"l.stick","label":"Left Joy-Con · Joystick","symptoms":["Drifts or moves on its own","Does not return to the center when released","Movement does not register or cuts out","Movement feels inaccurate or does not reach full range","Feels loose or wobbly","Sticks, catches, or is difficult to move","Pressing the stick does not register or cuts out","Other"],"targets":[],"side":"l"}],"position":["left",30],"help":"","row":2},{"id":"lbuttons","label":"Directional buttons","icon":"face","areas":[{"id":"l.buttons","label":"Left Joy-Con · Directional buttons","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":["Up","Down","Left","Right"],"side":"l"}],"position":["left",48],"help":"","row":3},{"id":"lsystem","label":"Minus / Capture","icon":"system","areas":[{"id":"l.system","label":"Left Joy-Con · System buttons","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":["Minus","Capture"],"side":"l"}],"position":["left",66],"help":"","row":4},{"id":"lrail","label":"Left side / rail","icon":"rail","areas":[{"id":"l.sidebuttons","label":"Left Joy-Con · SL / SR buttons","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":["SL","SR"],"side":"l"},{"id":"l.sync","label":"Left Joy-Con · SYNC button","symptoms":["Does not respond when pressed","Sticks or feels physically damaged","Other"],"targets":[],"side":"l"},{"id":"l.attachment","label":"Left Joy-Con · Rail / lock / release","symptoms":["Does not slide on or off correctly","Does not lock securely or slides off without release","Feels unusually loose while attached","Release button is stuck or damaged","Other"],"targets":[],"side":"l"},{"id":"l.charging","label":"Left Joy-Con · Charging / console connection","symptoms":["Does not charge on a powered console or charging grip","Charging cuts in and out","Not detected while attached to the console","Attached connection drops","Charging contacts appear damaged","Other"],"targets":[],"side":"l"}],"position":["left",84],"help":"Side buttons, SYNC, attachment, and charging are separate areas. An ordinary noncharging grip is not a charger.","row":5},{"id":"rshoulder","label":"Right · R / ZR","icon":"shoulder","areas":[{"id":"r.bumper","label":"Right Joy-Con · R bumper","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":[],"side":"r"},{"id":"r.trigger","label":"Right Joy-Con · ZR trigger","symptoms":["Does not register correctly","Only responds sometimes","Sticks or does not return","Feels loose or physically damaged","Other"],"targets":[],"side":"r"}],"position":["right",12],"help":"The bumper and trigger count separately. Select only the controls that have problems.","row":1},{"id":"rstick","label":"Right joystick","icon":"stick","areas":[{"id":"r.stick","label":"Right Joy-Con · Joystick","symptoms":["Drifts or moves on its own","Does not return to the center when released","Movement does not register or cuts out","Movement feels inaccurate or does not reach full range","Feels loose or wobbly","Sticks, catches, or is difficult to move","Pressing the stick does not register or cuts out","Other"],"targets":[],"side":"r"}],"position":["right",48],"help":"","row":2},{"id":"rbuttons","label":"A / B / X / Y","icon":"face","areas":[{"id":"r.buttons","label":"Right Joy-Con · Face buttons","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":["A","B","X","Y"],"side":"r"}],"position":["right",30],"help":"","row":3},{"id":"rsystem","label":"Plus / HOME","icon":"system","areas":[{"id":"r.system","label":"Right Joy-Con · System buttons","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":["Plus","HOME"],"side":"r"}],"position":["right",66],"help":"","row":4},{"id":"rrail","label":"Right side / rail","icon":"rail","areas":[{"id":"r.sidebuttons","label":"Right Joy-Con · SL / SR buttons","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":["SL","SR"],"side":"r"},{"id":"r.sync","label":"Right Joy-Con · SYNC button","symptoms":["Does not respond when pressed","Sticks or feels physically damaged","Other"],"targets":[],"side":"r"},{"id":"r.attachment","label":"Right Joy-Con · Rail / lock / release","symptoms":["Does not slide on or off correctly","Does not lock securely or slides off without release","Feels unusually loose while attached","Release button is stuck or damaged","Other"],"targets":[],"side":"r"},{"id":"r.charging","label":"Right Joy-Con · Charging / console connection","symptoms":["Does not charge on a powered console or charging grip","Charging cuts in and out","Not detected while attached to the console","Attached connection drops","Charging contacts appear damaged","Other"],"targets":[],"side":"r"}],"position":["right",84],"help":"Side buttons, SYNC, attachment, and charging are separate areas. An ordinary noncharging grip is not a charger.","row":5},{"id":"battery","label":"Battery / power","icon":"battery","areas":[{"id":"l.battery","label":"Left Joy-Con · Battery / power","symptoms":["Will not turn on","Shuts off unexpectedly","Battery runs down unusually quickly","Only works while connected to power","Other"],"targets":[],"side":"l"},{"id":"r.battery","label":"Right Joy-Con · Battery / power","symptoms":["Will not turn on","Shuts off unexpectedly","Battery runs down unusually quickly","Only works while connected to power","Other"],"targets":[],"side":"r"}],"position":null,"help":"Select symptoms on the affected side only. Each side is recorded separately."},{"id":"wireless","label":"Wireless connection","icon":"wifi","areas":[{"id":"l.wireless","label":"Left Joy-Con · Wireless connection","symptoms":["Will not pair","Disconnects during use","Works attached or wired, but not wirelessly","Other"],"targets":[],"side":"l"},{"id":"r.wireless","label":"Right Joy-Con · Wireless connection","symptoms":["Will not pair","Disconnects during use","Works attached or wired, but not wirelessly","Other"],"targets":[],"side":"r"}],"position":null,"help":"Select symptoms on the affected side only. Each side is recorded separately."},{"id":"rumble","label":"HD rumble","icon":"sound","areas":[{"id":"l.rumble","label":"Left Joy-Con · HD rumble","symptoms":["No vibration","Weak or intermittent vibration","Unusual buzzing or rattling","Other"],"targets":[],"side":"l"},{"id":"r.rumble","label":"Right Joy-Con · HD rumble","symptoms":["No vibration","Weak or intermittent vibration","Unusual buzzing or rattling","Other"],"targets":[],"side":"r"}],"position":null,"help":"Select symptoms on the affected side only. Each side is recorded separately."},{"id":"motion","label":"Motion controls","icon":"motion","areas":[{"id":"l.motion","label":"Left Joy-Con · Motion controls","symptoms":["Tilt or movement is not detected","Motion drifts while held still","Motion response is inaccurate or intermittent","Other"],"targets":[],"side":"l"},{"id":"r.motion","label":"Right Joy-Con · Motion controls","symptoms":["Tilt or movement is not detected","Motion drifts while held still","Motion response is inaccurate or intermittent","Other"],"targets":[],"side":"r"}],"position":null,"help":"Select symptoms on the affected side only. Each side is recorded separately."},{"id":"lights","label":"Player lights","icon":"light","areas":[{"id":"l.lights","label":"Left Joy-Con · Player lights","symptoms":["One or more indicators do not light up while other functions work","An individual indicator flickers or appears damaged","Other"],"targets":["First light","Second light","Third light","Fourth light","Not sure"],"side":"l"},{"id":"r.lights","label":"Right Joy-Con · Player lights","symptoms":["One or more indicators do not light up while other functions work","An individual indicator flickers or appears damaged","Other"],"targets":["First light","Second light","Third light","Fourth light","Not sure"],"side":"r"}],"position":null,"help":"Select symptoms on the affected side only. Each side is recorded separately."},{"id":"amiibo","label":"Amiibo · right only","icon":"nfc","areas":[{"id":"r.amiibo","label":"Right Joy-Con · Amiibo reader","symptoms":["Compatible amiibo is not detected","Amiibo reading works intermittently","Other"],"targets":[],"side":"r"}],"position":null,"help":"The amiibo reader is on the right Joy-Con. Check with compatible amiibo and software."},{"id":"ir","label":"IR camera · right only","icon":"camera","areas":[{"id":"r.ir","label":"Right Joy-Con · IR motion camera","symptoms":["IR interaction is not detected in compatible software","IR response is inaccurate or intermittent","Camera window appears damaged or obstructed","Other"],"targets":[],"side":"r"}],"position":null,"help":"This is the IR camera on the original right Joy-Con, used by compatible software."},{"id":"other","label":"Other / not sure","icon":"search","areas":[{"id":"l.other","label":"Left Joy-Con · Other / not sure","symptoms":["Other"],"targets":[],"side":"l"},{"id":"r.other","label":"Right Joy-Con · Other / not sure","symptoms":["Other"],"targets":[],"side":"r"}],"position":null,"help":"Describe the problem under the Joy-Con that needs repair. Details on one side won’t select the other."}],"id":"joycon"},"switchpro":{"name":"Nintendo Switch Pro Controller","platform":"nintendo","upgrades":true,"groups":[{"id":"lshoulder","label":"L / ZL","icon":"shoulder","areas":[{"id":"lb","label":"Left bumper · L","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":[],"side":null},{"id":"lt","label":"Left trigger · ZL","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":[],"side":null}],"position":["left",13],"help":"The bumper and trigger count as separate repair areas.","row":1},{"id":"dpad","label":"D-pad","icon":"dpad","areas":[{"id":"dpad","label":"D-pad","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":["Up","Down","Left","Right"],"side":null}],"position":["left",70],"help":"","row":2},{"id":"lstick","label":"Left joystick","icon":"stick","areas":[{"id":"lstick","label":"Left joystick","symptoms":["Drifts or moves on its own","Does not return to the center when released","Movement does not register or cuts out","Movement feels inaccurate or does not reach full range","Feels loose or wobbly","Sticks, catches, or is difficult to move","Pressing the stick does not register or cuts out","Other"],"targets":[],"side":null}],"position":["left",27],"help":"","row":3},{"id":"system","label":"System buttons","icon":"system","areas":[{"id":"system","label":"System buttons","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":["Plus","Minus","HOME","Capture"],"side":null}],"position":["left",48],"help":"","row":4},{"id":"usb","label":"Charging / USB","icon":"usb","areas":[{"id":"usb","label":"Charging / USB connection","symptoms":["Does not charge through USB","Cable connection is loose or damaged","Charging cuts out when the cable moves","Wired connection is not detected or disconnects","Other"],"targets":[],"side":null}],"position":["top",1],"help":""},{"id":"rshoulder","label":"R / ZR","icon":"shoulder","areas":[{"id":"rb","label":"Right bumper · R","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":[],"side":null},{"id":"rt","label":"Right trigger · ZR","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":[],"side":null}],"position":["right",13],"help":"The bumper and trigger count as separate repair areas.","row":1},{"id":"face","label":"Face buttons","icon":"face","areas":[{"id":"face","label":"Face buttons","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":["A","B","X","Y"],"side":null}],"position":["right",32],"help":"","row":2},{"id":"rstick","label":"Right joystick","icon":"stick","areas":[{"id":"rstick","label":"Right joystick","symptoms":["Drifts or moves on its own","Does not return to the center when released","Movement does not register or cuts out","Movement feels inaccurate or does not reach full range","Feels loose or wobbly","Sticks, catches, or is difficult to move","Pressing the stick does not register or cuts out","Other"],"targets":[],"side":null}],"position":["right",51],"help":"","row":3},{"id":"battery","label":"Battery / power","icon":"battery","areas":[{"id":"battery","label":"Battery / power","symptoms":["Will not turn on","Shuts off unexpectedly","Battery runs down unusually quickly","Only works while connected to power","Other"],"targets":[],"side":null}],"position":null,"help":""},{"id":"wireless","label":"Wireless connection","icon":"wifi","areas":[{"id":"wireless","label":"Wireless connection","symptoms":["Will not pair","Disconnects during use","Works attached or wired, but not wirelessly","Other"],"targets":[],"side":null}],"position":null,"help":""},{"id":"motion","label":"Motion controls","icon":"motion","areas":[{"id":"motion","label":"Motion controls","symptoms":["Tilt or movement is not detected","Motion drifts while held still","Motion response is inaccurate or intermittent","Other"],"targets":[],"side":null}],"position":null,"help":"This means moving or tilting the whole controller, rather than moving a joystick."},{"id":"lights","label":"Lights / indicators","icon":"light","areas":[{"id":"lights","label":"Lights / indicators","symptoms":["One or more indicators do not light up while other functions work","An individual indicator flickers or appears damaged","Other"],"targets":["Player lights","Charging light","HOME light"],"side":null}],"position":null,"help":""},{"id":"other","label":"Other / not sure","icon":"search","areas":[{"id":"other","label":"Other / not sure","symptoms":["Other"],"targets":[],"side":null}],"position":null,"help":"Describe a problem you haven’t already selected in another area."},{"id":"sync","label":"SYNC button","icon":"system","areas":[{"id":"sync","label":"SYNC button","symptoms":["Does not respond when pressed","Only responds sometimes","Sticks or returns slowly","Registers repeated or unwanted presses","Feels loose or physically damaged","Other"],"targets":[],"side":null}],"help":"For a physically faulty SYNC button. Pairing failure without a button fault belongs under Wireless connection.","position":null},{"id":"rumble","label":"HD rumble","icon":"sound","areas":[{"id":"rumble","label":"HD rumble","symptoms":["No vibration","Weak or intermittent vibration","Unusual buzzing or rattling","Other"],"targets":["Left side","Right side","Both sides","Not sure"],"side":null}],"help":"","position":null},{"id":"amiibo","label":"Amiibo reader","icon":"nfc","areas":[{"id":"amiibo","label":"Amiibo reader","symptoms":["Compatible amiibo is not detected","Amiibo reading works intermittently","Other"],"targets":[],"side":null}],"help":"Check with compatible amiibo and supported software.","position":null}],"id":"switchpro"}};
function newState(model=''){return {model,issues:{},notes:'',joystick:'None',triggers:false,paddles:false,shipping:'',agreement:false,battery:'Not sure',revision:''};}
function calculate(state,models,variants,addonVariants){
 const model=models[state.model],areas=model?model.groups.flatMap(g=>g.areas).filter(a=>state.issues[a.id]?.symptoms.length):[];
 const left=areas.filter(a=>a.side==='l').length,right=areas.filter(a=>a.side==='r').length;
 const units=model?.joy?Number(left>0)+Number(right>0):Number(areas.length>0);
 const tier=Math.min(3,model?.joy?Math.max(left,right):areas.length),tierName=['','Basic','Standard','Full Tech Revival'][tier];
 const joystick=model?.joy&&units===2?'Joy-Con Pair':model?.upgrades?state.joystick:'None';
 const extra=model?.upgrades?[state.triggers?'Mouse-Click Triggers':'',state.paddles?'Four Back Paddles':''].filter(Boolean).join(' + ')||'None':'None';
 const match=(tierName,j='None',e='None')=>variants.find(v=>v.options?.join(' / ')===`${tierName} / ${j} / ${e}`||v.title===`${tierName} / ${j} / ${e}`);
 const variant=tier?match(tierName,joystick,extra):null;
 const base=tier?match(tierName,model?.joy&&units===2?'Joy-Con Pair':'None'):null;
 const kit=addonVariants.find(v=>v.title==='Mail-In Kit');
 const incomplete=areas.filter(a=>(state.issues[a.id].symptoms.includes('Other')&&!state.issues[a.id].other?.trim())||(a.targets.length&&state.issues[a.id].symptoms.some(s=>s!=='Other')&&!state.issues[a.id].targets?.length));
 const variantReady=!!variant&&variant.available!==false;
 const kitReady=state.shipping!=='kit'||!!kit&&kit.available!==false;
 const total=variant?Number(variant.price)+(state.shipping==='kit'&&kit?Number(kit.price):0):null;
 return {model,areas,left,right,units,tier,tierName,variant,base,kit,incomplete,total,variantReady,kitReady,ready:!!model&&areas.length>0&&!incomplete.length&&variantReady&&kitReady&&!!state.shipping&&state.agreement,match};
}
function configurationProperties(state,c){
 const result={'Repair Tier':c.tierName,'Controller Type':c.model.name,'Repair Areas':String(c.areas.length),'Problem Described':c.areas.map(a=>a.label).join('; '),'Bench Fee Agreement':'Accepted'};
 if(c.model.joy){result['Joy-Con Quantity']=c.units===2?'Pair of Joy-Cons':'Single Joy-Con';result['Joy-Cons to send']=c.units===2?'Both':c.left?'Left only':'Right only';result['Left repair areas']=String(c.left);result['Right repair areas']=String(c.right);}
 for(const a of c.areas){const i=state.issues[a.id];result[a.label]=(i.targets.length?i.targets.join(', ')+': ':'')+i.symptoms.filter(s=>s!=='Other').join('; ')+(i.symptoms.includes('Other')?'; Other: '+i.other.trim():'');}
 if(state.notes.trim())result['Additional details']=state.notes.trim();
 if(c.model.upgrades){result['Joystick']=state.joystick==='None'?'No, Keep My Analogs':state.joystick+' Upgrade';result['Your Upgrades']=[state.triggers?'Mouse-Click Triggers':'',state.paddles?'4 Back Paddles':''].filter(Boolean).join(', ');}
 if(c.model.platform==='xbox'&&c.areas.some(a=>['battery','usb'].includes(a.id)))result['Battery type']=state.battery;
 if(state.revision.trim())result['Controller model number']=state.revision.trim();
 return result;
}

function simpleIcon(name){
 const paths={battery:'M3 7h16v10H3zM21 10v4M7 10v4',wifi:'M2 8q10-10 20 0M6 12q6-6 12 0M10 16q2-2 4 0M12 20h.01',sound:'M3 9h5l5-5v16l-5-5H3zM17 8q6 4 0 8',motion:'M7 4h10v16H7zM2 8V3h3M22 16v5h-3',light:'M12 1v3M12 20v3M1 12h3M20 12h3M5 5l2 2M17 17l2 2M5 19l2-2M17 7l2-2',search:'M15 15l7 7',nfc:'M4 5v14M8 3v18M12 7v10M16 3v18M20 5v14',camera:'M2 6h20v14H2z',mouse:'M12 3v7M7 10h10M7 3q5-3 10 0v16q-5 4-10 0z',system:'M5 5h14v14H5zM9 9h6v6H9z',usb:'M4 8h16v8H4zM8 11h8'};
 return `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${paths[name]||paths.search}"/>${name==='light'?'<circle cx="12" cy="12" r="4"/>':name==='search'?'<circle cx="9" cy="9" r="6"/>':name==='camera'?'<circle cx="12" cy="13" r="4"/>':''}</svg>`;
}
function controllerArt(m,artwork=ARTWORK){
 const art=artwork[m.id], [vx,vy,vw,vh]=art.viewBox;
 const box=m.joy?{x:300,y:45,w:360,h:380}:{x:230,y:60,w:500,h:365};
 const scale=Math.min(box.w/vw,box.h/vh);
 const x=box.x+(box.w-vw*scale)/2,y=box.y+(box.h-vh*scale)/2;
 const point=([ax,ay])=>[x+(ax-vx)*scale,y+(ay-vy)*scale];
 const lines=m.groups.filter(g=>g.position).map(g=>{
  const [ax,ay]=point(art.anchors[g.id]),[side,p]=g.position;
  const start=side==='left'?230:side==='right'?730:480;
  const lineY=p*4.8+19,bend=side==='left'?253:707;
  const route=side==='top'?'M480 44V'+ay:'M'+start+' '+lineY+'H'+bend+'L'+ax+' '+ay;
  return '<path data-line="'+g.id+'" d="'+route+'"/><circle data-line="'+g.id+'" cx="'+ax+'" cy="'+ay+'" r="4"/>';
 }).join('');
 return '<svg class="trvr-art" data-approved-model="'+m.id+'" data-artwork-source="'+art.file+'" viewBox="0 0 960 480" aria-hidden="true"><g class="trvr-approved-drawing" transform="translate('+x+' '+y+') scale('+scale+') translate('+(-vx)+' '+(-vy)+')">'+art.body+'</g><g class="trvr-connectors">'+lines+'</g></svg>';
}

function initVisualRepair(root){
 if(root.dataset.ready)return;
 const config=JSON.parse(root.querySelector('[data-config]').textContent);
 config.variants||=[];config.addonVariants||=[];
 for(const key of Object.keys(config.text))config.text[key]=config.text[key].replace(/&(amp|lt|gt|quot|#39|#x27);/g,(_,entity)=>({amp:'&',lt:'<',gt:'>',quot:'"','#39':"'",'#x27':"'"}[entity]));
 const $=s=>root.querySelector(s),$$=s=>[...root.querySelectorAll(s)];
 const t=(s,v={})=>Object.entries(v).reduce((out,[k,value])=>out.replaceAll('{'+k+'}',value),config.text[s]||s);
 const esc=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
 const E=s=>esc(t(s));
 const money=n=>new Intl.NumberFormat(config.locale,{style:'currency',currency:config.currency}).format(Number(n)/100);
 const uid=name=>'trvr-'+config.sectionId+'-'+name;
 let state=newState(),active=null,busy=false,lastAdded='',lastTrigger=null;
 const model=()=>MODELS[state.model];
 const groups=()=>model()?.groups||[];
 const issue=id=>state.issues[id]??(state.issues[id]={symptoms:[],targets:[],other:''});
 const calc=()=>calculate(state,MODELS,config.variants,config.addonVariants);
 const groupCount=g=>g.areas.filter(a=>state.issues[a.id]?.symptoms.length).length;
 const send=c=>c.model?.joy?(c.units===2?t('Send BOTH Joy-Cons'):c.units?t(c.left?'Send your LEFT Joy-Con only':'Send your RIGHT Joy-Con only'):t('No Joy-Cons selected')):'';
 const phone=matchMedia('(max-width:850px)');
 function fitMenu(){const diagram=$('[data-diagram]');if(!diagram)return;diagram.style.setProperty('--menu-space','0px');const panel=$('[data-panel="'+active+'"]');if(panel&&!phone.matches&&panel.closest('[data-diagram]'))diagram.style.setProperty('--menu-space',Math.max(0,panel.getBoundingClientRect().bottom-diagram.getBoundingClientRect().bottom+20)+'px');}
 function sizeArt(){$('.trvr-art')?.setAttribute('viewBox',phone.matches?(model()?.joy?'285 25 390 420':'205 25 550 420'):'0 0 960 480');fitMenu();}
 function draw(){
  const m=model();
  for(const select of $$('[data-platform]')){select.value=m?.platform===select.dataset.platform?state.model:'';select.closest('.trvr-platform').classList.toggle('is-selected',m?.platform===select.dataset.platform);}
  $('[data-empty]').hidden=!!m;$('[data-diagnosis]').hidden=!m;$('[data-form]').hidden=!m;
  if(!m){refresh();return;}
  $('[data-model-name]').textContent=t(m.name);$('[data-joy-warning]').hidden=!m.joy;
  $('[data-diagram]').classList.toggle('is-joy',!!m.joy);
  const disclosure=g=>`<div class="trvr-disclosure ${g.position?g.position[0]:'system'}" data-disclosure="${g.id}" style="--row:${g.row||5};--position:${g.position?.[1]||0}%"><button type="button" data-group="${g.id}" aria-controls="${uid('panel-'+g.id)}" class="${g.position?'trvr-callout':'trvr-system'}">${g.position?'':simpleIcon(g.icon)}<span>${E(g.label)}</span><b aria-hidden="true">+</b></button><div class="trvr-panel" data-panel="${g.id}" id="${uid('panel-'+g.id)}" tabindex="-1" role="region" hidden></div></div>`;
  $('[data-diagram]').innerHTML=`<div class="trvr-art-wrap">${controllerArt(m)}${m.joy?'<div class="trvr-unit left" data-unit-label="l"></div><div class="trvr-unit right" data-unit-label="r"></div>':''}</div><div class="trvr-callouts">${groups().filter(g=>g.position).sort((a,b)=>a.position[1]-b.position[1]).map(disclosure).join('')}</div>`;
  $('[data-systems]').innerHTML=groups().filter(g=>!g.position).map(disclosure).join('');
  $('[data-notes]').value=state.notes;$('[data-agreement]').checked=state.agreement;
  for(const radio of $$('[name="shipping-'+config.sectionId+'"]'))radio.checked=radio.value===state.shipping;
  $('[data-upgrade-section]').hidden=!m.upgrades;
  $('[data-mail-step]').textContent=m.upgrades?'05':'04';$('[data-bench-step]').textContent=m.upgrades?'06':'05';
  renderUpgrades();sizeArt();renderPanel();refresh();
 }
 function renderUpgrades(){
  const c=calc(),tier=c.tierName||'Basic',base=c.match(tier),delta=(j,e='None')=>{const v=c.match(tier,j,e);return v&&base?money(v.price-base.price):t('Unavailable');};
  $('[data-upgrades]').innerHTML=`<fieldset class="trvr-upgrade-options"><legend>${E('Joystick upgrade')}</legend>${[['None','Keep standard sticks'],['Hall Effect','Hall Effect'],['TMR','TMR']].map(([v,label])=>`<label class="trvr-choice"><input type="radio" name="joystick-${config.sectionId}" data-joystick value="${v}" ${state.joystick===v?'checked':''}><span>${E(label)}<small>${v==='None'?E('No upgrade'):'+'+delta(v)}</small></span></label>`).join('')}</fieldset>${[['triggers','Mouse-Click Triggers'],['paddles','Four Back Paddles']].map(([v,label])=>`<label class="trvr-choice"><input type="checkbox" data-upgrade="${v}" ${state[v]?'checked':''}><span>${E(label)}</span><strong>+${delta('None',label)}</strong></label>`).join('')}`;
 }
 function renderPanel(focus){
  const g=groups().find(g=>g.id===active);
  for(const p of $$('[data-panel]')){p.hidden=p.dataset.panel!==active;if(p.hidden)p.innerHTML='';}
  for(const d of $$('[data-disclosure]'))d.classList.toggle('is-expanded',d.dataset.disclosure===active);
  if(!g){fitMenu();return;}
  const panel=$('[data-panel="'+g.id+'"]');
  panel.setAttribute('aria-labelledby',uid('panel-title-'+g.id));
  panel.innerHTML=`<div class="trvr-panel-head"><div><h3 id="${uid('panel-title-'+g.id)}">${E(g.label)}</h3><p>${E(g.help||'Select all that apply. Multiple symptoms in one repair area count once.')}</p></div><button type="button" data-close aria-label="${E('Close symptom menu')}">×</button></div><button class="trvr-clear" type="button" data-clear="${g.id}">${E('Clear this area')}</button>${g.areas.map(a=>{
   const i=issue(a.id),other=i.symptoms.includes('Other'),missing=i.symptoms.some(s=>s!=='Other')&&a.targets.length&&!i.targets.length;
   return `<fieldset class="trvr-symptom-area"><legend>${E(a.label)}</legend>${a.targets.length?`<p>${E('Which controls or features are affected?')}</p><div class="trvr-targets">${a.targets.map((v,n)=>`<label><input type="checkbox" id="${uid('target-'+a.id+'-'+n)}" data-target="${a.id}" value="${esc(v)}" ${i.targets.includes(v)?'checked':''}>${E(v)}</label>`).join('')}</div>${missing?`<p class="trvr-error">${E('Select the affected control or feature above.')}</p>`:''}`:''}<div class="trvr-symptoms">${a.symptoms.map((v,n)=>`<label class="trvr-symptom"><input type="checkbox" id="${uid('issue-'+a.id+'-'+n)}" data-area="${a.id}" value="${esc(v)}" ${i.symptoms.includes(v)?'checked':''}><span>${E(v)}</span></label>`).join('')}</div>${other?`<label class="trvr-other" for="${uid('other-'+a.id)}">${E('Describe the other problem')} — ${E(a.label)}</label><textarea id="${uid('other-'+a.id)}" data-other="${a.id}" rows="2" maxlength="200" required aria-invalid="${!i.other.trim()}" aria-describedby="${uid('error-'+a.id)}">${esc(i.other)}</textarea><p class="trvr-error" id="${uid('error-'+a.id)}">${i.other.trim()?E('A short description is included.'):E('Add a short description to include this problem.')}</p>`:''}</fieldset>`;
  }).join('')}`+(model().platform==='xbox'&&['battery','usb'].includes(g.id)?`<label class="trvr-field-label" for="${uid('battery')}">${E('Battery type (optional)')}</label><select id="${uid('battery')}" data-battery>${['Not sure','AA batteries','Rechargeable battery pack'].map(v=>`<option ${state.battery===v?'selected':''}>${E(v)}</option>`).join('')}</select>`:'');
  fitMenu();
  if(focus)root.querySelector('[id="'+focus+'"]')?.focus({preventScroll:true});
 }
 function openGroup(id){active=id;lastTrigger=$('[data-group="'+id+'"]');renderPanel();refresh();const p=$('[data-panel="'+id+'"]');p.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'nearest'});p.focus({preventScroll:true});}
 function refresh(announce=false){
  const c=calc();
  for(const b of $$('[data-group]')){const g=groups().find(g=>g.id===b.dataset.group),selected=groupCount(g)>0;b.classList.toggle('is-selected',selected);b.classList.toggle('is-open',active===g.id);b.setAttribute('aria-expanded',String(active===g.id));b.querySelector('b').textContent=selected?'✓':active===g.id?'−':'+';}
  for(const part of $$('[data-art]')){const ids=part.dataset.art.split(' ');part.classList.toggle('is-selected',ids.some(id=>state.issues[id]?.symptoms.length));}
  for(const line of $$('[data-line]')){const g=groups().find(g=>g.id===line.dataset.line);line.classList.toggle('is-selected',groupCount(g)>0);}
  for(const el of $$('[data-unit]'))el.classList.toggle('is-selected',el.dataset.unit==='l'?c.left>0:c.right>0);
  for(const el of $$('[data-unit-label]')){const n=el.dataset.unitLabel==='l'?c.left:c.right;el.innerHTML=`<strong>${E(el.dataset.unitLabel==='l'?'LEFT JOY-CON':'RIGHT JOY-CON')}</strong><span>${n?E('Included')+' · '+n:E('Not included')}</span>`;el.classList.toggle('is-selected',n>0);}
  const count=t(c.areas.length===1?'{count} repair area':'{count} repair areas',{count:c.areas.length});
  const list=c.areas.map(a=>`<li><button type="button" data-edit="${groups().find(g=>g.areas.includes(a)).id}">${E(a.label)}</button><small>${issue(a.id).symptoms.map(E).join(' · ')}</small></li>`).join('');
  const selectedUpgrades=c.model?.upgrades?[state.joystick!=='None'?state.joystick:'',state.triggers?'Mouse-Click Triggers':'',state.paddles?'Four Back Paddles':''].filter(Boolean):[];
  $('[data-summary]').innerHTML=`<p class="trvr-model-summary">${c.model?E(c.model.name):E('Choose your controller')}</p>${c.model?.joy?`<p class="trvr-send">${esc(send(c))}</p>${c.units===2?`<p>${E('Pair discount applied. The higher side tier is used.')}</p>`:''}<p>${esc(t('Left: {left} areas · Right: {right} areas',{left:c.left,right:c.right}))}</p>`:''}${list?`<ul class="trvr-issue-list">${list}</ul>`:`<p>${E('Your selected repair areas will appear here.')}</p>`}<dl><div><dt>${c.tier?E(c.tierName)+(c.units===2?' · '+E('pair'):''):E('Repair service')}</dt><dd>${c.base?money(c.base.price):E('Pending')}</dd></div>${selectedUpgrades.length?`<div><dt>${E('Upgrades')}<small>${selectedUpgrades.map(E).join(' · ')}</small></dt><dd>${c.variant&&c.base?money(c.variant.price-c.base.price):E('Pending')}</dd></div>`:''}<div><dt>${state.shipping==='kit'?E('Mail-In Kit'):state.shipping==='self'?E('Self Ship'):E('Mail-in method')}</dt><dd>${state.shipping==='kit'?(c.kit?money(c.kit.price):E('Unavailable')):state.shipping==='self'?E('No added fee'):E('Pending')}</dd></div></dl><div class="trvr-total"><span>${E('Estimated total')}</span><strong>${c.total!==null?money(c.total):'—'}</strong></div>`;
  const missing=[];if(!c.model)missing.push(t('choose a controller'));else if(!c.areas.length)missing.push(t('select at least one problem'));if(c.incomplete.length)missing.push(t('complete the highlighted problem details'));if(c.tier&&!c.variantReady)missing.push(t('the selected repair combination is unavailable'));if(!c.kitReady)missing.push(t('the Mail-In Kit is unavailable'));if(!state.shipping)missing.push(t('choose a mail-in method'));if(!state.agreement)missing.push(t('accept the bench-fee terms'));
  const same=lastAdded===JSON.stringify(state);
  $('[data-submit]').disabled=busy||!c.ready||same;
  $('[data-submit]').textContent=busy?t('Adding repair…'):same?t('Added to cart'):t('Add repair to cart');
  $('[data-status]').textContent=same?t('Your configured repair was added to the cart.'):missing.length?t('To continue: {details}',{details:missing.join('; ')+'.'}):t('Your repair is ready to add to cart.');
  $('[data-cart-link]').hidden=!same;
  $('[data-notes-count]').textContent=t('{count} / 1,200 characters',{count:state.notes.length});
  if(announce)$('[data-announcement]').textContent=count+'. '+(c.tier?t(c.tierName)+'. ':'')+send(c);
 }
 root.addEventListener('click',async event=>{
  const b=event.target.closest('button');if(!b||busy)return;
  if(b.dataset.group){lastTrigger=b;if(active===b.dataset.group){active=null;renderPanel();refresh();}else openGroup(b.dataset.group);}
  if(b.dataset.edit)openGroup(b.dataset.edit);
  if(b.hasAttribute('data-close')){active=null;renderPanel();refresh();lastTrigger?.focus({preventScroll:true});}
  if(b.dataset.clear){groups().find(g=>g.id===b.dataset.clear).areas.forEach(a=>delete state.issues[a.id]);renderPanel();refresh(true);}
  if(b.hasAttribute('data-reset')){state.issues={};renderPanel();refresh(true);}
  if(b.hasAttribute('data-submit')){
   const c=calc();if(!c.ready||lastAdded===JSON.stringify(state))return;
   busy=true;refresh();const controls=$$('input,select,textarea,button').map(el=>[el,el.disabled]);controls.forEach(([el])=>el.disabled=true);b.setAttribute('aria-busy','true');
   try{
    if(!window.TechReviveNativeCart?.addConfiguration)throw new Error(t('The cart service did not load. Refresh the page and try again.'));
    await window.TechReviveNativeCart.addConfiguration({root,productId:config.productId,parentVariantId:c.variant.id,parentProperties:configurationProperties(state,c),addonVariants:config.addonVariants,serviceLabel:'Repair Service - '+c.tierName,addOns:state.shipping==='kit'?[{variantTitle:'Mail-In Kit',label:'Mail-In Kit'}]:[]});
    lastAdded=JSON.stringify(state);busy=false;controls.forEach(([el,disabled])=>el.disabled=disabled);refresh();$('[data-announcement]').textContent=t('Your configured repair was added to the cart.');
   }catch(error){busy=false;controls.forEach(([el,disabled])=>el.disabled=disabled);refresh();$('[data-status]').textContent=error.message||t('The repair could not be added. Please try again.');}
   finally{b.removeAttribute('aria-busy');}
  }
 });
 root.addEventListener('change',event=>{
  if(busy)return;const el=event.target;
  if(el.dataset.platform!==undefined){const next=el.value;if(next===state.model)return;state=newState(next);active=null;draw();$('[data-announcement]').textContent=next?t('Controller selected. Choose its repair areas.'):t('Choose your controller');return;}
  if(el.dataset.area){const i=issue(el.dataset.area);i.symptoms=el.checked?[...i.symptoms,el.value]:i.symptoms.filter(s=>s!==el.value);if(el.value==='Other'&&!el.checked)i.other='';renderPanel(el.id);renderUpgrades();}
  if(el.dataset.target){const i=issue(el.dataset.target);i.targets=el.checked?[...i.targets,el.value]:i.targets.filter(s=>s!==el.value);renderPanel(el.id);}
  if(el.hasAttribute('data-joystick'))state.joystick=el.value;
  if(el.dataset.upgrade)state[el.dataset.upgrade]=el.checked;
  if(el.hasAttribute('data-shipping'))state.shipping=el.value;
  if(el.hasAttribute('data-agreement'))state.agreement=el.checked;
  if(el.hasAttribute('data-battery'))state.battery=el.value;
  refresh(true);
 });
 root.addEventListener('input',event=>{
  if(busy)return;const el=event.target;
  if(el.dataset.other){issue(el.dataset.other).other=el.value;el.setAttribute('aria-invalid',String(!el.value.trim()));root.querySelector('[id="'+uid('error-'+el.dataset.other)+'"]').textContent=el.value.trim()?t('A short description is included.'):t('Add a short description to include this problem.');}
  if(el.hasAttribute('data-notes'))state.notes=el.value;
  if(el.hasAttribute('data-revision'))state.revision=el.value;
  refresh();
 });
 root.addEventListener('keydown',event=>{if(event.key==='Escape'&&active){active=null;renderPanel();refresh();lastTrigger?.focus({preventScroll:true});}});
 phone.addEventListener('change',sizeArt);
 const diagramObserver=new ResizeObserver(fitMenu);diagramObserver.observe($('[data-diagram]'));
 root._visualRepairCleanup=()=>{phone.removeEventListener('change',sizeArt);diagramObserver.disconnect();};
 root.dataset.ready='true';draw();
 const oldTier=new URL(location.href).searchParams;
 if(oldTier.has('tier')||oldTier.has('repair_tier'))$('[data-legacy-note]').hidden=false;
}
function initAllVisual(scope=document){if(scope.matches?.('[data-tr-visual-repair]'))initVisualRepair(scope);scope.querySelectorAll?.('[data-tr-visual-repair]').forEach(initVisualRepair);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initAllVisual());else initAllVisual();
document.addEventListener('shopify:section:load',event=>initAllVisual(event.target));
document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-tr-visual-repair]').forEach(root=>root._visualRepairCleanup?.()));

})();

  } catch(e) { console.error(e); }
})();
})();
